export const TrendsMock = {
  startDate: '2024-06-25T15:52:00.000Z',
  endDate: '2024-06-26T15:50:59.000Z',
  resolutionMin: 1,
  data: {
    pressureBar: [
      ['2024-06-25T15:52:00Z', 6.263319969177246],
      ['2024-06-25T15:53:00Z', 6.255435943603516],
      ['2024-06-25T15:54:00Z', 6.250095367431641],
      ['2024-06-25T15:55:00Z', 6.243610382080078],
      ['2024-06-25T15:56:00Z', 6.269741415977478],
      ['2024-06-25T15:57:00Z', 6.250095367431641],
      ['2024-06-25T15:58:00Z', 6.219768047332764],
      ['2024-06-25T15:59:00Z', 6.236743688583374],
      ['2024-06-25T16:00:00Z', 6.287861466407776],
      ['2024-06-25T16:01:00Z', 6.305790901184082],
      ['2024-06-25T16:02:00Z', 6.32848858833313],
      ['2024-06-25T16:03:00Z', 6.35614554087321],
      ['2024-06-25T16:04:00Z', 6.376363754272461],
      ['2024-06-25T16:05:00Z', 6.384374618530273],
      ['2024-06-25T16:06:00Z', 6.415274262428284],
      ['2024-06-25T16:07:00Z', 6.445601582527161],
      ['2024-06-25T16:08:00Z', 6.4318684339523315],
      ['2024-06-25T16:09:00Z', 6.353856682777405],
      ['2024-06-25T16:10:00Z', 6.283665180206299],
      ['2024-06-25T16:11:00Z', 6.227016091346741],
      ['2024-06-25T16:12:00Z', 6.20698869228363],
      ['2024-06-25T16:13:00Z', 6.208896160125732],
      ['2024-06-25T16:14:00Z', 6.231975317001343],
      ['2024-06-25T16:15:00Z', 6.298161268234253],
      ['2024-06-25T16:16:00Z', 6.30083167552948],
      ['2024-06-25T16:17:00Z', 6.301467259724935],
      ['2024-06-25T16:18:00Z', 6.308270454406738],
      ['2024-06-25T16:19:00Z', 6.3274078369140625],
      ['2024-06-25T16:20:00Z', 6.315709273020427],
      ['2024-06-25T16:21:00Z', 6.26535439491272],
      ['2024-06-25T16:22:00Z', 6.212202231089274],
      ['2024-06-25T16:23:00Z', 6.217288374900818],
      ['2024-06-25T16:24:00Z', 6.232738137245178],
      ['2024-06-25T16:25:00Z', 6.22377347946167],
      ['2024-06-25T16:26:00Z', 6.266689658164978],
      ['2024-06-25T16:27:00Z', 6.270186583201091],
      ['2024-06-25T16:28:00Z', 6.269169092178345],
      ['2024-06-25T16:29:00Z', 6.293202042579651],
      ['2024-06-25T16:30:00Z', 6.277561545372009],
      ['2024-06-25T16:31:00Z', 6.248569488525391],
      ['2024-06-25T16:32:00Z', 6.235790014266968],
      ['2024-06-25T16:33:00Z', 6.230767250061035],
      ['2024-06-25T16:34:00Z', 6.220340251922607],
      ['2024-06-25T16:35:00Z', 6.227206826210022],
      ['2024-06-25T16:36:00Z', 6.238396803538005],
      ['2024-06-25T16:37:00Z', 6.242465972900391],
      ['2024-06-25T16:38:00Z', 6.21461808681488],
      ['2024-06-25T16:39:00Z', 6.197197437286377],
      ['2024-06-25T16:40:00Z', 6.2252994775772095],
      ['2024-06-25T16:41:00Z', 6.244945406913757],
      ['2024-06-25T16:42:00Z', 6.254100799560547],
      ['2024-06-25T16:43:00Z', 6.278896689414978],
      ['2024-06-25T16:44:00Z', 6.257979075113933],
      ['2024-06-25T16:45:00Z', 6.24532687664032],
      ['2024-06-25T16:46:00Z', 6.212202231089274],
      ['2024-06-25T16:47:00Z', 6.2147453625996905],
      ['2024-06-25T16:48:00Z', 6.223392009735107],
      ['2024-06-25T16:49:00Z', 6.266307950019836],
      ['2024-06-25T16:50:00Z', 6.311322212219238],
      ['2024-06-25T16:51:00Z', 6.330205321311951],
      ['2024-06-25T16:52:00Z', 6.3302052815755205],
      ['2024-06-25T16:53:00Z', 6.342412352561951],
      ['2024-06-25T16:54:00Z', 6.392576456069946],
      ['2024-06-25T16:55:00Z', 6.419851899147034],
      ['2024-06-25T16:56:00Z', 6.428435325622559],
      ['2024-06-25T16:57:00Z', 6.4637216329574585],
      ['2024-06-25T16:58:00Z', 6.528000354766846],
      ['2024-06-25T16:59:00Z', 6.614404678344727],
      ['2024-06-25T17:00:00Z', 6.716830730438232],
      ['2024-06-25T17:01:00Z', 6.816395878791809],
      ['2024-06-25T17:02:00Z', 6.469443678855896],
      ['2024-06-25T17:03:00Z', 6.177106539408366],
      ['2024-06-25T17:04:00Z', 6.332875609397888],
      ['2024-06-25T17:05:00Z', 6.474975228309631],
      ['2024-06-25T17:06:00Z', 6.5991456508636475],
      ['2024-06-25T17:07:00Z', 6.704814195632935],
      ['2024-06-25T17:08:00Z', 6.675822138786316],
      ['2024-06-25T17:09:00Z', 6.371404528617859],
      ['2024-06-25T17:10:00Z', 6.476882696151733],
      ['2024-06-25T17:11:00Z', 6.6052491664886475],
      ['2024-06-25T17:12:00Z', 6.721853415171306],
      ['2024-06-25T17:13:00Z', 6.813534736633301],
      ['2024-06-25T17:14:00Z', 6.463721752166748],
      ['2024-06-25T17:15:00Z', 6.126115798950195],
      ['2024-06-25T17:16:00Z', 6.004615902900696],
      ['2024-06-25T17:17:00Z', 6.171320676803589],
      ['2024-06-25T17:18:00Z', 6.385328412055969],
      ['2024-06-25T17:19:00Z', 6.418707609176636],
      ['2024-06-25T17:20:00Z', 6.473830819129944],
      ['2024-06-25T17:21:00Z', 6.5104522705078125],
      ['2024-06-25T17:22:00Z', 6.500724792480469],
      ['2024-06-25T17:23:00Z', 6.520370721817017],
      ['2024-06-25T17:24:00Z', 6.5354390144348145],
      ['2024-06-25T17:25:00Z', 6.548154989878337],
      ['2024-06-25T17:26:00Z', 6.575303435325623],
      ['2024-06-25T17:27:00Z', 6.567864537239075],
      ['2024-06-25T17:28:00Z', 6.54097044467926],
      ['2024-06-25T17:29:00Z', 6.500724792480469],
      ['2024-06-25T17:30:00Z', 6.452277501424153],
      ['2024-06-25T17:31:00Z', 6.436636924743652],
      ['2024-06-25T17:32:00Z', 6.445601582527161],
      ['2024-06-25T17:33:00Z', 6.439497947692871],
      ['2024-06-25T17:34:00Z', 6.417563080787659],
      ['2024-06-25T17:35:00Z', 6.388443946838379],
      ['2024-06-25T17:36:00Z', 6.379034042358398],
      ['2024-06-25T17:37:00Z', 6.34088659286499],
      ['2024-06-25T17:38:00Z', 6.296635389328003],
      ['2024-06-25T17:39:00Z', 6.282520771026611],
      ['2024-06-25T17:40:00Z', 6.274509906768799],
      ['2024-06-25T17:41:00Z', 6.251621246337891],
      ['2024-06-25T17:42:00Z', 6.250095367431641],
      ['2024-06-25T17:43:00Z', 6.253910064697266],
      ['2024-06-25T17:44:00Z', 6.251621246337891],
      ['2024-06-25T17:45:00Z', 6.259632110595703],
      ['2024-06-25T17:46:00Z', 6.2378880977630615],
      ['2024-06-25T17:47:00Z', 6.241893649101257],
      ['2024-06-25T17:48:00Z', 6.303502082824707],
      ['2024-06-25T17:49:00Z', 6.363012194633484],
      ['2024-06-25T17:50:00Z', 6.360723257064819],
      ['2024-06-25T17:51:00Z', 6.317998091379802],
      ['2024-06-25T17:52:00Z', 6.295872211456299],
      ['2024-06-25T17:53:00Z', 6.3012131452560425],
      ['2024-06-25T17:54:00Z', 6.297970533370972],
      ['2024-06-25T17:55:00Z', 6.270695209503174],
      ['2024-06-25T17:56:00Z', 6.244182586669922],
      ['2024-06-25T17:57:00Z', 6.246280670166016],
      ['2024-06-25T17:58:00Z', 6.251621246337891],
      ['2024-06-25T17:59:00Z', 6.292566299438477],
      ['2024-06-25T18:00:00Z', 6.304773648579915],
      ['2024-06-25T18:01:00Z', 6.309605598449707],
      ['2024-06-25T18:02:00Z', 6.289005756378174],
      ['2024-06-25T18:03:00Z', 6.291676163673401],
      ['2024-06-25T18:04:00Z', 6.286208311716716],
      ['2024-06-25T18:05:00Z', 6.285445372263591],
      ['2024-06-25T18:06:00Z', 6.266117334365845],
      ['2024-06-25T18:07:00Z', 6.242656588554382],
      ['2024-06-25T18:08:00Z', 6.22224760055542],
      ['2024-06-25T18:09:00Z', 6.233310341835022],
      ['2024-06-25T18:10:00Z', 6.2348363399505615],
      ['2024-06-25T18:11:00Z', 6.240431308746338],
      ['2024-06-25T18:12:00Z', 6.256707668304443],
      ['2024-06-25T18:13:00Z', 6.257724761962891],
      ['2024-06-25T18:14:00Z', 6.259250640869141],
      ['2024-06-25T18:15:00Z', 6.275272846221924],
      ['2024-06-25T18:16:00Z', 6.277370929718018],
      ['2024-06-25T18:17:00Z', 6.281757831573486],
      ['2024-06-25T18:18:00Z', 6.30388343334198],
      ['2024-06-25T18:19:00Z', 6.289577960968018],
      ['2024-06-25T18:20:00Z', 6.257152557373047],
      ['2024-06-25T18:21:00Z', 6.241893649101257],
      ['2024-06-25T18:22:00Z', 6.223964214324951],
      ['2024-06-25T18:23:00Z', 6.205081462860107],
      ['2024-06-25T18:24:00Z', 6.218305746714274],
      ['2024-06-25T18:25:00Z', 6.230258464813232],
      ['2024-06-25T18:26:00Z', 6.241321325302124],
      ['2024-06-25T18:27:00Z', 6.286144733428955],
      ['2024-06-25T18:28:00Z', 6.293392658233643],
      ['2024-06-25T18:29:00Z', 6.29625391960144],
      ['2024-06-25T18:30:00Z', 6.291548887888591],
      ['2024-06-25T18:31:00Z', 6.304646372795105],
      ['2024-06-25T18:32:00Z', 6.361104726791382],
      ['2024-06-25T18:33:00Z', 6.364728808403015],
      ['2024-06-25T18:34:00Z', 6.395628213882446],
      ['2024-06-25T18:35:00Z', 6.4686808586120605],
      ['2024-06-25T18:36:00Z', 6.528381705284119],
      ['2024-06-25T18:37:00Z', 6.581597566604614],
      ['2024-06-25T18:38:00Z', 6.636339426040649],
      ['2024-06-25T18:39:00Z', 6.706721544265747],
      ['2024-06-25T18:40:00Z', 6.731517553329468],
      ['2024-06-25T18:41:00Z', 6.389333963394165],
      ['2024-06-25T18:42:00Z', 6.3805601596832275],
      ['2024-06-25T18:43:00Z', 6.4990081787109375],
      ['2024-06-25T18:44:00Z', 6.60563063621521],
      ['2024-06-25T18:45:00Z', 6.714351058006287],
      ['2024-06-25T18:46:00Z', 6.802853465080261],
      ['2024-06-25T18:47:00Z', 6.4223315715789795],
      ['2024-06-25T18:48:00Z', 6.173037171363831],
      ['2024-06-25T18:49:00Z', 6.3410773277282715],
      ['2024-06-25T18:50:00Z', 6.463530898094177],
      ['2024-06-25T18:51:00Z', 6.570344090461731],
      ['2024-06-25T18:52:00Z', 6.660372376441956],
      ['2024-06-25T18:53:00Z', 6.76565957069397],
      ['2024-06-25T18:54:00Z', 6.662661194801331],
      ['2024-06-25T18:55:00Z', 6.249141693115234],
      ['2024-06-25T18:56:00Z', 6.1964980363845825],
      ['2024-06-25T18:57:00Z', 6.315709352493286],
      ['2024-06-25T18:58:00Z', 6.463149309158325],
      ['2024-06-25T18:59:00Z', 6.5856029987335205],
      ['2024-06-25T19:00:00Z', 6.705386400222778],
      ['2024-06-25T19:01:00Z', 6.680209040641785],
      ['2024-06-25T19:02:00Z', 6.385137677192688],
      ['2024-06-25T19:03:00Z', 6.564621925354004],
      ['2024-06-25T19:04:00Z', 6.761526902516683],
      ['2024-06-25T19:05:00Z', 6.860456347465515],
      ['2024-06-25T19:06:00Z', 6.490806460380554],
      ['2024-06-25T19:07:00Z', 6.199549913406372],
      ['2024-06-25T19:08:00Z', 6.4295796155929565],
      ['2024-06-25T19:09:00Z', 6.651598334312439],
      ['2024-06-25T19:10:00Z', 6.841573238372803],
      ['2024-06-25T19:11:00Z', 6.729419231414795],
      ['2024-06-25T19:12:00Z', 6.289387345314026],
      ['2024-06-25T19:13:00Z', 6.413939118385315],
      ['2024-06-25T19:14:00Z', 6.6796369552612305],
      ['2024-06-25T19:15:00Z', 6.8022812604904175],
      ['2024-06-25T19:16:00Z', 6.546692609786987],
      ['2024-06-25T19:17:00Z', 6.438544154167175],
      ['2024-06-25T19:18:00Z', 6.753452301025391],
      ['2024-06-25T19:19:00Z', 6.607728719711304],
      ['2024-06-25T19:20:00Z', 6.236934542655945],
      ['2024-06-25T19:21:00Z', 6.29606306552887],
      ['2024-06-25T19:22:00Z', 6.318506558736165],
      ['2024-06-25T19:23:00Z', 6.315899848937988],
      ['2024-06-25T19:24:00Z', 6.332303285598755],
      ['2024-06-25T19:25:00Z', 6.352076371510823],
      ['2024-06-25T19:26:00Z', 6.34393835067749],
      ['2024-06-25T19:27:00Z', 6.333638668060303],
      ['2024-06-25T19:28:00Z', 6.338597774505615],
      ['2024-06-25T19:29:00Z', 6.35004186630249],
      ['2024-06-25T19:30:00Z', 6.360723257064819],
      ['2024-06-25T19:31:00Z', 6.370896021525065],
      ['2024-06-25T19:32:00Z', 6.369306564331055],
      ['2024-06-25T19:33:00Z', 6.366445541381836],
      ['2024-06-25T19:34:00Z', 6.369497299194336],
      ['2024-06-25T19:35:00Z', 6.368352890014648],
      ['2024-06-25T19:36:00Z', 6.370260238647461],
      ['2024-06-25T19:37:00Z', 6.382085800170898],
      ['2024-06-25T19:38:00Z', 6.379415512084961],
      ['2024-06-25T19:39:00Z', 6.380178451538086],
      ['2024-06-25T19:40:00Z', 6.3749650319417315],
      ['2024-06-25T19:41:00Z', 6.375219345092773],
      ['2024-06-25T19:42:00Z', 6.373693466186523],
      ['2024-06-25T19:43:00Z', 6.374837875366211],
      ['2024-06-25T19:44:00Z', 6.378271102905273],
      ['2024-06-25T19:45:00Z', 6.389206727345784],
      ['2024-06-25T19:46:00Z', 6.392957925796509],
      ['2024-06-25T19:47:00Z', 6.379796981811523],
      ['2024-06-25T19:48:00Z', 6.38234011332194],
      ['2024-06-25T19:49:00Z', 6.392958045005798],
      ['2024-06-25T19:50:00Z', 6.388380169868469],
      ['2024-06-25T19:51:00Z', 6.3871720631917315],
      ['2024-06-25T19:52:00Z', 6.388443787892659],
      ['2024-06-25T19:53:00Z', 6.39314877986908],
      ['2024-06-25T19:54:00Z', 6.3920042514801025],
      ['2024-06-25T19:55:00Z', 6.388189315795898],
      ['2024-06-25T19:56:00Z', 6.386472702026367],
      ['2024-06-25T19:57:00Z', 6.37769889831543],
      ['2024-06-25T19:58:00Z', 6.373884201049805],
      ['2024-06-25T19:59:00Z', 6.3764909108479815],
      ['2024-06-25T20:00:00Z', 6.377126693725586],
      ['2024-06-25T20:01:00Z', 6.383420944213867],
      ['2024-06-25T20:02:00Z', 6.385519027709961],
      ['2024-06-25T20:03:00Z', 6.389206727345784],
      ['2024-06-25T20:04:00Z', 6.387998700141907],
      ['2024-06-25T20:05:00Z', 6.384374618530273],
      ['2024-06-25T20:06:00Z', 6.384946823120117],
      ['2024-06-25T20:07:00Z', 6.386281967163086],
      ['2024-06-25T20:08:00Z', 6.381895065307617],
      ['2024-06-25T20:09:00Z', 6.378652572631836],
      ['2024-06-25T20:10:00Z', 6.377126693725586],
      ['2024-06-25T20:11:00Z', 6.375473658243815],
      ['2024-06-25T20:12:00Z', 6.375219345092773],
      ['2024-06-25T20:13:00Z', 6.367780685424805],
      ['2024-06-25T20:14:00Z', 6.367208480834961],
      ['2024-06-25T20:15:00Z', 6.363202929496765],
      ['2024-06-25T20:16:00Z', 6.372930526733398],
      ['2024-06-25T20:17:00Z', 6.373502731323242],
      ['2024-06-25T20:18:00Z', 6.380178451538086],
      ['2024-06-25T20:19:00Z', 6.387172222137451],
      ['2024-06-25T20:20:00Z', 6.378271102905273],
      ['2024-06-25T20:21:00Z', 6.378271102905273],
      ['2024-06-25T20:22:00Z', 6.386281967163086],
      ['2024-06-25T20:23:00Z', 6.381895065307617],
      ['2024-06-25T20:24:00Z', 6.387680848439534],
      ['2024-06-25T20:25:00Z', 6.386281967163086],
      ['2024-06-25T20:26:00Z', 6.377889633178711],
      ['2024-06-25T20:27:00Z', 6.3757279713948565],
      ['2024-06-25T20:28:00Z', 6.376999537150065],
      ['2024-06-25T20:29:00Z', 6.371976852416992],
      ['2024-06-25T20:30:00Z', 6.373311996459961],
      ['2024-06-25T20:31:00Z', 6.377317428588867],
      ['2024-06-25T20:32:00Z', 6.382848739624023],
      ['2024-06-25T20:33:00Z', 6.384374618530273],
      ['2024-06-25T20:34:00Z', 6.385900497436523],
      ['2024-06-25T20:35:00Z', 6.385900497436523],
      ['2024-06-25T20:36:00Z', 6.381704330444336],
      ['2024-06-25T20:37:00Z', 6.379796981811523],
      ['2024-06-25T20:38:00Z', 6.3795426686604815],
      ['2024-06-25T20:39:00Z', 6.382848739624023],
      ['2024-06-25T20:40:00Z', 6.373884201049805],
      ['2024-06-25T20:41:00Z', 6.3711503346761065],
      ['2024-06-25T20:42:00Z', 6.373311996459961],
      ['2024-06-25T20:43:00Z', 6.372358322143555],
      ['2024-06-25T20:44:00Z', 6.371976852416992],
      ['2024-06-25T20:45:00Z', 6.378271102905273],
      ['2024-06-25T20:46:00Z', 6.388443787892659],
      ['2024-06-25T20:47:00Z', 6.389333724975586],
      ['2024-06-25T20:48:00Z', 6.385900497436523],
      ['2024-06-25T20:49:00Z', 6.384946823120117],
      ['2024-06-25T20:50:00Z', 6.369878768920898],
      ['2024-06-25T20:51:00Z', 6.359451770782471],
      ['2024-06-25T20:52:00Z', 6.352839310963948],
      ['2024-06-25T20:53:00Z', 6.349533240000407],
      ['2024-06-25T20:54:00Z', 6.3433661460876465],
      ['2024-06-25T20:55:00Z', 6.335546016693115],
      ['2024-06-25T20:56:00Z', 6.330395936965942],
      ['2024-06-25T20:57:00Z', 6.321304003397624],
      ['2024-06-25T20:58:00Z', 6.317997932434082],
      ['2024-06-25T20:59:00Z', 6.329442262649536],
      ['2024-06-25T21:00:00Z', 6.332112789154053],
      ['2024-06-25T21:01:00Z', 6.340632279713948],
      ['2024-06-25T21:02:00Z', 6.344701290130615],
      ['2024-06-25T21:03:00Z', 6.3433661460876465],
      ['2024-06-25T21:04:00Z', 6.346036434173584],
      ['2024-06-25T21:05:00Z', 6.348007361094157],
      ['2024-06-25T21:06:00Z', 6.350614070892334],
      ['2024-06-25T21:07:00Z', 6.352139949798584],
      ['2024-06-25T21:08:00Z', 6.348134517669678],
      ['2024-06-25T21:09:00Z', 6.345972855885823],
      ['2024-06-25T21:10:00Z', 6.344510555267334],
      ['2024-06-25T21:11:00Z', 6.343556880950928],
      ['2024-06-25T21:12:00Z', 6.345972855885823],
      ['2024-06-25T21:13:00Z', 6.348134517669678],
      ['2024-06-25T21:14:00Z', 6.344446976979573],
      ['2024-06-25T21:15:00Z', 6.343429724375407],
      ['2024-06-25T21:16:00Z', 6.346608638763428],
      ['2024-06-25T21:17:00Z', 6.347753047943115],
      ['2024-06-25T21:18:00Z', 6.3479437828063965],
      ['2024-06-25T21:19:00Z', 6.35004186630249],
      ['2024-06-25T21:20:00Z', 6.3494696617126465],
      ['2024-06-25T21:21:00Z', 6.339169979095459],
      ['2024-06-25T21:22:00Z', 6.327407677968343],
      ['2024-06-25T21:23:00Z', 6.326581120491028],
      ['2024-06-25T21:24:00Z', 6.329187870025635],
      ['2024-06-25T21:25:00Z', 6.334528764088948],
      ['2024-06-25T21:26:00Z', 6.333638668060303],
      ['2024-06-25T21:27:00Z', 6.333638668060303],
      ['2024-06-25T21:28:00Z', 6.335927486419678],
      ['2024-06-25T21:29:00Z', 6.34241247177124],
      ['2024-06-25T21:30:00Z', 6.344510555267334],
      ['2024-06-25T21:31:00Z', 6.343175411224365],
      ['2024-06-25T21:32:00Z', 6.341140906016032],
      ['2024-06-25T21:33:00Z', 6.342158158620198],
      ['2024-06-25T21:34:00Z', 6.333765824635823],
      ['2024-06-25T21:35:00Z', 6.327153444290161],
      ['2024-06-25T21:36:00Z', 6.318951606750488],
      ['2024-06-25T21:37:00Z', 6.323084354400635],
      ['2024-06-25T21:38:00Z', 6.3387885093688965],
      ['2024-06-25T21:39:00Z', 6.335546016693115],
      ['2024-06-25T21:40:00Z', 6.3357367515563965],
      ['2024-06-25T21:41:00Z', 6.344701290130615],
      ['2024-06-25T21:42:00Z', 6.355764031410217],
      ['2024-06-25T21:43:00Z', 6.362630724906921],
      ['2024-06-25T21:44:00Z', 6.375219345092773],
      ['2024-06-25T21:45:00Z', 6.38075065612793],
      ['2024-06-25T21:46:00Z', 6.37623659769694],
      ['2024-06-25T21:47:00Z', 6.378843307495117],
      ['2024-06-25T21:48:00Z', 6.3803056081136065],
      ['2024-06-25T21:49:00Z', 6.38081423441569],
      ['2024-06-25T21:50:00Z', 6.376999537150065],
      ['2024-06-25T21:51:00Z', 6.38075065612793],
      ['2024-06-25T21:52:00Z', 6.381322860717773],
      ['2024-06-25T21:53:00Z', 6.376999537150065],
      ['2024-06-25T21:54:00Z', 6.3742020924886065],
      ['2024-06-25T21:55:00Z', 6.372358322143555],
      ['2024-06-25T21:56:00Z', 6.371976852416992],
      ['2024-06-25T21:57:00Z', 6.366318384806315],
      ['2024-06-25T21:58:00Z', 6.3658097585042315],
      ['2024-06-25T21:59:00Z', 6.370832443237305],
      ['2024-06-25T22:00:00Z', 6.371404647827148],
      ['2024-06-25T22:01:00Z', 6.376999537150065],
      ['2024-06-25T22:02:00Z', 6.374456405639648],
      ['2024-06-25T22:03:00Z', 6.3803056081136065],
      ['2024-06-25T22:04:00Z', 6.362630724906921],
      ['2024-06-25T22:05:00Z', 6.337326208750407],
      ['2024-06-25T22:06:00Z', 6.32384729385376],
      ['2024-06-25T22:07:00Z', 6.308270454406738],
      ['2024-06-25T22:08:00Z', 6.335355162620544],
      ['2024-06-25T22:09:00Z', 6.352139949798584],
      ['2024-06-25T22:10:00Z', 6.3711503346761065],
      ['2024-06-25T22:11:00Z', 6.3795426686604815],
      ['2024-06-25T22:12:00Z', 6.381895065307617],
      ['2024-06-25T22:13:00Z', 6.3787797292073565],
      ['2024-06-25T22:14:00Z', 6.371786117553711],
      ['2024-06-25T22:15:00Z', 6.370832443237305],
      ['2024-06-25T22:16:00Z', 6.368352890014648],
      ['2024-06-25T22:17:00Z', 6.364728808403015],
      ['2024-06-25T22:18:00Z', 6.362821578979492],
      ['2024-06-25T22:19:00Z', 6.3574806451797485],
      ['2024-06-25T22:20:00Z', 6.359197378158569],
      ['2024-06-25T22:21:00Z', 6.358243703842163],
      ['2024-06-25T22:22:00Z', 6.335927248001099],
      ['2024-06-25T22:23:00Z', 6.3092241287231445],
      ['2024-06-25T22:24:00Z', 6.33630895614624],
      ['2024-06-25T22:25:00Z', 6.364283720652263],
      ['2024-06-25T22:26:00Z', 6.3855191469192505],
      ['2024-06-25T22:27:00Z', 6.369497299194336],
      ['2024-06-25T22:28:00Z', 6.35614538192749],
      ['2024-06-25T22:29:00Z', 6.359197378158569],
      ['2024-06-25T22:30:00Z', 6.347753167152405],
      ['2024-06-25T22:31:00Z', 6.307888984680176],
      ['2024-06-25T22:32:00Z', 6.3145647048950195],
      ['2024-06-25T22:33:00Z', 6.345273375511169],
      ['2024-06-25T22:34:00Z', 6.372930526733398],
      ['2024-06-25T22:35:00Z', 6.352330684661865],
      ['2024-06-25T22:36:00Z', 6.346608638763428],
      ['2024-06-25T22:37:00Z', 6.3513771295547485],
      ['2024-06-25T22:38:00Z', 6.379415512084961],
      ['2024-06-25T22:39:00Z', 6.3803056081136065],
      ['2024-06-25T22:40:00Z', 6.370896021525065],
      ['2024-06-25T22:41:00Z', 6.361486196517944],
      ['2024-06-25T22:42:00Z', 6.32689905166626],
      ['2024-06-25T22:43:00Z', 6.302739143371582],
      ['2024-06-25T22:44:00Z', 6.317425847053528],
      ['2024-06-25T22:45:00Z', 6.356908480326335],
      ['2024-06-25T22:46:00Z', 6.375410079956055],
      ['2024-06-25T22:47:00Z', 6.370260238647461],
      ['2024-06-25T22:48:00Z', 6.359197378158569],
      ['2024-06-25T22:49:00Z', 6.349660396575928],
      ['2024-06-25T22:50:00Z', 6.313420295715332],
      ['2024-06-25T22:51:00Z', 6.298161268234253],
      ['2024-06-25T22:52:00Z', 6.319524049758911],
      ['2024-06-25T22:53:00Z', 6.354810357093811],
      ['2024-06-25T22:54:00Z', 6.380369186401367],
      ['2024-06-25T22:55:00Z', 6.362058520317078],
      ['2024-06-25T22:56:00Z', 6.358943144480388],
      ['2024-06-25T22:57:00Z', 6.359197378158569],
      ['2024-06-25T22:58:00Z', 6.361740589141846],
      ['2024-06-25T22:59:00Z', 6.3642838795979815],
      ['2024-06-25T23:00:00Z', 6.366064071655273],
      ['2024-06-25T23:01:00Z', 6.372421900431315],
      ['2024-06-25T23:02:00Z', 6.370260238647461],
      ['2024-06-25T23:03:00Z', 6.378271102905273],
      ['2024-06-25T23:04:00Z', 6.377508163452148],
      ['2024-06-25T23:05:00Z', 6.3742020924886065],
      ['2024-06-25T23:06:00Z', 6.372167587280273],
      ['2024-06-25T23:07:00Z', 6.372739791870117],
      ['2024-06-25T23:08:00Z', 6.372930526733398],
      ['2024-06-25T23:09:00Z', 6.366254806518555],
      ['2024-06-25T23:10:00Z', 6.363393783569336],
      ['2024-06-25T23:11:00Z', 6.367589950561523],
      ['2024-06-25T23:12:00Z', 6.38227653503418],
      ['2024-06-25T23:13:00Z', 6.38075065612793],
      ['2024-06-25T23:14:00Z', 6.368352890014648],
      ['2024-06-25T23:15:00Z', 6.361677050590515],
      ['2024-06-25T23:16:00Z', 6.359769582748413],
      ['2024-06-25T23:17:00Z', 6.359197378158569],
      ['2024-06-25T23:18:00Z', 6.353347937266032],
      ['2024-06-25T23:19:00Z', 6.345082759857178],
      ['2024-06-25T23:20:00Z', 6.349851131439209],
      ['2024-06-25T23:21:00Z', 6.325818181037903],
      ['2024-06-25T23:22:00Z', 6.3054094314575195],
      ['2024-06-25T23:23:00Z', 6.324355920155843],
      ['2024-06-25T23:24:00Z', 6.367589712142944],
      ['2024-06-25T23:25:00Z', 6.389969666798909],
      ['2024-06-25T23:26:00Z', 6.384183883666992],
      ['2024-06-25T23:27:00Z', 6.381322860717773],
      ['2024-06-25T23:28:00Z', 6.373884201049805],
      ['2024-06-25T23:29:00Z', 6.365301132202148],
      ['2024-06-25T23:30:00Z', 6.370896021525065],
      ['2024-06-25T23:31:00Z', 6.37623659769694],
      ['2024-06-25T23:32:00Z', 6.380178451538086],
      ['2024-06-25T23:33:00Z', 6.376935958862305],
      ['2024-06-25T23:34:00Z', 6.363520781199138],
      ['2024-06-25T23:35:00Z', 6.354238152503967],
      ['2024-06-25T23:36:00Z', 6.3464179039001465],
      ['2024-06-25T23:37:00Z', 6.3395514488220215],
      ['2024-06-25T23:38:00Z', 6.3334479331970215],
      ['2024-06-25T23:39:00Z', 6.330968260765076],
      ['2024-06-25T23:40:00Z', 6.329251527786255],
      ['2024-06-25T23:41:00Z', 6.321304003397624],
      ['2024-06-25T23:42:00Z', 6.315963427225749],
      ['2024-06-25T23:43:00Z', 6.3145647048950195],
      ['2024-06-25T23:44:00Z', 6.321304003397624],
      ['2024-06-25T23:45:00Z', 6.334020137786865],
      ['2024-06-25T23:46:00Z', 6.338343461354573],
      ['2024-06-25T23:47:00Z', 6.35156774520874],
      ['2024-06-25T23:48:00Z', 6.366826891899109],
      ['2024-06-25T23:49:00Z', 6.356908440589905],
      ['2024-06-25T23:50:00Z', 6.324355920155843],
      ['2024-06-25T23:51:00Z', 6.308842658996582],
      ['2024-06-25T23:52:00Z', 6.325055360794067],
      ['2024-06-25T23:53:00Z', 6.34393835067749],
      ['2024-06-25T23:54:00Z', 6.322194218635559],
      ['2024-06-25T23:55:00Z', 6.303120493888855],
      ['2024-06-25T23:56:00Z', 6.316662907600403],
      ['2024-06-25T23:57:00Z', 6.357099175453186],
      ['2024-06-25T23:58:00Z', 6.366254806518555],
      ['2024-06-25T23:59:00Z', 6.35614538192749],
      ['2024-06-26T00:00:00Z', 6.341649532318115],
      ['2024-06-26T00:01:00Z', 6.346799373626709],
      ['2024-06-26T00:02:00Z', 6.369878768920898],
      ['2024-06-26T00:03:00Z', 6.3803056081136065],
      ['2024-06-26T00:04:00Z', 6.378843307495117],
      ['2024-06-26T00:05:00Z', 6.3703873952229815],
      ['2024-06-26T00:06:00Z', 6.360723336537679],
      ['2024-06-26T00:07:00Z', 6.347753167152405],
      ['2024-06-26T00:08:00Z', 6.322957158088684],
      ['2024-06-26T00:09:00Z', 6.300958792368571],
      ['2024-06-26T00:10:00Z', 6.322194337844849],
      ['2024-06-26T00:11:00Z', 6.323147892951965],
      ['2024-06-26T00:12:00Z', 6.3107500076293945],
      ['2024-06-26T00:13:00Z', 6.310940742492676],
      ['2024-06-26T00:14:00Z', 6.34088659286499],
      ['2024-06-26T00:15:00Z', 6.3749650319417315],
      ['2024-06-26T00:16:00Z', 6.378271102905273],
      ['2024-06-26T00:17:00Z', 6.3650468190511065],
      ['2024-06-26T00:18:00Z', 6.368925094604492],
      ['2024-06-26T00:19:00Z', 6.376999537150065],
      ['2024-06-26T00:20:00Z', 6.35309374332428],
      ['2024-06-26T00:21:00Z', 6.318951725959778],
      ['2024-06-26T00:22:00Z', 6.306172251701355],
      ['2024-06-26T00:23:00Z', 6.346608638763428],
      ['2024-06-26T00:24:00Z', 6.379797101020813],
      ['2024-06-26T00:25:00Z', 6.370832443237305],
      ['2024-06-26T00:26:00Z', 6.358180046081543],
      ['2024-06-26T00:27:00Z', 6.361486275990804],
      ['2024-06-26T00:28:00Z', 6.355382442474365],
      ['2024-06-26T00:29:00Z', 6.357099294662476],
      ['2024-06-26T00:30:00Z', 6.358180046081543],
      ['2024-06-26T00:31:00Z', 6.358942985534668],
      ['2024-06-26T00:32:00Z', 6.356336236000061],
      ['2024-06-26T00:33:00Z', 6.360723257064819],
      ['2024-06-26T00:34:00Z', 6.357289791107178],
      ['2024-06-26T00:35:00Z', 6.35614550113678],
      ['2024-06-26T00:36:00Z', 6.350995659828186],
      ['2024-06-26T00:37:00Z', 6.3464179039001465],
      ['2024-06-26T00:38:00Z', 6.342031002044678],
      ['2024-06-26T00:39:00Z', 6.339932918548584],
      ['2024-06-26T00:40:00Z', 6.33783483505249],
      ['2024-06-26T00:41:00Z', 6.334528764088948],
      ['2024-06-26T00:42:00Z', 6.336118221282959],
      ['2024-06-26T00:43:00Z', 6.335927486419678],
      ['2024-06-26T00:44:00Z', 6.327153364817302],
      ['2024-06-26T00:45:00Z', 6.322003483772278],
      ['2024-06-26T00:46:00Z', 6.315709114074707],
      ['2024-06-26T00:47:00Z', 6.31926949818929],
      ['2024-06-26T00:48:00Z', 6.319523811340332],
      ['2024-06-26T00:49:00Z', 6.3122758865356445],
      ['2024-06-26T00:50:00Z', 6.309796333312988],
      ['2024-06-26T00:51:00Z', 6.317044258117676],
      ['2024-06-26T00:52:00Z', 6.328933556874593],
      ['2024-06-26T00:53:00Z', 6.344701290130615],
      ['2024-06-26T00:54:00Z', 6.354238033294678],
      ['2024-06-26T00:55:00Z', 6.364156723022461],
      ['2024-06-26T00:56:00Z', 6.375410079956055],
      ['2024-06-26T00:57:00Z', 6.3810685475667315],
      ['2024-06-26T00:58:00Z', 6.376363754272461],
      ['2024-06-26T00:59:00Z', 6.371786117553711],
      ['2024-06-26T01:00:00Z', 6.364919662475586],
      ['2024-06-26T01:01:00Z', 6.361104965209961],
      ['2024-06-26T01:02:00Z', 6.359197378158569],
      ['2024-06-26T01:03:00Z', 6.359197378158569],
      ['2024-06-26T01:04:00Z', 6.357417106628418],
      ['2024-06-26T01:05:00Z', 6.362249135971069],
      ['2024-06-26T01:06:00Z', 6.366445422172546],
      ['2024-06-26T01:07:00Z', 6.3696244557698565],
      ['2024-06-26T01:08:00Z', 6.372930526733398],
      ['2024-06-26T01:09:00Z', 6.375219345092773],
      ['2024-06-26T01:10:00Z', 6.376999537150065],
      ['2024-06-26T01:11:00Z', 6.375219345092773],
      ['2024-06-26T01:12:00Z', 6.370450973510742],
      ['2024-06-26T01:13:00Z', 6.367844263712565],
      ['2024-06-26T01:14:00Z', 6.363012154897054],
      ['2024-06-26T01:15:00Z', 6.359197378158569],
      ['2024-06-26T01:16:00Z', 6.359578847885132],
      ['2024-06-26T01:17:00Z', 6.352330684661865],
      ['2024-06-26T01:18:00Z', 6.357289791107178],
      ['2024-06-26T01:19:00Z', 6.355001091957092],
      ['2024-06-26T01:20:00Z', 6.358180046081543],
      ['2024-06-26T01:21:00Z', 6.357417106628418],
      ['2024-06-26T01:22:00Z', 6.372739791870117],
      ['2024-06-26T01:23:00Z', 6.382848739624023],
      ['2024-06-26T01:24:00Z', 6.368352890014648],
      ['2024-06-26T01:25:00Z', 6.3650468190511065],
      ['2024-06-26T01:26:00Z', 6.362249374389648],
      ['2024-06-26T01:27:00Z', 6.361867785453796],
      ['2024-06-26T01:28:00Z', 6.363775134086609],
      ['2024-06-26T01:29:00Z', 6.367780685424805],
      ['2024-06-26T01:30:00Z', 6.3696244557698565],
      ['2024-06-26T01:31:00Z', 6.367589950561523],
      ['2024-06-26T01:32:00Z', 6.363775253295898],
      ['2024-06-26T01:33:00Z', 6.365873217582703],
      ['2024-06-26T01:34:00Z', 6.370450973510742],
      ['2024-06-26T01:35:00Z', 6.362249135971069],
      ['2024-06-26T01:36:00Z', 6.326008915901184],
      ['2024-06-26T01:37:00Z', 6.322067101796468],
      ['2024-06-26T01:38:00Z', 6.337580521901448],
      ['2024-06-26T01:39:00Z', 6.34088659286499],
      ['2024-06-26T01:40:00Z', 6.341649532318115],
      ['2024-06-26T01:41:00Z', 6.348007361094157],
      ['2024-06-26T01:42:00Z', 6.345209916432698],
      ['2024-06-26T01:43:00Z', 6.341903845469157],
      ['2024-06-26T01:44:00Z', 6.342031002044678],
      ['2024-06-26T01:45:00Z', 6.352839310963948],
      ['2024-06-26T01:46:00Z', 6.362439870834351],
      ['2024-06-26T01:47:00Z', 6.370260238647461],
      ['2024-06-26T01:48:00Z', 6.376999537150065],
      ['2024-06-26T01:49:00Z', 6.377317428588867],
      ['2024-06-26T01:50:00Z', 6.375028610229492],
      ['2024-06-26T01:51:00Z', 6.368925094604492],
      ['2024-06-26T01:52:00Z', 6.357099294662476],
      ['2024-06-26T01:53:00Z', 6.357099294662476],
      ['2024-06-26T01:54:00Z', 6.35614538192749],
      ['2024-06-26T01:55:00Z', 6.357417106628418],
      ['2024-06-26T01:56:00Z', 6.3582435846328735],
      ['2024-06-26T01:57:00Z', 6.36549186706543],
      ['2024-06-26T01:58:00Z', 6.370260238647461],
      ['2024-06-26T01:59:00Z', 6.371404647827148],
      ['2024-06-26T02:00:00Z', 6.370641708374023],
      ['2024-06-26T02:01:00Z', 6.370641708374023],
      ['2024-06-26T02:02:00Z', 6.372167587280273],
      ['2024-06-26T02:03:00Z', 6.372167587280273],
      ['2024-06-26T02:04:00Z', 6.372167587280273],
      ['2024-06-26T02:05:00Z', 6.372167587280273],
      ['2024-06-26T02:06:00Z', 6.372167587280273],
      ['2024-06-26T02:07:00Z', 6.370641708374022],
      ['2024-06-26T02:08:00Z', 6.360214710235596],
      ['2024-06-26T02:09:00Z', 6.366318384806315],
      ['2024-06-26T02:10:00Z', 6.362249374389648],
      ['2024-06-26T02:11:00Z', 6.364919543266296],
      ['2024-06-26T02:12:00Z', 6.368925094604492],
      ['2024-06-26T02:13:00Z', 6.370832443237305],
      ['2024-06-26T02:14:00Z', 6.377126693725586],
      ['2024-06-26T02:15:00Z', 6.376363754272461],
      ['2024-06-26T02:16:00Z', 6.373311996459961],
      ['2024-06-26T02:17:00Z', 6.372739791870117],
      ['2024-06-26T02:18:00Z', 6.376935958862305],
      ['2024-06-26T02:19:00Z', 6.378271102905273],
      ['2024-06-26T02:20:00Z', 6.379796981811523],
      ['2024-06-26T02:21:00Z', 6.376363754272461],
      ['2024-06-26T02:22:00Z', 6.37617301940918],
      ['2024-06-26T02:23:00Z', 6.370896021525065],
      ['2024-06-26T02:24:00Z', 6.362503528594971],
      ['2024-06-26T02:25:00Z', 6.35004186630249],
      ['2024-06-26T02:26:00Z', 6.340123653411865],
      ['2024-06-26T02:27:00Z', 6.330777525901794],
      ['2024-06-26T02:28:00Z', 6.338979244232178],
      ['2024-06-26T02:29:00Z', 6.3433661460876465],
      ['2024-06-26T02:30:00Z', 6.339869340260823],
      ['2024-06-26T02:31:00Z', 6.34393835067749],
      ['2024-06-26T02:32:00Z', 6.333829402923584],
      ['2024-06-26T02:33:00Z', 6.341140906016032],
      ['2024-06-26T02:34:00Z', 6.337834715843201],
      ['2024-06-26T02:35:00Z', 6.3241017659505205],
      ['2024-06-26T02:36:00Z', 6.298669815063477],
      ['2024-06-26T02:37:00Z', 6.317044377326965],
      ['2024-06-26T02:38:00Z', 6.334592223167419],
      ['2024-06-26T02:39:00Z', 6.363012154897054],
      ['2024-06-26T02:40:00Z', 6.38380241394043],
      ['2024-06-26T02:41:00Z', 6.365046660105388],
      ['2024-06-26T02:42:00Z', 6.359197378158569],
      ['2024-06-26T02:43:00Z', 6.326009035110474],
      ['2024-06-26T02:44:00Z', 6.30095895131429],
      ['2024-06-26T02:45:00Z', 6.311703681945801],
      ['2024-06-26T02:46:00Z', 6.3456549644470215],
      ['2024-06-26T02:47:00Z', 6.378461837768555],
      ['2024-06-26T02:48:00Z', 6.360532522201538],
      ['2024-06-26T02:49:00Z', 6.329823851585388],
      ['2024-06-26T02:50:00Z', 6.310368537902832],
      ['2024-06-26T02:51:00Z', 6.330968260765076],
      ['2024-06-26T02:52:00Z', 6.366827011108398],
      ['2024-06-26T02:53:00Z', 6.361295461654663],
      ['2024-06-26T02:54:00Z', 6.345209916432698],
      ['2024-06-26T02:55:00Z', 6.3286794026692705],
      ['2024-06-26T02:56:00Z', 6.348261674245198],
      ['2024-06-26T02:57:00Z', 6.371404647827148],
      ['2024-06-26T02:58:00Z', 6.37165896097819],
      ['2024-06-26T02:59:00Z', 6.3410773277282715],
      ['2024-06-26T03:00:00Z', 6.323147892951965],
      ['2024-06-26T03:01:00Z', 6.321049809455872],
      ['2024-06-26T03:02:00Z', 6.350614070892334],
      ['2024-06-26T03:03:00Z', 6.373693466186523],
      ['2024-06-26T03:04:00Z', 6.386409282684326],
      ['2024-06-26T03:05:00Z', 6.382085800170898],
      ['2024-06-26T03:06:00Z', 6.372930526733398],
      ['2024-06-26T03:07:00Z', 6.36555544535319],
      ['2024-06-26T03:08:00Z', 6.360151171684265],
      ['2024-06-26T03:09:00Z', 6.357289910316467],
      ['2024-06-26T03:10:00Z', 6.364728808403015],
      ['2024-06-26T03:11:00Z', 6.373693466186523],
      ['2024-06-26T03:12:00Z', 6.38386599222819],
      ['2024-06-26T03:13:00Z', 6.38234011332194],
      ['2024-06-26T03:14:00Z', 6.3803056081136065],
      ['2024-06-26T03:15:00Z', 6.375473658243815],
      ['2024-06-26T03:16:00Z', 6.372421900431315],
      ['2024-06-26T03:17:00Z', 6.368352890014648],
      ['2024-06-26T03:18:00Z', 6.371213912963867],
      ['2024-06-26T03:19:00Z', 6.371976852416992],
      ['2024-06-26T03:20:00Z', 6.370832443237305],
      ['2024-06-26T03:21:00Z', 6.369497299194336],
      ['2024-06-26T03:22:00Z', 6.365301132202148],
      ['2024-06-26T03:23:00Z', 6.363775134086609],
      ['2024-06-26T03:24:00Z', 6.350550492604573],
      ['2024-06-26T03:25:00Z', 6.323338747024536],
      ['2024-06-26T03:26:00Z', 6.316662907600403],
      ['2024-06-26T03:27:00Z', 6.347562313079834],
      ['2024-06-26T03:28:00Z', 6.373693466186523],
      ['2024-06-26T03:29:00Z', 6.386663556098938],
      ['2024-06-26T03:30:00Z', 6.378843307495117],
      ['2024-06-26T03:31:00Z', 6.373884201049805],
      ['2024-06-26T03:32:00Z', 6.370450973510742],
      ['2024-06-26T03:33:00Z', 6.3650468190511065],
      ['2024-06-26T03:34:00Z', 6.370260238647461],
      ['2024-06-26T03:35:00Z', 6.370896021525065],
      ['2024-06-26T03:36:00Z', 6.377126693725586],
      ['2024-06-26T03:37:00Z', 6.383420944213867],
      ['2024-06-26T03:38:00Z', 6.38532829284668],
      ['2024-06-26T03:39:00Z', 6.384374618530273],
      ['2024-06-26T03:40:00Z', 6.374074935913086],
      ['2024-06-26T03:41:00Z', 6.375791549682617],
      ['2024-06-26T03:42:00Z', 6.375219345092773],
      ['2024-06-26T03:43:00Z', 6.37623659769694],
      ['2024-06-26T03:44:00Z', 6.375219345092773],
      ['2024-06-26T03:45:00Z', 6.372739791870117],
      ['2024-06-26T03:46:00Z', 6.37165896097819],
      ['2024-06-26T03:47:00Z', 6.344319939613342],
      ['2024-06-26T03:48:00Z', 6.310368537902832],
      ['2024-06-26T03:49:00Z', 6.320032596588135],
      ['2024-06-26T03:50:00Z', 6.323338667551677],
      ['2024-06-26T03:51:00Z', 6.312148729960124],
      ['2024-06-26T03:52:00Z', 6.308334032694499],
      ['2024-06-26T03:53:00Z', 6.335736513137817],
      ['2024-06-26T03:54:00Z', 6.357417106628418],
      ['2024-06-26T03:55:00Z', 6.349278926849365],
      ['2024-06-26T03:56:00Z', 6.329442262649536],
      ['2024-06-26T03:57:00Z', 6.330968260765076],
      ['2024-06-26T03:58:00Z', 6.365555286407471],
      ['2024-06-26T03:59:00Z', 6.370896021525065],
      ['2024-06-26T04:00:00Z', 6.360151171684265],
      ['2024-06-26T04:01:00Z', 6.350550492604573],
      ['2024-06-26T04:02:00Z', 6.357417106628418],
      ['2024-06-26T04:03:00Z', 6.386917908986409],
      ['2024-06-26T04:04:00Z', 6.369687914848328],
      ['2024-06-26T04:05:00Z', 6.325627485911052],
      ['2024-06-26T04:06:00Z', 6.306744575500488],
      ['2024-06-26T04:07:00Z', 6.321304162343343],
      ['2024-06-26T04:08:00Z', 6.35156790415446],
      ['2024-06-26T04:09:00Z', 6.349787553151448],
      ['2024-06-26T04:10:00Z', 6.339169979095459],
      ['2024-06-26T04:11:00Z', 6.31774361928304],
      ['2024-06-26T04:12:00Z', 6.328297853469849],
      ['2024-06-26T04:13:00Z', 6.351377010345459],
      ['2024-06-26T04:14:00Z', 6.363012313842773],
      ['2024-06-26T04:15:00Z', 6.38227653503418],
      ['2024-06-26T04:16:00Z', 6.371404647827148],
      ['2024-06-26T04:17:00Z', 6.342031002044678],
      ['2024-06-26T04:18:00Z', 6.340632279713948],
      ['2024-06-26T04:19:00Z', 6.339169979095459],
      ['2024-06-26T04:20:00Z', 6.313801884651184],
      ['2024-06-26T04:21:00Z', 6.3019760847091675],
      ['2024-06-26T04:22:00Z', 6.321304162343343],
      ['2024-06-26T04:23:00Z', 6.343747496604919],
      ['2024-06-26T04:24:00Z', 6.381704330444336],
      ['2024-06-26T04:25:00Z', 6.355573296546936],
      ['2024-06-26T04:26:00Z', 6.318252245585124],
      ['2024-06-26T04:27:00Z', 6.318951725959778],
      ['2024-06-26T04:28:00Z', 6.343175411224365],
      ['2024-06-26T04:29:00Z', 6.357289910316467],
      ['2024-06-26T04:30:00Z', 6.368352890014648],
      ['2024-06-26T04:31:00Z', 6.376363754272461],
      ['2024-06-26T04:32:00Z', 6.372421900431315],
      ['2024-06-26T04:33:00Z', 6.367399215698242],
      ['2024-06-26T04:34:00Z', 6.35614538192749],
      ['2024-06-26T04:35:00Z', 6.355191707611084],
      ['2024-06-26T04:36:00Z', 6.3650468190511065],
      ['2024-06-26T04:37:00Z', 6.3582435846328735],
      ['2024-06-26T04:38:00Z', 6.353665828704834],
      ['2024-06-26T04:39:00Z', 6.347371578216553],
      ['2024-06-26T04:40:00Z', 6.343556880950928],
      ['2024-06-26T04:41:00Z', 6.3433661460876465],
      ['2024-06-26T04:42:00Z', 6.344319820404053],
      ['2024-06-26T04:43:00Z', 6.350804805755615],
      ['2024-06-26T04:44:00Z', 6.354110876719157],
      ['2024-06-26T04:45:00Z', 6.359197378158569],
      ['2024-06-26T04:46:00Z', 6.363775253295898],
      ['2024-06-26T04:47:00Z', 6.375473658243815],
      ['2024-06-26T04:48:00Z', 6.37623659769694],
      ['2024-06-26T04:49:00Z', 6.3795426686604815],
      ['2024-06-26T04:50:00Z', 6.3757279713948565],
      ['2024-06-26T04:51:00Z', 6.368352890014648],
      ['2024-06-26T04:52:00Z', 6.368925094604492],
      ['2024-06-26T04:53:00Z', 6.371404647827148],
      ['2024-06-26T04:54:00Z', 6.365873336791992],
      ['2024-06-26T04:55:00Z', 6.365873336791992],
      ['2024-06-26T04:56:00Z', 6.365873336791992],
      ['2024-06-26T04:57:00Z', 6.363393783569336],
      ['2024-06-26T04:58:00Z', 6.366254806518555],
      ['2024-06-26T04:59:00Z', 6.378271102905273],
      ['2024-06-26T05:00:00Z', 6.388952414194743],
      ['2024-06-26T05:01:00Z', 6.3680985768636065],
      ['2024-06-26T05:02:00Z', 6.35309362411499],
      ['2024-06-26T05:03:00Z', 6.349851131439209],
      ['2024-06-26T05:04:00Z', 6.3529030084609985],
      ['2024-06-26T05:05:00Z', 6.35461962223053],
      ['2024-06-26T05:06:00Z', 6.357099294662476],
      ['2024-06-26T05:07:00Z', 6.358625173568726],
      ['2024-06-26T05:08:00Z', 6.364728927612305],
      ['2024-06-26T05:09:00Z', 6.35461962223053],
      ['2024-06-26T05:10:00Z', 6.345209916432698],
      ['2024-06-26T05:11:00Z', 6.343175411224365],
      ['2024-06-26T05:12:00Z', 6.346227169036865],
      ['2024-06-26T05:13:00Z', 6.347371578216553],
      ['2024-06-26T05:14:00Z', 6.349851131439209],
      ['2024-06-26T05:15:00Z', 6.354873816172282],
      ['2024-06-26T05:16:00Z', 6.354047417640686],
      ['2024-06-26T05:17:00Z', 6.35614550113678],
      ['2024-06-26T05:18:00Z', 6.361486275990804],
      ['2024-06-26T05:19:00Z', 6.364728927612305],
      ['2024-06-26T05:20:00Z', 6.361104965209961],
      ['2024-06-26T05:21:00Z', 6.364156723022461],
      ['2024-06-26T05:22:00Z', 6.35614550113678],
      ['2024-06-26T05:23:00Z', 6.355764031410217],
      ['2024-06-26T05:24:00Z', 6.358052968978882],
      ['2024-06-26T05:25:00Z', 6.355573296546936],
      ['2024-06-26T05:26:00Z', 6.349660396575928],
      ['2024-06-26T05:27:00Z', 6.355000972747803],
      ['2024-06-26T05:28:00Z', 6.350804805755615],
      ['2024-06-26T05:29:00Z', 6.35614554087321],
      ['2024-06-26T05:30:00Z', 6.3567177057266235],
      ['2024-06-26T05:31:00Z', 6.354810357093811],
      ['2024-06-26T05:32:00Z', 6.348007361094157],
      ['2024-06-26T05:33:00Z', 6.348770300547282],
      ['2024-06-26T05:34:00Z', 6.350614070892334],
      ['2024-06-26T05:35:00Z', 6.355000972747803],
      ['2024-06-26T05:36:00Z', 6.361740589141846],
      ['2024-06-26T05:37:00Z', 6.361104846000671],
      ['2024-06-26T05:38:00Z', 6.363203048706055],
      ['2024-06-26T05:39:00Z', 6.363775134086609],
      ['2024-06-26T05:40:00Z', 6.363393664360046],
      ['2024-06-26T05:41:00Z', 6.373502731323242],
      ['2024-06-26T05:42:00Z', 6.383103052775065],
      ['2024-06-26T05:43:00Z', 6.375791549682617],
      ['2024-06-26T05:44:00Z', 6.363393664360046],
      ['2024-06-26T05:45:00Z', 6.360151171684265],
      ['2024-06-26T05:46:00Z', 6.35614554087321],
      ['2024-06-26T05:47:00Z', 6.327344059944153],
      ['2024-06-26T05:48:00Z', 6.3271535237630205],
      ['2024-06-26T05:49:00Z', 6.331985632578532],
      ['2024-06-26T05:50:00Z', 6.33783483505249],
      ['2024-06-26T05:51:00Z', 6.335037390391032],
      ['2024-06-26T05:52:00Z', 6.33173131942749],
      ['2024-06-26T05:53:00Z', 6.326199769973755],
      ['2024-06-26T05:54:00Z', 6.324292302131653],
      ['2024-06-26T05:55:00Z', 6.3214311599731445],
      ['2024-06-26T05:56:00Z', 6.330396056175232],
      ['2024-06-26T05:57:00Z', 6.352839469909668],
      ['2024-06-26T05:58:00Z', 6.3703873952229815],
      ['2024-06-26T05:59:00Z', 6.384374618530273],
      ['2024-06-26T06:00:00Z', 6.382848739624023],
      ['2024-06-26T06:01:00Z', 6.37922477722168],
      ['2024-06-26T06:02:00Z', 6.372930526733398],
      ['2024-06-26T06:03:00Z', 6.3696244557698565],
      ['2024-06-26T06:04:00Z', 6.3703873952229815],
      ['2024-06-26T06:05:00Z', 6.372167587280273],
      ['2024-06-26T06:06:00Z', 6.371976852416992],
      ['2024-06-26T06:07:00Z', 6.372930526733398],
      ['2024-06-26T06:08:00Z', 6.379034042358398],
      ['2024-06-26T06:09:00Z', 6.37623659769694],
      ['2024-06-26T06:10:00Z', 6.377126693725586],
      ['2024-06-26T06:11:00Z', 6.393275896708171],
      ['2024-06-26T06:12:00Z', 6.38081423441569],
      ['2024-06-26T06:13:00Z', 6.369497299194336],
      ['2024-06-26T06:14:00Z', 6.367780685424805],
      ['2024-06-26T06:15:00Z', 6.368352890014648],
      ['2024-06-26T06:16:00Z', 6.361295580863953],
      ['2024-06-26T06:17:00Z', 6.3529030084609985],
      ['2024-06-26T06:18:00Z', 6.35461962223053],
      ['2024-06-26T06:19:00Z', 6.35767138004303],
      ['2024-06-26T06:20:00Z', 6.358625173568726],
      ['2024-06-26T06:21:00Z', 6.362249374389648],
      ['2024-06-26T06:22:00Z', 6.3642838795979815],
      ['2024-06-26T06:23:00Z', 6.364919662475586],
      ['2024-06-26T06:24:00Z', 6.367780685424805],
      ['2024-06-26T06:25:00Z', 6.369878768920898],
      ['2024-06-26T06:26:00Z', 6.3742020924886065],
      ['2024-06-26T06:27:00Z', 6.3749650319417315],
      ['2024-06-26T06:28:00Z', 6.377126693725586],
      ['2024-06-26T06:29:00Z', 6.37623659769694],
      ['2024-06-26T06:30:00Z', 6.378271102905273],
      ['2024-06-26T06:31:00Z', 6.380369186401367],
      ['2024-06-26T06:32:00Z', 6.379796981811523],
      ['2024-06-26T06:33:00Z', 6.38386599222819],
      ['2024-06-26T06:34:00Z', 6.3803056081136065],
      ['2024-06-26T06:35:00Z', 6.38227653503418],
      ['2024-06-26T06:36:00Z', 6.382467269897461],
      ['2024-06-26T06:37:00Z', 6.38227653503418],
      ['2024-06-26T06:38:00Z', 6.384374618530273],
      ['2024-06-26T06:39:00Z', 6.383420944213867],
      ['2024-06-26T06:40:00Z', 6.384374618530273],
      ['2024-06-26T06:41:00Z', 6.382848739624023],
      ['2024-06-26T06:42:00Z', 6.384374618530273],
      ['2024-06-26T06:43:00Z', 6.383230209350586],
      ['2024-06-26T06:44:00Z', 6.382467269897461],
      ['2024-06-26T06:45:00Z', 6.3856461842854815],
      ['2024-06-26T06:46:00Z', 6.3856461842854815],
      ['2024-06-26T06:47:00Z', 6.386472702026367],
      ['2024-06-26T06:48:00Z', 6.385519027709961],
      ['2024-06-26T06:49:00Z', 6.38380241394043],
      ['2024-06-26T06:50:00Z', 6.383039474487305],
      ['2024-06-26T06:51:00Z', 6.38532829284668],
      ['2024-06-26T06:52:00Z', 6.385519027709961],
      ['2024-06-26T06:53:00Z', 6.3864091237386065],
      ['2024-06-26T06:54:00Z', 6.383103052775065],
      ['2024-06-26T06:55:00Z', 6.381895065307617],
      ['2024-06-26T06:56:00Z', 6.377317428588867],
      ['2024-06-26T06:57:00Z', 6.37776247660319],
      ['2024-06-26T06:58:00Z', 6.38227653503418],
      ['2024-06-26T06:59:00Z', 6.379796981811523],
      ['2024-06-26T07:00:00Z', 6.377508163452148],
      ['2024-06-26T07:01:00Z', 6.3795426686604815],
      ['2024-06-26T07:02:00Z', 6.37922477722168],
      ['2024-06-26T07:03:00Z', 6.37922477722168],
      ['2024-06-26T07:04:00Z', 6.3803056081136065],
      ['2024-06-26T07:05:00Z', 6.3787797292073565],
      ['2024-06-26T07:06:00Z', 6.378461837768555],
      ['2024-06-26T07:07:00Z', 6.372167587280273],
      ['2024-06-26T07:08:00Z', 6.3688615163167315],
      ['2024-06-26T07:09:00Z', 6.3703873952229815],
      ['2024-06-26T07:10:00Z', 6.362249374389648],
      ['2024-06-26T07:11:00Z', 6.360341787338257],
      ['2024-06-26T07:12:00Z', 6.35461950302124],
      ['2024-06-26T07:13:00Z', 6.35614538192749],
      ['2024-06-26T07:14:00Z', 6.358180046081543],
      ['2024-06-26T07:15:00Z', 6.362821578979492],
      ['2024-06-26T07:16:00Z', 6.366445541381836],
      ['2024-06-26T07:17:00Z', 6.366318384806315],
      ['2024-06-26T07:18:00Z', 6.366827011108398],
      ['2024-06-26T07:19:00Z', 6.367208480834961],
      ['2024-06-26T07:20:00Z', 6.368352890014648],
      ['2024-06-26T07:21:00Z', 6.3703873952229815],
      ['2024-06-26T07:22:00Z', 6.369497299194336],
      ['2024-06-26T07:23:00Z', 6.3734391530354815],
      ['2024-06-26T07:24:00Z', 6.321622133255005],
      ['2024-06-26T07:25:00Z', 6.29612668355306],
      ['2024-06-26T07:26:00Z', 6.305981516838074],
      ['2024-06-26T07:27:00Z', 6.295300006866455],
      ['2024-06-26T07:28:00Z', 6.305027961730957],
      ['2024-06-26T07:29:00Z', 6.320096015930176],
      ['2024-06-26T07:30:00Z', 6.318506558736165],
      ['2024-06-26T07:31:00Z', 6.318570137023926],
      ['2024-06-26T07:32:00Z', 6.319015185038249],
      ['2024-06-26T07:33:00Z', 6.3183794021606445],
      ['2024-06-26T07:34:00Z', 6.3176164627075195],
      ['2024-06-26T07:35:00Z', 6.317425727844238],
      ['2024-06-26T07:36:00Z', 6.317997932434082],
      ['2024-06-26T07:37:00Z', 6.31926949818929],
      ['2024-06-26T07:38:00Z', 6.319015185038249],
      ['2024-06-26T07:39:00Z', 6.31316598256429],
      ['2024-06-26T07:40:00Z', 6.318506558736165],
      ['2024-06-26T07:41:00Z', 6.3183794021606445],
      ['2024-06-26T07:42:00Z', 6.317044258117676],
      ['2024-06-26T07:43:00Z', 6.313674608866374],
      ['2024-06-26T07:44:00Z', 6.3176164627075195],
      ['2024-06-26T07:45:00Z', 6.315709114074707],
      ['2024-06-26T07:46:00Z', 6.3145647048950195],
      ['2024-06-26T07:47:00Z', 6.3160905838012695],
      ['2024-06-26T07:48:00Z', 6.317425727844238],
      ['2024-06-26T07:49:00Z', 6.315200487772624],
      ['2024-06-26T07:50:00Z', 6.312657356262207],
      ['2024-06-26T07:51:00Z', 6.313928922017415],
      ['2024-06-26T07:52:00Z', 6.316472053527832],
      ['2024-06-26T07:53:00Z', 6.315709114074707],
      ['2024-06-26T07:54:00Z', 6.314437548319499],
      ['2024-06-26T07:55:00Z', 6.316472053527832],
      ['2024-06-26T07:56:00Z', 6.314946174621582],
      ['2024-06-26T07:57:00Z', 6.315200487772624],
      ['2024-06-26T07:58:00Z', 6.316472053527832],
      ['2024-06-26T07:59:00Z', 6.31164010365804],
      ['2024-06-26T08:00:00Z', 6.316472053527832],
      ['2024-06-26T08:01:00Z', 6.3153276443481445],
      ['2024-06-26T08:02:00Z', 6.3153276443481445],
      ['2024-06-26T08:03:00Z', 6.3153276443481445],
      ['2024-06-26T08:04:00Z', 6.319523811340332],
      ['2024-06-26T08:05:00Z', 6.318506558736165],
      ['2024-06-26T08:06:00Z', 6.317234992980957],
      ['2024-06-26T08:07:00Z', 6.317044258117676],
      ['2024-06-26T08:08:00Z', 6.3160905838012695],
      ['2024-06-26T08:09:00Z', 6.320541063944499],
      ['2024-06-26T08:10:00Z', 6.318506558736165],
      ['2024-06-26T08:11:00Z', 6.314946174621582],
      ['2024-06-26T08:12:00Z', 6.316472053527832],
      ['2024-06-26T08:13:00Z', 6.318506558736165],
      ['2024-06-26T08:14:00Z', 6.316980679829915],
      ['2024-06-26T08:15:00Z', 6.317997932434082],
      ['2024-06-26T08:16:00Z', 6.319015185038249],
      ['2024-06-26T08:17:00Z', 6.316980679829915],
      ['2024-06-26T08:18:00Z', 6.318570137023926],
      ['2024-06-26T08:19:00Z', 6.317425727844238],
      ['2024-06-26T08:20:00Z', 6.320477485656738],
      ['2024-06-26T08:21:00Z', 6.320541063944499],
      ['2024-06-26T08:22:00Z', 6.320096015930176],
      ['2024-06-26T08:23:00Z', 6.31926949818929],
      ['2024-06-26T08:24:00Z', 6.315709114074707],
      ['2024-06-26T08:25:00Z', 6.319778124491374],
      ['2024-06-26T08:26:00Z', 6.3221940994262695],
      ['2024-06-26T08:27:00Z', 6.321304003397624],
      ['2024-06-26T08:28:00Z', 6.321049690246582],
      ['2024-06-26T08:29:00Z', 6.318506558736165],
      ['2024-06-26T08:30:00Z', 6.316472053527832],
      ['2024-06-26T08:31:00Z', 6.3019760847091675],
      ['2024-06-26T08:32:00Z', 6.294155716896057],
      ['2024-06-26T08:33:00Z', 6.296635389328003],
      ['2024-06-26T08:34:00Z', 6.2966353098551435],
      ['2024-06-26T08:35:00Z', 6.298415660858154],
      ['2024-06-26T08:36:00Z', 6.292311827341716],
      ['2024-06-26T08:37:00Z', 6.293074766794841],
      ['2024-06-26T08:38:00Z', 6.287861347198486],
      ['2024-06-26T08:39:00Z', 6.295363744099935],
      ['2024-06-26T08:40:00Z', 6.295300126075745],
      ['2024-06-26T08:41:00Z', 6.299178600311279],
      ['2024-06-26T08:42:00Z', 6.300641059875488],
      ['2024-06-26T08:43:00Z', 6.3000688552856445],
      ['2024-06-26T08:44:00Z', 6.305027961730957],
      ['2024-06-26T08:45:00Z', 6.303692817687988],
      ['2024-06-26T08:46:00Z', 6.317234992980957],
      ['2024-06-26T08:47:00Z', 6.325055122375488],
      ['2024-06-26T08:48:00Z', 6.329823851585388],
      ['2024-06-26T08:49:00Z', 6.332748572031657],
      ['2024-06-26T08:50:00Z', 6.33325719833374],
      ['2024-06-26T08:51:00Z', 6.340632279713948],
      ['2024-06-26T08:52:00Z', 6.34393835067749],
      ['2024-06-26T08:53:00Z', 6.34699010848999],
      ['2024-06-26T08:54:00Z', 6.351949214935303],
      ['2024-06-26T08:55:00Z', 6.3536659479141235],
      ['2024-06-26T08:56:00Z', 6.352585156758626],
      ['2024-06-26T08:57:00Z', 6.349278926849365],
      ['2024-06-26T08:58:00Z', 6.35156774520874],
      ['2024-06-26T08:59:00Z', 6.35004186630249],
      ['2024-06-26T09:00:00Z', 6.3433661460876465],
      ['2024-06-26T09:01:00Z', 6.342984676361084],
      ['2024-06-26T09:02:00Z', 6.3410773277282715],
      ['2024-06-26T09:03:00Z', 6.336817582448323],
      ['2024-06-26T09:04:00Z', 6.330586791038513],
      ['2024-06-26T09:05:00Z', 6.322575688362122],
      ['2024-06-26T09:06:00Z', 6.313992500305176],
      ['2024-06-26T09:07:00Z', 6.304265022277832],
      ['2024-06-26T09:08:00Z', 6.298669815063477],
      ['2024-06-26T09:09:00Z', 6.299878001213074],
      ['2024-06-26T09:10:00Z', 6.300450166066487],
      ['2024-06-26T09:11:00Z', 6.303502082824707],
      ['2024-06-26T09:12:00Z', 6.302739143371582],
      ['2024-06-26T09:13:00Z', 6.301785469055176],
      ['2024-06-26T09:14:00Z', 6.299941539764404],
      ['2024-06-26T09:15:00Z', 6.299687226613362],
      ['2024-06-26T09:16:00Z', 6.3004502058029175],
      ['2024-06-26T09:17:00Z', 6.3008317947387695],
      ['2024-06-26T09:18:00Z', 6.304265022277832],
      ['2024-06-26T09:19:00Z', 6.3031206130981445],
      ['2024-06-26T09:20:00Z', 6.3061723709106445],
      ['2024-06-26T09:21:00Z', 6.304265022277832],
      ['2024-06-26T09:22:00Z', 6.305790901184082],
      ['2024-06-26T09:23:00Z', 6.304265022277832],
      ['2024-06-26T09:24:00Z', 6.307316780090332],
      ['2024-06-26T09:25:00Z', 6.30706246693929],
      ['2024-06-26T09:26:00Z', 6.307316780090332],
      ['2024-06-26T09:27:00Z', 6.304074287414551],
      ['2024-06-26T09:28:00Z', 6.304265022277832],
      ['2024-06-26T09:29:00Z', 6.30553658803304],
      ['2024-06-26T09:30:00Z', 6.306744575500488],
      ['2024-06-26T09:31:00Z', 6.304773648579915],
      ['2024-06-26T09:32:00Z', 6.294346451759338],
      ['2024-06-26T09:33:00Z', 6.289768695831299],
      ['2024-06-26T09:34:00Z', 6.286971251169841],
      ['2024-06-26T09:35:00Z', 6.294346332550049],
      ['2024-06-26T09:36:00Z', 6.301721890767415],
      ['2024-06-26T09:37:00Z', 6.305790901184082],
      ['2024-06-26T09:38:00Z', 6.294727802276611],
      ['2024-06-26T09:39:00Z', 6.273746967315674],
      ['2024-06-26T09:40:00Z', 6.269169330596924],
      ['2024-06-26T09:41:00Z', 6.273492654164632],
      ['2024-06-26T09:42:00Z', 6.27775239944458],
      ['2024-06-26T09:43:00Z', 6.285445372263591],
      ['2024-06-26T09:44:00Z', 6.284428119659424],
      ['2024-06-26T09:45:00Z', 6.292311827341716],
      ['2024-06-26T09:46:00Z', 6.295363744099935],
      ['2024-06-26T09:47:00Z', 6.28843355178833],
      ['2024-06-26T09:48:00Z', 6.28233003616333],
      ['2024-06-26T09:49:00Z', 6.276989459991455],
      ['2024-06-26T09:50:00Z', 6.295681715011597],
      ['2024-06-26T09:51:00Z', 6.326009035110474],
      ['2024-06-26T09:52:00Z', 6.320032437642415],
      ['2024-06-26T09:53:00Z', 6.340123653411865],
      ['2024-06-26T09:54:00Z', 6.356527090072632],
      ['2024-06-26T09:55:00Z', 6.341903845469157],
      ['2024-06-26T09:56:00Z', 6.338597774505615],
      ['2024-06-26T09:57:00Z', 6.336118221282959],
      ['2024-06-26T09:58:00Z', 6.326199650764465],
      ['2024-06-26T09:59:00Z', 6.338089148203532],
      ['2024-06-26T10:00:00Z', 6.351313432057698],
      ['2024-06-26T10:01:00Z', 6.355573296546936],
      ['2024-06-26T10:02:00Z', 6.351186275482178],
      ['2024-06-26T10:03:00Z', 6.347562313079834],
      ['2024-06-26T10:04:00Z', 6.335800329844157],
      ['2024-06-26T10:05:00Z', 6.329823970794678],
      ['2024-06-26T10:06:00Z', 6.326771974563599],
      ['2024-06-26T10:07:00Z', 6.320477485656738],
      ['2024-06-26T10:08:00Z', 6.317807197570801],
      ['2024-06-26T10:09:00Z', 6.302548289299011],
      ['2024-06-26T10:10:00Z', 6.2747005224227905],
      ['2024-06-26T10:11:00Z', 6.272220969200134],
      ['2024-06-26T10:12:00Z', 6.285953998565674],
      ['2024-06-26T10:13:00Z', 6.302484671274821],
      ['2024-06-26T10:14:00Z', 6.301213105519612],
      ['2024-06-26T10:15:00Z', 6.288242816925049],
      ['2024-06-26T10:16:00Z', 6.284046649932861],
      ['2024-06-26T10:17:00Z', 6.280104796091716],
      ['2024-06-26T10:18:00Z', 6.269741415977478],
      ['2024-06-26T10:19:00Z', 6.219577471415202],
      ['2024-06-26T10:20:00Z', 6.168650388717651],
      ['2024-06-26T10:21:00Z', 6.119630694389343],
      ['2024-06-26T10:22:00Z', 6.056305885314941],
      ['2024-06-26T10:23:00Z', 6.296826124191284],
      ['2024-06-26T10:24:00Z', 6.521324396133423],
      ['2024-06-26T10:25:00Z', 6.629663467407227],
      ['2024-06-26T10:26:00Z', 6.73495078086853],
      ['2024-06-26T10:27:00Z', 6.70099937915802],
      ['2024-06-26T10:28:00Z', 6.393275896708171],
      ['2024-06-26T10:29:00Z', 6.493476629257202],
      ['2024-06-26T10:30:00Z', 6.6205079555511475],
      ['2024-06-26T10:31:00Z', 6.748111724853516],
      ['2024-06-26T10:32:00Z', 6.8022812604904175],
      ['2024-06-26T10:33:00Z', 6.453994035720825],
      ['2024-06-26T10:34:00Z', 6.269169092178345],
      ['2024-06-26T10:35:00Z', 6.429388761520386],
      ['2024-06-26T10:36:00Z', 6.5339131355285645],
      ['2024-06-26T10:37:00Z', 6.641870737075806],
      ['2024-06-26T10:38:00Z', 6.764324426651001],
      ['2024-06-26T10:39:00Z', 6.4940489530563354],
      ['2024-06-26T10:40:00Z', 6.41165030002594],
      ['2024-06-26T10:41:00Z', 6.4909971952438354],
      ['2024-06-26T10:42:00Z', 6.543640851974487],
      ['2024-06-26T10:43:00Z', 6.596856713294983],
      ['2024-06-26T10:44:00Z', 6.664377808570862],
      ['2024-06-26T10:45:00Z', 6.7351415157318115],
      ['2024-06-26T10:46:00Z', 6.549553751945496],
      ['2024-06-26T10:47:00Z', 6.313229560852051],
      ['2024-06-26T10:48:00Z', 6.406309604644775],
      ['2024-06-26T10:49:00Z', 6.511215329170227],
      ['2024-06-26T10:50:00Z', 6.594377040863037],
      ['2024-06-26T10:51:00Z', 6.67181658744812],
      ['2024-06-26T10:52:00Z', 6.63328742980957],
      ['2024-06-26T10:53:00Z', 6.291866898536682],
      ['2024-06-26T10:54:00Z', 6.382848858833313],
      ['2024-06-26T10:55:00Z', 6.464103102684021],
      ['2024-06-26T10:56:00Z', 6.5424964427948],
      ['2024-06-26T10:57:00Z', 6.61802864074707],
      ['2024-06-26T10:58:00Z', 6.6849775314331055],
      ['2024-06-26T10:59:00Z', 6.725413918495178],
      ['2024-06-26T11:00:00Z', 6.3889524936676025],
      ['2024-06-26T11:01:00Z', 6.3794156312942505],
      ['2024-06-26T11:02:00Z', 6.465819835662842],
      ['2024-06-26T11:03:00Z', 6.554131269454956],
      ['2024-06-26T11:04:00Z', 6.624323010444641],
      ['2024-06-26T11:05:00Z', 6.67792022228241],
      ['2024-06-26T11:06:00Z', 6.756313323974609],
      ['2024-06-26T11:07:00Z', 6.644159555435181],
      ['2024-06-26T11:08:00Z', 6.319523811340332],
      ['2024-06-26T11:09:00Z', 6.402113318443298],
      ['2024-06-26T11:10:00Z', 6.490615725517273],
      ['2024-06-26T11:11:00Z', 6.56087080637614],
      ['2024-06-26T11:12:00Z', 6.624513626098633],
      ['2024-06-26T11:13:00Z', 6.693560719490051],
      ['2024-06-26T11:14:00Z', 6.7339969873428345],
      ['2024-06-26T11:15:00Z', 6.3870450258255005],
      ['2024-06-26T11:16:00Z', 6.242847204208374],
      ['2024-06-26T11:17:00Z', 6.389333963394165],
      ['2024-06-26T11:18:00Z', 6.4763103723526],
      ['2024-06-26T11:19:00Z', 6.54707407951355],
      ['2024-06-26T11:20:00Z', 6.608110070228577],
      ['2024-06-26T11:21:00Z', 6.673914670944214],
      ['2024-06-26T11:22:00Z', 6.709391951560974],
      ['2024-06-26T11:23:00Z', 6.563668251037598],
      ['2024-06-26T11:24:00Z', 6.287289142608643],
      ['2024-06-26T11:25:00Z', 6.354047536849976],
      ['2024-06-26T11:26:00Z', 6.367589950561523],
      ['2024-06-26T11:27:00Z', 6.384374737739563],
      ['2024-06-26T11:28:00Z', 6.415655732154846],
      ['2024-06-26T11:29:00Z', 6.4501793384552],
      ['2024-06-26T11:30:00Z', 6.449988484382629],
      ['2024-06-26T11:31:00Z', 6.437018394470215],
      ['2024-06-26T11:32:00Z', 6.4242390394210815],
      ['2024-06-26T11:33:00Z', 6.42404826482137],
      ['2024-06-26T11:34:00Z', 6.437590599060059],
      ['2024-06-26T11:35:00Z', 6.456664323806763],
      ['2024-06-26T11:36:00Z', 6.4916965166727705],
      ['2024-06-26T11:37:00Z', 6.534676233927409],
      ['2024-06-26T11:38:00Z', 6.562333106994629],
      ['2024-06-26T11:39:00Z', 6.574349522590637],
      ['2024-06-26T11:40:00Z', 6.589608669281006],
      ['2024-06-26T11:41:00Z', 6.614595293998718],
      ['2024-06-26T11:42:00Z', 6.598001003265381],
      ['2024-06-26T11:43:00Z', 6.593423366546631],
      ['2024-06-26T11:44:00Z', 6.581979115804036],
      ['2024-06-26T11:45:00Z', 6.576447606086731],
      ['2024-06-26T11:46:00Z', 6.54402232170105],
      ['2024-06-26T11:47:00Z', 6.4997711181640625],
      ['2024-06-26T11:48:00Z', 6.477454821268718],
      ['2024-06-26T11:49:00Z', 6.4843214352925616],
      ['2024-06-26T11:50:00Z', 6.4901706377665205],
      ['2024-06-26T11:51:00Z', 6.475928783416748],
      ['2024-06-26T11:52:00Z', 6.456092119216919],
      ['2024-06-26T11:53:00Z', 6.429388880729675],
      ['2024-06-26T11:54:00Z', 6.409742832183838],
      ['2024-06-26T11:55:00Z', 6.3904783725738525],
      ['2024-06-26T11:56:00Z', 6.41317617893219],
      ['2024-06-26T11:57:00Z', 6.466582775115967],
      ['2024-06-26T11:58:00Z', 6.500089009602864],
      ['2024-06-26T11:59:00Z', 6.509880185127258],
      ['2024-06-26T12:00:00Z', 6.531115690867106],
      ['2024-06-26T12:01:00Z', 6.538490891456604],
      ['2024-06-26T12:02:00Z', 6.551842570304871],
      ['2024-06-26T12:03:00Z', 6.5779736042022705],
      ['2024-06-26T12:04:00Z', 6.613832354545593],
      ['2024-06-26T12:05:00Z', 6.6348770459493],
      ['2024-06-26T12:06:00Z', 6.6470208168029785],
      ['2024-06-26T12:07:00Z', 6.6839602788289385],
      ['2024-06-26T12:08:00Z', 6.693560600280762],
      ['2024-06-26T12:09:00Z', 6.331921815872192],
      ['2024-06-26T12:10:00Z', 6.3809415102005005],
      ['2024-06-26T12:11:00Z', 6.4330127239227295],
      ['2024-06-26T12:12:00Z', 6.460097789764404],
      ['2024-06-26T12:13:00Z', 6.4560922384262085],
      ['2024-06-26T12:14:00Z', 6.450242678324382],
      ['2024-06-26T12:15:00Z', 6.438289960225423],
      ['2024-06-26T12:16:00Z', 6.429388999938965],
      ['2024-06-26T12:17:00Z', 6.449416399002075],
      ['2024-06-26T12:18:00Z', 6.488136053085327],
      ['2024-06-26T12:19:00Z', 6.5714884996414185],
      ['2024-06-26T12:20:00Z', 6.649500370025635],
      ['2024-06-26T12:21:00Z', 6.744487524032593],
      ['2024-06-26T12:22:00Z', 6.5522239208221436],
      ['2024-06-26T12:23:00Z', 6.261158108711243],
      ['2024-06-26T12:24:00Z', 6.390669107437134],
      ['2024-06-26T12:25:00Z', 6.5714884996414185],
      ['2024-06-26T12:26:00Z', 6.738956332206726],
      ['2024-06-26T12:27:00Z', 6.699282884597778],
      ['2024-06-26T12:28:00Z', 6.449988484382629],
      ['2024-06-26T12:29:00Z', 6.629281997680664],
      ['2024-06-26T12:30:00Z', 6.81200897693634],
      ['2024-06-26T12:31:00Z', 6.8551154136657715],
      ['2024-06-26T12:32:00Z', 6.833752870559692],
      ['2024-06-26T12:33:00Z', 6.4629586935043335],
      ['2024-06-26T12:34:00Z', 6.331921815872192],
      ['2024-06-26T12:35:00Z', 6.335164427757263],
      ['2024-06-26T12:36:00Z', 6.297907034556071],
      ['2024-06-26T12:37:00Z', 6.247997283935547],
      ['2024-06-26T12:38:00Z', 6.211184859275818],
      ['2024-06-26T12:39:00Z', 6.38094162940979],
      ['2024-06-26T12:40:00Z', 6.509689450263977],
      ['2024-06-26T12:41:00Z', 6.635767102241516],
      ['2024-06-26T12:42:00Z', 6.716639876365662],
      ['2024-06-26T12:43:00Z', 6.629663586616516],
      ['2024-06-26T12:44:00Z', 6.3073166608810425],
      ['2024-06-26T12:45:00Z', 6.391432046890259],
      ['2024-06-26T12:46:00Z', 6.470842679341634],
      ['2024-06-26T12:47:00Z', 6.544289207458496],
      ['2024-06-26T12:48:00Z', 6.609254598617554],
      ['2024-06-26T12:49:00Z', 6.677348017692566],
      ['2024-06-26T12:50:00Z', 6.67944598197937],
      ['2024-06-26T12:51:00Z', 6.306172251701355],
      ['2024-06-26T12:52:00Z', 6.314755439758301],
      ['2024-06-26T12:53:00Z', 6.352076530456543],
      ['2024-06-26T12:54:00Z', 6.3350372314453125],
      ['2024-06-26T12:55:00Z', 6.322575728098552],
      ['2024-06-26T12:56:00Z', 6.3475624322891235],
      ['2024-06-26T12:57:00Z', 6.401541233062744],
      ['2024-06-26T12:58:00Z', 6.448462605476379],
      ['2024-06-26T12:59:00Z', 6.4955748319625854],
      ['2024-06-26T13:00:00Z', 6.519798517227173],
      ['2024-06-26T13:01:00Z', 6.546883265177409],
      ['2024-06-26T13:02:00Z', 6.587701201438904],
      ['2024-06-26T13:03:00Z', 6.641107797622681],
      ['2024-06-26T13:04:00Z', 6.6742963790893555],
      ['2024-06-26T13:05:00Z', 6.672388792037964],
      ['2024-06-26T13:06:00Z', 6.6592278480529785],
      ['2024-06-26T13:07:00Z', 6.6515984535217285],
      ['2024-06-26T13:08:00Z', 6.635957837104797],
      ['2024-06-26T13:09:00Z', 6.622924168904622],
      ['2024-06-26T13:10:00Z', 6.619872411092122],
      ['2024-06-26T13:11:00Z', 6.599781354268392],
      ['2024-06-26T13:12:00Z', 6.648165225982666],
      ['2024-06-26T13:13:00Z', 6.6900637944539385],
      ['2024-06-26T13:14:00Z', 6.696231007575989],
      ['2024-06-26T13:15:00Z', 6.3559547662734985],
      ['2024-06-26T13:16:00Z', 6.336690306663513],
      ['2024-06-26T13:17:00Z', 6.362249255180359],
      ['2024-06-26T13:18:00Z', 6.364728927612305],
      ['2024-06-26T13:19:00Z', 6.369878768920898],
      ['2024-06-26T13:20:00Z', 6.374456405639648],
      ['2024-06-26T13:21:00Z', 6.369306564331055],
      ['2024-06-26T13:22:00Z', 6.3703873952229815],
      ['2024-06-26T13:23:00Z', 6.361104965209961],
      ['2024-06-26T13:24:00Z', 6.362249255180359],
      ['2024-06-26T13:25:00Z', 6.36708132425944],
      ['2024-06-26T13:26:00Z', 6.386472821235657],
      ['2024-06-26T13:27:00Z', 6.411268711090088],
      ['2024-06-26T13:28:00Z', 6.428880373636882],
      ['2024-06-26T13:29:00Z', 6.420233408610026],
      ['2024-06-26T13:30:00Z', 6.434983889261882],
      ['2024-06-26T13:31:00Z', 6.45780873298645],
      ['2024-06-26T13:32:00Z', 6.4864195585250854],
      ['2024-06-26T13:33:00Z', 6.494621276855469],
      ['2024-06-26T13:34:00Z', 6.523422479629517],
      ['2024-06-26T13:35:00Z', 6.559281349182129],
      ['2024-06-26T13:36:00Z', 6.594377040863037],
      ['2024-06-26T13:37:00Z', 6.622415542602539],
      ['2024-06-26T13:38:00Z', 6.625467300415039],
      ['2024-06-26T13:39:00Z', 6.629536310831706],
      ['2024-06-26T13:40:00Z', 6.633478164672852],
      ['2024-06-26T13:41:00Z', 6.620889663696289],
      ['2024-06-26T13:42:00Z', 6.611162066459656],
      ['2024-06-26T13:43:00Z', 6.613260269165039],
      ['2024-06-26T13:44:00Z', 6.613832354545593],
      ['2024-06-26T13:45:00Z', 6.61802864074707],
      ['2024-06-26T13:46:00Z', 6.631189465522766],
      ['2024-06-26T13:47:00Z', 6.671244382858276],
      ['2024-06-26T13:48:00Z', 6.701190233230591],
      ['2024-06-26T13:49:00Z', 6.474593758583069],
      ['2024-06-26T13:50:00Z', 6.261539578437805],
      ['2024-06-26T13:51:00Z', 6.330205202102661],
      ['2024-06-26T13:52:00Z', 6.358815908432007],
      ['2024-06-26T13:53:00Z', 6.3927671909332275],
      ['2024-06-26T13:54:00Z', 6.443312764167786],
      ['2024-06-26T13:55:00Z', 6.503013730049133],
      ['2024-06-26T13:56:00Z', 6.58712899684906],
      ['2024-06-26T13:57:00Z', 6.703669786453247],
      ['2024-06-26T13:58:00Z', 6.762226223945618],
      ['2024-06-26T13:59:00Z', 6.421759486198425],
      ['2024-06-26T14:00:00Z', 6.353475213050842],
      ['2024-06-26T14:01:00Z', 6.382848739624023],
      ['2024-06-26T14:02:00Z', 6.361677050590515],
      ['2024-06-26T14:03:00Z', 6.333066463470459],
      ['2024-06-26T14:04:00Z', 6.328107118606567],
      ['2024-06-26T14:05:00Z', 6.350423336029053],
      ['2024-06-26T14:06:00Z', 6.386472940444946],
      ['2024-06-26T14:07:00Z', 6.458571791648865],
      ['2024-06-26T14:08:00Z', 6.492523193359375],
      ['2024-06-26T14:09:00Z', 6.481078743934631],
      ['2024-06-26T14:10:00Z', 6.456664323806763],
      ['2024-06-26T14:11:00Z', 6.462577223777771],
      ['2024-06-26T14:12:00Z', 6.542114973068237],
      ['2024-06-26T14:13:00Z', 6.630617260932922],
      ['2024-06-26T14:14:00Z', 6.6653313636779785],
      ['2024-06-26T14:15:00Z', 6.678492546081543],
      ['2024-06-26T14:16:00Z', 6.706340154012044],
      ['2024-06-26T14:17:00Z', 6.446555256843567],
      ['2024-06-26T14:18:00Z', 6.323338627815247],
      ['2024-06-26T14:19:00Z', 6.407644748687744],
      ['2024-06-26T14:20:00Z', 6.45628297328949],
      ['2024-06-26T14:21:00Z', 6.507718563079834],
      ['2024-06-26T14:22:00Z', 6.531115690867106],
      ['2024-06-26T14:23:00Z', 6.553177714347839],
      ['2024-06-26T14:24:00Z', 6.606202840805054],
      ['2024-06-26T14:25:00Z', 6.654650092124939],
      ['2024-06-26T14:26:00Z', 6.717784404754639],
      ['2024-06-26T14:27:00Z', 6.716639995574951],
      ['2024-06-26T14:28:00Z', 6.316090703010559],
      ['2024-06-26T14:29:00Z', 6.235217809677124],
      ['2024-06-26T14:30:00Z', 6.344319820404053],
      ['2024-06-26T14:31:00Z', 6.375473658243815],
      ['2024-06-26T14:32:00Z', 6.382848739624023],
      ['2024-06-26T14:33:00Z', 6.428435206413269],
      ['2024-06-26T14:34:00Z', 6.413748383522034],
      ['2024-06-26T14:35:00Z', 6.4238574504852295],
      ['2024-06-26T14:36:00Z', 6.442931175231934],
      ['2024-06-26T14:37:00Z', 6.4557106494903564],
      ['2024-06-26T14:38:00Z', 6.486610174179077],
      ['2024-06-26T14:39:00Z', 6.520434379577637],
      ['2024-06-26T14:40:00Z', 6.514839291572571],
      ['2024-06-26T14:41:00Z', 6.5369648933410645],
      ['2024-06-26T14:42:00Z', 6.627946853637695],
      ['2024-06-26T14:43:00Z', 6.725986123085022],
      ['2024-06-26T14:44:00Z', 6.783970355987549],
      ['2024-06-26T14:45:00Z', 6.436446189880371],
      ['2024-06-26T14:46:00Z', 6.277180194854736],
      ['2024-06-26T14:47:00Z', 6.4511330127716064],
      ['2024-06-26T14:48:00Z', 6.566720008850098],
      ['2024-06-26T14:49:00Z', 6.663233518600464],
      ['2024-06-26T14:50:00Z', 6.7730982303619385],
      ['2024-06-26T14:51:00Z', 6.619935870170593],
      ['2024-06-26T14:52:00Z', 6.428816556930542],
      ['2024-06-26T14:53:00Z', 6.5756847858428955],
      ['2024-06-26T14:54:00Z', 6.71797502040863],
      ['2024-06-26T14:55:00Z', 6.806858777999878],
      ['2024-06-26T14:56:00Z', 6.480125188827515],
      ['2024-06-26T14:57:00Z', 6.209659099578857],
      ['2024-06-26T14:58:00Z', 6.1884870529174805],
      ['2024-06-26T14:59:00Z', 6.164899031321208],
      ['2024-06-26T15:00:00Z', 6.144617319107056],
      ['2024-06-26T15:01:00Z', 6.128786087036133],
      ['2024-06-26T15:02:00Z', 6.101129174232483],
      ['2024-06-26T15:03:00Z', 6.20380973815918],
      ['2024-06-26T15:04:00Z', 6.4663920402526855],
      ['2024-06-26T15:05:00Z', 6.598191976547241],
      ['2024-06-26T15:06:00Z', 6.71339750289917],
      ['2024-06-26T15:07:00Z', 6.560235023498535],
      ['2024-06-26T15:08:00Z', 6.387617230415344],
      ['2024-06-26T15:09:00Z', 6.519226312637329],
      ['2024-06-26T15:10:00Z', 6.645494699478149],
      ['2024-06-26T15:11:00Z', 6.765278100967407],
      ['2024-06-26T15:12:00Z', 6.7210270166397095],
      ['2024-06-26T15:13:00Z', 6.324483036994934],
      ['2024-06-26T15:14:00Z', 6.230258464813232],
      ['2024-06-26T15:15:00Z', 6.217288494110107],
      ['2024-06-26T15:16:00Z', 6.192874073982239],
      ['2024-06-26T15:17:00Z', 6.1758348147074384],
      ['2024-06-26T15:18:00Z', 6.155298709869385],
      ['2024-06-26T15:19:00Z', 6.134317517280579],
      ['2024-06-26T15:20:00Z', 6.10837709903717],
      ['2024-06-26T15:21:00Z', 6.091210842132568],
      ['2024-06-26T15:22:00Z', 6.30693519115448],
      ['2024-06-26T15:23:00Z', 6.541161298751831],
      ['2024-06-26T15:24:00Z', 6.692034721374512],
      ['2024-06-26T15:25:00Z', 6.8060959577560425],
      ['2024-06-26T15:26:00Z', 6.503776669502258],
      ['2024-06-26T15:27:00Z', 6.258487820625305],
      ['2024-06-26T15:28:00Z', 6.257470448811849],
      ['2024-06-26T15:29:00Z', 6.250476837158203],
      ['2024-06-26T15:30:00Z', 6.247615814208984],
      ['2024-06-26T15:31:00Z', 6.230830788612366],
      ['2024-06-26T15:32:00Z', 6.22224760055542],
      ['2024-06-26T15:33:00Z', 6.204699754714966],
      ['2024-06-26T15:34:00Z', 6.185244560241699],
      ['2024-06-26T15:35:00Z', 6.12993061542511],
      ['2024-06-26T15:36:00Z', 6.0667964220047],
      ['2024-06-26T15:37:00Z', 6.063553810119629],
      ['2024-06-26T15:38:00Z', 6.371786117553711],
      ['2024-06-26T15:39:00Z', 6.453040361404419],
      ['2024-06-26T15:40:00Z', 6.513122797012329],
      ['2024-06-26T15:41:00Z', 6.586366057395935],
      ['2024-06-26T15:42:00Z', 6.6569390296936035],
      ['2024-06-26T15:43:00Z', 6.645494699478149],
      ['2024-06-26T15:44:00Z', 6.283665180206299],
      ['2024-06-26T15:45:00Z', 6.164263367652893],
      ['2024-06-26T15:46:00Z', 6.108567833900452],
      ['2024-06-26T15:47:00Z', 6.124780654907227],
      ['2024-06-26T15:48:00Z', 6.384565353393555],
      ['2024-06-26T15:49:00Z', 6.429007411003113],
      ['2024-06-26T15:50:00Z', 6.462195873260498],
    ],
    flowM3Min: [
      ['2024-06-25T15:52:00Z', 35.850114822387695],
      ['2024-06-25T15:53:00Z', 35.459527015686035],
      ['2024-06-25T15:54:00Z', 35.4896240234375],
      ['2024-06-25T15:55:00Z', 35.45348612467448],
      ['2024-06-25T15:56:00Z', 35.08853340148926],
      ['2024-06-25T15:57:00Z', 35.75065326690674],
      ['2024-06-25T15:58:00Z', 35.60140609741211],
      ['2024-06-25T15:59:00Z', 35.22535419464111],
      ['2024-06-25T16:00:00Z', 34.38497066497803],
      ['2024-06-25T16:01:00Z', 32.973663330078125],
      ['2024-06-25T16:02:00Z', 32.53098392486572],
      ['2024-06-25T16:03:00Z', 32.441786766052246],
      ['2024-06-25T16:04:00Z', 32.96134281158447],
      ['2024-06-25T16:05:00Z', 32.42192792892456],
      ['2024-06-25T16:06:00Z', 32.10519313812256],
      ['2024-06-25T16:07:00Z', 31.96390199661255],
      ['2024-06-25T16:08:00Z', 34.03179931640625],
      ['2024-06-25T16:09:00Z', 34.72813320159912],
      ['2024-06-25T16:10:00Z', 34.61911678314209],
      ['2024-06-25T16:11:00Z', 35.17843437194824],
      ['2024-06-25T16:12:00Z', 35.85255146026611],
      ['2024-06-25T16:13:00Z', 36.53831958770752],
      ['2024-06-25T16:14:00Z', 35.632405598958336],
      ['2024-06-25T16:15:00Z', 34.55807971954346],
      ['2024-06-25T16:16:00Z', 33.58300018310547],
      ['2024-06-25T16:17:00Z', 33.00308322906494],
      ['2024-06-25T16:18:00Z', 33.496697425842285],
      ['2024-06-25T16:19:00Z', 32.2130241394043],
      ['2024-06-25T16:20:00Z', 33.3799409866333],
      ['2024-06-25T16:21:00Z', 34.49650764465332],
      ['2024-06-25T16:22:00Z', 34.9459753036499],
      ['2024-06-25T16:23:00Z', 37.13127517700195],
      ['2024-06-25T16:24:00Z', 36.19059753417969],
      ['2024-06-25T16:25:00Z', 36.14083766937256],
      ['2024-06-25T16:26:00Z', 34.97006416320801],
      ['2024-06-25T16:27:00Z', 35.499768575032554],
      ['2024-06-25T16:28:00Z', 35.90522289276123],
      ['2024-06-25T16:29:00Z', 34.744585037231445],
      ['2024-06-25T16:30:00Z', 33.8484582901001],
      ['2024-06-25T16:31:00Z', 34.23742485046387],
      ['2024-06-25T16:32:00Z', 34.37709999084473],
      ['2024-06-25T16:33:00Z', 34.29756832122803],
      ['2024-06-25T16:34:00Z', 35.47398090362549],
      ['2024-06-25T16:35:00Z', 35.161712646484375],
      ['2024-06-25T16:36:00Z', 35.469757080078125],
      ['2024-06-25T16:37:00Z', 35.27158164978027],
      ['2024-06-25T16:38:00Z', 36.0911865234375],
      ['2024-06-25T16:39:00Z', 37.28139305114746],
      ['2024-06-25T16:40:00Z', 37.21455097198486],
      ['2024-06-25T16:41:00Z', 36.50556468963623],
      ['2024-06-25T16:42:00Z', 37.36422856648763],
      ['2024-06-25T16:43:00Z', 35.91780090332031],
      ['2024-06-25T16:44:00Z', 34.67742919921875],
      ['2024-06-25T16:45:00Z', 35.550522804260254],
      ['2024-06-25T16:46:00Z', 36.731560707092285],
      ['2024-06-25T16:47:00Z', 36.533617655436196],
      ['2024-06-25T16:48:00Z', 36.595505714416504],
      ['2024-06-25T16:49:00Z', 34.78542995452881],
      ['2024-06-25T16:50:00Z', 32.33028268814087],
      ['2024-06-25T16:51:00Z', 32.85163593292236],
      ['2024-06-25T16:52:00Z', 33.016329765319824],
      ['2024-06-25T16:53:00Z', 32.236806869506836],
      ['2024-06-25T16:54:00Z', 31.82426691055298],
      ['2024-06-25T16:55:00Z', 32.97940731048584],
      ['2024-06-25T16:56:00Z', 32.256157875061035],
      ['2024-06-25T16:57:00Z', 32.168598651885986],
      ['2024-06-25T16:58:00Z', 30.811909357706707],
      ['2024-06-25T16:59:00Z', 31.401349544525146],
      ['2024-06-25T17:00:00Z', 30.887461185455322],
      ['2024-06-25T17:01:00Z', 30.137858390808105],
      ['2024-06-25T17:02:00Z', 10.171724081039429],
      ['2024-06-25T17:03:00Z', 25.474493503570557],
      ['2024-06-25T17:04:00Z', 31.869771003723145],
      ['2024-06-25T17:05:00Z', 30.769476890563965],
      ['2024-06-25T17:06:00Z', 31.123887538909912],
      ['2024-06-25T17:07:00Z', 31.128041744232178],
      ['2024-06-25T17:08:00Z', 23.09481692314148],
      ['2024-06-25T17:09:00Z', 24.286409616470337],
      ['2024-06-25T17:10:00Z', 30.597455501556396],
      ['2024-06-25T17:11:00Z', 30.922780513763428],
      ['2024-06-25T17:12:00Z', 30.23628870646159],
      ['2024-06-25T17:13:00Z', 25.61080773671468],
      ['2024-06-25T17:14:00Z', 14.93565845489502],
      ['2024-06-25T17:15:00Z', 26.17091703414917],
      ['2024-06-25T17:16:00Z', 26.460439682006836],
      ['2024-06-25T17:17:00Z', 41.82430839538574],
      ['2024-06-25T17:18:00Z', 34.110042572021484],
      ['2024-06-25T17:19:00Z', 32.03280544281006],
      ['2024-06-25T17:20:00Z', 32.25309944152832],
      ['2024-06-25T17:21:00Z', 33.00370693206787],
      ['2024-06-25T17:22:00Z', 32.59009122848511],
      ['2024-06-25T17:23:00Z', 32.0059380531311],
      ['2024-06-25T17:24:00Z', 32.36226145426432],
      ['2024-06-25T17:25:00Z', 33.08473205566406],
      ['2024-06-25T17:26:00Z', 32.07279523213705],
      ['2024-06-25T17:27:00Z', 33.22149181365967],
      ['2024-06-25T17:28:00Z', 32.88992786407471],
      ['2024-06-25T17:29:00Z', 33.448580741882324],
      ['2024-06-25T17:30:00Z', 33.9530668258667],
      ['2024-06-25T17:31:00Z', 32.735050201416016],
      ['2024-06-25T17:32:00Z', 32.83497714996338],
      ['2024-06-25T17:33:00Z', 32.807190895080566],
      ['2024-06-25T17:34:00Z', 33.642727851867676],
      ['2024-06-25T17:35:00Z', 33.70250701904297],
      ['2024-06-25T17:36:00Z', 33.25209331512451],
      ['2024-06-25T17:37:00Z', 33.698628425598145],
      ['2024-06-25T17:38:00Z', 33.197279930114746],
      ['2024-06-25T17:39:00Z', 35.35388946533203],
      ['2024-06-25T17:40:00Z', 34.93812847137451],
      ['2024-06-25T17:41:00Z', 35.791306495666504],
      ['2024-06-25T17:42:00Z', 36.019089698791504],
      ['2024-06-25T17:43:00Z', 35.67585754394531],
      ['2024-06-25T17:44:00Z', 36.452059745788574],
      ['2024-06-25T17:45:00Z', 36.25998783111572],
      ['2024-06-25T17:46:00Z', 36.72475719451904],
      ['2024-06-25T17:47:00Z', 35.5066614151001],
      ['2024-06-25T17:48:00Z', 33.47426748275757],
      ['2024-06-25T17:49:00Z', 32.45870351791382],
      ['2024-06-25T17:50:00Z', 33.24035453796387],
      ['2024-06-25T17:51:00Z', 33.60962390899658],
      ['2024-06-25T17:52:00Z', 32.96312379837036],
      ['2024-06-25T17:53:00Z', 32.51284122467041],
      ['2024-06-25T17:54:00Z', 33.35142135620117],
      ['2024-06-25T17:55:00Z', 33.741238594055176],
      ['2024-06-25T17:56:00Z', 34.28098678588867],
      ['2024-06-25T17:57:00Z', 34.024489084879555],
      ['2024-06-25T17:58:00Z', 34.42134189605713],
      ['2024-06-25T17:59:00Z', 33.51498031616211],
      ['2024-06-25T18:00:00Z', 33.06752061843872],
      ['2024-06-25T18:01:00Z', 33.15048408508301],
      ['2024-06-25T18:02:00Z', 32.64764213562012],
      ['2024-06-25T18:03:00Z', 33.010276794433594],
      ['2024-06-25T18:04:00Z', 33.62836456298828],
      ['2024-06-25T18:05:00Z', 32.59281539916992],
      ['2024-06-25T18:06:00Z', 33.179009437561035],
      ['2024-06-25T18:07:00Z', 33.37698173522949],
      ['2024-06-25T18:08:00Z', 34.22330570220947],
      ['2024-06-25T18:09:00Z', 34.220778465270996],
      ['2024-06-25T18:10:00Z', 34.505863189697266],
      ['2024-06-25T18:11:00Z', 34.02644443511963],
      ['2024-06-25T18:12:00Z', 33.427120208740234],
      ['2024-06-25T18:13:00Z', 34.27944850921631],
      ['2024-06-25T18:14:00Z', 33.85795021057129],
      ['2024-06-25T18:15:00Z', 33.72585678100586],
      ['2024-06-25T18:16:00Z', 34.563035011291504],
      ['2024-06-25T18:17:00Z', 33.2790158589681],
      ['2024-06-25T18:18:00Z', 33.24049186706543],
      ['2024-06-25T18:19:00Z', 33.157236099243164],
      ['2024-06-25T18:20:00Z', 34.08883762359619],
      ['2024-06-25T18:21:00Z', 33.168680826822914],
      ['2024-06-25T18:22:00Z', 33.55116081237793],
      ['2024-06-25T18:23:00Z', 35.27372487386068],
      ['2024-06-25T18:24:00Z', 35.2522497177124],
      ['2024-06-25T18:25:00Z', 34.87690448760986],
      ['2024-06-25T18:26:00Z', 34.31095886230469],
      ['2024-06-25T18:27:00Z', 33.85789108276367],
      ['2024-06-25T18:28:00Z', 33.15544509887695],
      ['2024-06-25T18:29:00Z', 33.3506825764974],
      ['2024-06-25T18:30:00Z', 33.01498794555664],
      ['2024-06-25T18:31:00Z', 32.40043640136719],
      ['2024-06-25T18:32:00Z', 32.50009775161743],
      ['2024-06-25T18:33:00Z', 33.74420642852783],
      ['2024-06-25T18:34:00Z', 31.591169357299805],
      ['2024-06-25T18:35:00Z', 31.25380802154541],
      ['2024-06-25T18:36:00Z', 32.33139991760254],
      ['2024-06-25T18:37:00Z', 32.16327428817749],
      ['2024-06-25T18:38:00Z', 31.721137523651123],
      ['2024-06-25T18:39:00Z', 31.06586456298828],
      ['2024-06-25T18:40:00Z', 27.989360332489014],
      ['2024-06-25T18:41:00Z', 19.391570329666138],
      ['2024-06-25T18:42:00Z', 30.862968921661377],
      ['2024-06-25T18:43:00Z', 31.602869510650635],
      ['2024-06-25T18:44:00Z', 30.88839340209961],
      ['2024-06-25T18:45:00Z', 31.0053284962972],
      ['2024-06-25T18:46:00Z', 28.839145183563232],
      ['2024-06-25T18:47:00Z', 11.18528413772583],
      ['2024-06-25T18:48:00Z', 28.854145526885986],
      ['2024-06-25T18:49:00Z', 32.369696617126465],
      ['2024-06-25T18:50:00Z', 31.452232837677002],
      ['2024-06-25T18:51:00Z', 31.086782455444336],
      ['2024-06-25T18:52:00Z', 31.358354568481445],
      ['2024-06-25T18:53:00Z', 30.918349742889404],
      ['2024-06-25T18:54:00Z', 19.117263078689575],
      ['2024-06-25T18:55:00Z', 19.05625057220459],
      ['2024-06-25T18:56:00Z', 26.92356300354004],
      ['2024-06-25T18:57:00Z', 32.81096839904785],
      ['2024-06-25T18:58:00Z', 31.6408371925354],
      ['2024-06-25T18:59:00Z', 30.71189594268799],
      ['2024-06-25T19:00:00Z', 30.99517567952474],
      ['2024-06-25T19:01:00Z', 22.52393627166748],
      ['2024-06-25T19:02:00Z', 23.90560221672058],
      ['2024-06-25T19:03:00Z', 29.621337890625],
      ['2024-06-25T19:04:00Z', 29.53180170059204],
      ['2024-06-25T19:05:00Z', 21.36129633585612],
      ['2024-06-25T19:06:00Z', 8.571125626564026],
      ['2024-06-25T19:07:00Z', 23.788184881210327],
      ['2024-06-25T19:08:00Z', 30.432488441467285],
      ['2024-06-25T19:09:00Z', 29.762825965881348],
      ['2024-06-25T19:10:00Z', 26.68453852335612],
      ['2024-06-25T19:11:00Z', 12.129162311553955],
      ['2024-06-25T19:12:00Z', 13.314558506011963],
      ['2024-06-25T19:13:00Z', 30.205697059631348],
      ['2024-06-25T19:14:00Z', 28.74967908859253],
      ['2024-06-25T19:15:00Z', 15.832926273345947],
      ['2024-06-25T19:16:00Z', 10.954163789749146],
      ['2024-06-25T19:17:00Z', 20.255825757980347],
      ['2024-06-25T19:18:00Z', 27.989433765411377],
      ['2024-06-25T19:19:00Z', 6.159326434135437],
      ['2024-06-25T19:20:00Z', 11.794604063034058],
      ['2024-06-25T19:21:00Z', 19.38278865814209],
      ['2024-06-25T19:22:00Z', 17.080501079559326],
      ['2024-06-25T19:23:00Z', 18.350436687469482],
      ['2024-06-25T19:24:00Z', 18.294790744781494],
      ['2024-06-25T19:25:00Z', 18.18897771835327],
      ['2024-06-25T19:26:00Z', 18.1528058052063],
      ['2024-06-25T19:27:00Z', 18.05327033996582],
      ['2024-06-25T19:28:00Z', 17.569246292114258],
      ['2024-06-25T19:29:00Z', 17.57912540435791],
      ['2024-06-25T19:30:00Z', 17.756848335266113],
      ['2024-06-25T19:31:00Z', 17.322154998779297],
      ['2024-06-25T19:32:00Z', 18.481884956359863],
      ['2024-06-25T19:33:00Z', 17.54788827896118],
      ['2024-06-25T19:34:00Z', 17.72559690475464],
      ['2024-06-25T19:35:00Z', 17.987778663635254],
      ['2024-06-25T19:36:00Z', 17.384693145751953],
      ['2024-06-25T19:37:00Z', 17.83584467569987],
      ['2024-06-25T19:38:00Z', 17.48238229751587],
      ['2024-06-25T19:39:00Z', 17.406381130218506],
      ['2024-06-25T19:40:00Z', 16.85774294535319],
      ['2024-06-25T19:41:00Z', 17.41987943649292],
      ['2024-06-25T19:42:00Z', 17.320122400919598],
      ['2024-06-25T19:43:00Z', 17.747382164001465],
      ['2024-06-25T19:44:00Z', 17.48772621154785],
      ['2024-06-25T19:45:00Z', 16.179325342178345],
      ['2024-06-25T19:46:00Z', 13.075628757476807],
      ['2024-06-25T19:47:00Z', 14.068727493286133],
      ['2024-06-25T19:48:00Z', 14.116353273391724],
      ['2024-06-25T19:49:00Z', 14.385798215866089],
      ['2024-06-25T19:50:00Z', 14.300023794174194],
      ['2024-06-25T19:51:00Z', 13.535076379776001],
      ['2024-06-25T19:52:00Z', 13.635693311691284],
      ['2024-06-25T19:53:00Z', 13.97627854347229],
      ['2024-06-25T19:54:00Z', 13.581698179244995],
      ['2024-06-25T19:55:00Z', 13.797182559967041],
      ['2024-06-25T19:56:00Z', 14.045089721679688],
      ['2024-06-25T19:57:00Z', 14.279024600982666],
      ['2024-06-25T19:58:00Z', 13.776235818862915],
      ['2024-06-25T19:59:00Z', 13.718804597854614],
      ['2024-06-25T20:00:00Z', 13.796701908111572],
      ['2024-06-25T20:01:00Z', 13.826222658157349],
      ['2024-06-25T20:02:00Z', 13.959969758987427],
      ['2024-06-25T20:03:00Z', 13.738336086273193],
      ['2024-06-25T20:04:00Z', 13.859585046768188],
      ['2024-06-25T20:05:00Z', 13.237651189168295],
      ['2024-06-25T20:06:00Z', 13.482098579406738],
      ['2024-06-25T20:07:00Z', 13.614789724349976],
      ['2024-06-25T20:08:00Z', 13.767758846282959],
      ['2024-06-25T20:09:00Z', 14.102720499038696],
      ['2024-06-25T20:10:00Z', 13.78027629852295],
      ['2024-06-25T20:11:00Z', 13.734247922897339],
      ['2024-06-25T20:12:00Z', 13.957246780395508],
      ['2024-06-25T20:13:00Z', 13.693326473236084],
      ['2024-06-25T20:14:00Z', 14.202365636825562],
      ['2024-06-25T20:15:00Z', 14.3433678150177],
      ['2024-06-25T20:16:00Z', 13.749531428019205],
      ['2024-06-25T20:17:00Z', 13.67948579788208],
      ['2024-06-25T20:18:00Z', 13.76113510131836],
      ['2024-06-25T20:19:00Z', 13.550615310668945],
      ['2024-06-25T20:20:00Z', 13.685050010681152],
      ['2024-06-25T20:21:00Z', 13.806849479675293],
      ['2024-06-25T20:22:00Z', 13.414997100830078],
      ['2024-06-25T20:23:00Z', 13.932855129241943],
      ['2024-06-25T20:24:00Z', 13.687839269638062],
      ['2024-06-25T20:25:00Z', 13.769436359405518],
      ['2024-06-25T20:26:00Z', 13.50904369354248],
      ['2024-06-25T20:27:00Z', 13.673278331756592],
      ['2024-06-25T20:28:00Z', 13.681527773539225],
      ['2024-06-25T20:29:00Z', 13.756515741348267],
      ['2024-06-25T20:30:00Z', 13.803937673568726],
      ['2024-06-25T20:31:00Z', 12.91830587387085],
      ['2024-06-25T20:32:00Z', 13.529342651367188],
      ['2024-06-25T20:33:00Z', 13.215389251708984],
      ['2024-06-25T20:34:00Z', 13.572951793670654],
      ['2024-06-25T20:35:00Z', 13.461608171463013],
      ['2024-06-25T20:36:00Z', 13.165191888809204],
      ['2024-06-25T20:37:00Z', 13.39181137084961],
      ['2024-06-25T20:38:00Z', 12.805398225784302],
      ['2024-06-25T20:39:00Z', 13.32294249534607],
      ['2024-06-25T20:40:00Z', 13.380385398864746],
      ['2024-06-25T20:41:00Z', 13.50638484954834],
      ['2024-06-25T20:42:00Z', 13.634305953979492],
      ['2024-06-25T20:43:00Z', 13.3080685933431],
      ['2024-06-25T20:44:00Z', 12.893061399459839],
      ['2024-06-25T20:45:00Z', 12.845364570617676],
      ['2024-06-25T20:46:00Z', 13.085347175598145],
      ['2024-06-25T20:47:00Z', 12.84631609916687],
      ['2024-06-25T20:48:00Z', 12.864600658416748],
      ['2024-06-25T20:49:00Z', 12.763427734375],
      ['2024-06-25T20:50:00Z', 12.963725805282593],
      ['2024-06-25T20:51:00Z', 12.682991027832031],
      ['2024-06-25T20:52:00Z', 13.549478530883789],
      ['2024-06-25T20:53:00Z', 13.000988960266113],
      ['2024-06-25T20:54:00Z', 13.342701435089111],
      ['2024-06-25T20:55:00Z', 13.810771465301514],
      ['2024-06-25T20:56:00Z', 13.399929523468018],
      ['2024-06-25T20:57:00Z', 13.394619941711426],
      ['2024-06-25T20:58:00Z', 13.27490496635437],
      ['2024-06-25T20:59:00Z', 14.192235310872396],
      ['2024-06-25T21:00:00Z', 13.326389789581299],
      ['2024-06-25T21:01:00Z', 13.901910066604614],
      ['2024-06-25T21:02:00Z', 13.817987124125162],
      ['2024-06-25T21:03:00Z', 13.362482070922852],
      ['2024-06-25T21:04:00Z', 13.755061149597168],
      ['2024-06-25T21:05:00Z', 13.13239598274231],
      ['2024-06-25T21:06:00Z', 13.426990747451782],
      ['2024-06-25T21:07:00Z', 13.447623252868652],
      ['2024-06-25T21:08:00Z', 13.669668912887573],
      ['2024-06-25T21:09:00Z', 13.378546714782715],
      ['2024-06-25T21:10:00Z', 13.49180555343628],
      ['2024-06-25T21:11:00Z', 13.55086898803711],
      ['2024-06-25T21:12:00Z', 13.464088678359985],
      ['2024-06-25T21:13:00Z', 13.397681713104248],
      ['2024-06-25T21:14:00Z', 13.362046718597412],
      ['2024-06-25T21:15:00Z', 14.022504568099976],
      ['2024-06-25T21:16:00Z', 13.415023803710938],
      ['2024-06-25T21:17:00Z', 13.22668981552124],
      ['2024-06-25T21:18:00Z', 13.53542160987854],
      ['2024-06-25T21:19:00Z', 13.255609512329102],
      ['2024-06-25T21:20:00Z', 13.71010971069336],
      ['2024-06-25T21:21:00Z', 14.389063835144043],
      ['2024-06-25T21:22:00Z', 13.278398036956787],
      ['2024-06-25T21:23:00Z', 14.273857116699219],
      ['2024-06-25T21:24:00Z', 13.382124900817871],
      ['2024-06-25T21:25:00Z', 13.47735595703125],
      ['2024-06-25T21:26:00Z', 13.800158739089966],
      ['2024-06-25T21:27:00Z', 13.784113883972168],
      ['2024-06-25T21:28:00Z', 13.930012702941895],
      ['2024-06-25T21:29:00Z', 13.570473194122314],
      ['2024-06-25T21:30:00Z', 13.996977170308432],
      ['2024-06-25T21:31:00Z', 13.74037480354309],
      ['2024-06-25T21:32:00Z', 14.223205089569092],
      ['2024-06-25T21:33:00Z', 13.517709016799927],
      ['2024-06-25T21:34:00Z', 13.836346864700317],
      ['2024-06-25T21:35:00Z', 13.92870569229126],
      ['2024-06-25T21:36:00Z', 14.25686764717102],
      ['2024-06-25T21:37:00Z', 14.524594942728678],
      ['2024-06-25T21:38:00Z', 14.015224933624268],
      ['2024-06-25T21:39:00Z', 13.886300086975098],
      ['2024-06-25T21:40:00Z', 13.845306158065796],
      ['2024-06-25T21:41:00Z', 13.964574575424194],
      ['2024-06-25T21:42:00Z', 14.058871746063232],
      ['2024-06-25T21:43:00Z', 13.709630966186523],
      ['2024-06-25T21:44:00Z', 13.723961591720581],
      ['2024-06-25T21:45:00Z', 13.861840009689331],
      ['2024-06-25T21:46:00Z', 14.135698080062866],
      ['2024-06-25T21:47:00Z', 14.032054901123047],
      ['2024-06-25T21:48:00Z', 13.928988695144653],
      ['2024-06-25T21:49:00Z', 13.789645195007324],
      ['2024-06-25T21:50:00Z', 13.845882415771484],
      ['2024-06-25T21:51:00Z', 13.333181619644165],
      ['2024-06-25T21:52:00Z', 14.050791501998901],
      ['2024-06-25T21:53:00Z', 13.708196640014648],
      ['2024-06-25T21:54:00Z', 14.153793573379517],
      ['2024-06-25T21:55:00Z', 13.836733102798462],
      ['2024-06-25T21:56:00Z', 13.862285137176514],
      ['2024-06-25T21:57:00Z', 14.000014940897623],
      ['2024-06-25T21:58:00Z', 13.949306964874268],
      ['2024-06-25T21:59:00Z', 14.033440113067627],
      ['2024-06-25T22:00:00Z', 13.828045129776001],
      ['2024-06-25T22:01:00Z', 13.884819984436035],
      ['2024-06-25T22:02:00Z', 14.138257026672363],
      ['2024-06-25T22:03:00Z', 13.924271821975708],
      ['2024-06-25T22:04:00Z', 14.2574942111969],
      ['2024-06-25T22:05:00Z', 14.541347821553549],
      ['2024-06-25T22:06:00Z', 14.869282007217407],
      ['2024-06-25T22:07:00Z', 16.487345695495605],
      ['2024-06-25T22:08:00Z', 16.00985860824585],
      ['2024-06-25T22:09:00Z', 15.480533599853516],
      ['2024-06-25T22:10:00Z', 15.302127361297607],
      ['2024-06-25T22:11:00Z', 15.759128093719482],
      ['2024-06-25T22:12:00Z', 15.13315463066101],
      ['2024-06-25T22:13:00Z', 15.194079160690308],
      ['2024-06-25T22:14:00Z', 15.458579063415527],
      ['2024-06-25T22:15:00Z', 14.89927339553833],
      ['2024-06-25T22:16:00Z', 15.353398084640503],
      ['2024-06-25T22:17:00Z', 15.021165132522583],
      ['2024-06-25T22:18:00Z', 15.58113169670105],
      ['2024-06-25T22:19:00Z', 15.644670963287354],
      ['2024-06-25T22:20:00Z', 15.523184776306152],
      ['2024-06-25T22:21:00Z', 15.46509337425232],
      ['2024-06-25T22:22:00Z', 15.802083730697632],
      ['2024-06-25T22:23:00Z', 16.779536565144856],
      ['2024-06-25T22:24:00Z', 15.979065418243408],
      ['2024-06-25T22:25:00Z', 15.910293102264404],
      ['2024-06-25T22:26:00Z', 15.445453643798828],
      ['2024-06-25T22:27:00Z', 14.77628755569458],
      ['2024-06-25T22:28:00Z', 15.178640365600586],
      ['2024-06-25T22:29:00Z', 14.765073458353678],
      ['2024-06-25T22:30:00Z', 15.957871437072754],
      ['2024-06-25T22:31:00Z', 15.948479890823364],
      ['2024-06-25T22:32:00Z', 18.272504329681396],
      ['2024-06-25T22:33:00Z', 16.351298570632935],
      ['2024-06-25T22:34:00Z', 16.0173282623291],
      ['2024-06-25T22:35:00Z', 16.259316205978394],
      ['2024-06-25T22:36:00Z', 16.61156972249349],
      ['2024-06-25T22:37:00Z', 16.017496347427368],
      ['2024-06-25T22:38:00Z', 15.68614912033081],
      ['2024-06-25T22:39:00Z', 15.368486086527506],
      ['2024-06-25T22:40:00Z', 15.036925077438354],
      ['2024-06-25T22:41:00Z', 15.45629334449768],
      ['2024-06-25T22:42:00Z', 15.972012837727865],
      ['2024-06-25T22:43:00Z', 16.81970500946045],
      ['2024-06-25T22:44:00Z', 17.22872018814087],
      ['2024-06-25T22:45:00Z', 16.2643985748291],
      ['2024-06-25T22:46:00Z', 16.611782550811768],
      ['2024-06-25T22:47:00Z', 15.736176490783691],
      ['2024-06-25T22:48:00Z', 15.586360454559326],
      ['2024-06-25T22:49:00Z', 15.764297723770142],
      ['2024-06-25T22:50:00Z', 16.857571125030518],
      ['2024-06-25T22:51:00Z', 18.480342388153076],
      ['2024-06-25T22:52:00Z', 18.282243728637695],
      ['2024-06-25T22:53:00Z', 17.266249656677246],
      ['2024-06-25T22:54:00Z', 15.846257209777832],
      ['2024-06-25T22:55:00Z', 15.534820795059204],
      ['2024-06-25T22:56:00Z', 16.012025356292725],
      ['2024-06-25T22:57:00Z', 16.075520515441895],
      ['2024-06-25T22:58:00Z', 15.861523628234863],
      ['2024-06-25T22:59:00Z', 15.824397087097168],
      ['2024-06-25T23:00:00Z', 15.35215139389038],
      ['2024-06-25T23:01:00Z', 15.738776445388794],
      ['2024-06-25T23:02:00Z', 16.292873700459797],
      ['2024-06-25T23:03:00Z', 15.915434837341309],
      ['2024-06-25T23:04:00Z', 15.528841733932495],
      ['2024-06-25T23:05:00Z', 16.30453610420227],
      ['2024-06-25T23:06:00Z', 15.649458408355713],
      ['2024-06-25T23:07:00Z', 15.580950736999512],
      ['2024-06-25T23:08:00Z', 15.195032119750977],
      ['2024-06-25T23:09:00Z', 15.64898133277893],
      ['2024-06-25T23:10:00Z', 15.649157047271729],
      ['2024-06-25T23:11:00Z', 15.614227771759033],
      ['2024-06-25T23:12:00Z', 15.294750531514486],
      ['2024-06-25T23:13:00Z', 14.853265523910522],
      ['2024-06-25T23:14:00Z', 14.982046842575073],
      ['2024-06-25T23:15:00Z', 14.811973810195923],
      ['2024-06-25T23:16:00Z', 15.170677502950033],
      ['2024-06-25T23:17:00Z', 15.40376901626587],
      ['2024-06-25T23:18:00Z', 15.04600214958191],
      ['2024-06-25T23:19:00Z', 15.719691276550293],
      ['2024-06-25T23:20:00Z', 15.282190084457397],
      ['2024-06-25T23:21:00Z', 15.724532842636108],
      ['2024-06-25T23:22:00Z', 16.669250965118408],
      ['2024-06-25T23:23:00Z', 16.92049551010132],
      ['2024-06-25T23:24:00Z', 16.61220359802246],
      ['2024-06-25T23:25:00Z', 14.796733856201172],
      ['2024-06-25T23:26:00Z', 14.157510757446289],
      ['2024-06-25T23:27:00Z', 14.106541872024536],
      ['2024-06-25T23:28:00Z', 14.070827960968018],
      ['2024-06-25T23:29:00Z', 14.564807415008545],
      ['2024-06-25T23:30:00Z', 15.403749227523804],
      ['2024-06-25T23:31:00Z', 15.12362289428711],
      ['2024-06-25T23:32:00Z', 14.776976823806763],
      ['2024-06-25T23:33:00Z', 14.810964822769165],
      ['2024-06-25T23:34:00Z', 14.570329427719116],
      ['2024-06-25T23:35:00Z', 14.967509269714355],
      ['2024-06-25T23:36:00Z', 15.107074737548828],
      ['2024-06-25T23:37:00Z', 15.089631795883179],
      ['2024-06-25T23:38:00Z', 15.481955289840698],
      ['2024-06-25T23:39:00Z', 14.674216747283936],
      ['2024-06-25T23:40:00Z', 14.794939517974854],
      ['2024-06-25T23:41:00Z', 15.007463693618774],
      ['2024-06-25T23:42:00Z', 15.433330535888672],
      ['2024-06-25T23:43:00Z', 16.05340027809143],
      ['2024-06-25T23:44:00Z', 15.504595120747885],
      ['2024-06-25T23:45:00Z', 15.759125073750814],
      ['2024-06-25T23:46:00Z', 15.297905445098877],
      ['2024-06-25T23:47:00Z', 15.229475736618042],
      ['2024-06-25T23:48:00Z', 15.072151899337769],
      ['2024-06-25T23:49:00Z', 16.226964950561523],
      ['2024-06-25T23:50:00Z', 15.746514956156412],
      ['2024-06-25T23:51:00Z', 16.264973163604736],
      ['2024-06-25T23:52:00Z', 15.928642988204956],
      ['2024-06-25T23:53:00Z', 16.50810718536377],
      ['2024-06-25T23:54:00Z', 17.126168251037598],
      ['2024-06-25T23:55:00Z', 17.476075172424316],
      ['2024-06-25T23:56:00Z', 18.33291530609131],
      ['2024-06-25T23:57:00Z', 17.36469316482544],
      ['2024-06-25T23:58:00Z', 17.422647953033447],
      ['2024-06-25T23:59:00Z', 16.85095739364624],
      ['2024-06-26T00:00:00Z', 17.23357081413269],
      ['2024-06-26T00:01:00Z', 17.322648525238037],
      ['2024-06-26T00:02:00Z', 16.54555892944336],
      ['2024-06-26T00:03:00Z', 16.620206356048584],
      ['2024-06-26T00:04:00Z', 15.350392818450928],
      ['2024-06-26T00:05:00Z', 15.414101918538412],
      ['2024-06-26T00:06:00Z', 15.425949096679688],
      ['2024-06-26T00:07:00Z', 16.58753204345703],
      ['2024-06-26T00:08:00Z', 16.762609481811523],
      ['2024-06-26T00:09:00Z', 17.269140243530273],
      ['2024-06-26T00:10:00Z', 17.6168532371521],
      ['2024-06-26T00:11:00Z', 17.5338773727417],
      ['2024-06-26T00:12:00Z', 17.280841827392578],
      ['2024-06-26T00:13:00Z', 17.614961624145508],
      ['2024-06-26T00:14:00Z', 16.95011854171753],
      ['2024-06-26T00:15:00Z', 16.16870371500651],
      ['2024-06-26T00:16:00Z', 15.333155393600464],
      ['2024-06-26T00:17:00Z', 15.388497829437256],
      ['2024-06-26T00:18:00Z', 15.85893726348877],
      ['2024-06-26T00:19:00Z', 15.68349289894104],
      ['2024-06-26T00:20:00Z', 16.39895749092102],
      ['2024-06-26T00:21:00Z', 16.261723518371582],
      ['2024-06-26T00:22:00Z', 16.86621379852295],
      ['2024-06-26T00:23:00Z', 16.58536458015442],
      ['2024-06-26T00:24:00Z', 16.276394844055176],
      ['2024-06-26T00:25:00Z', 15.551759958267212],
      ['2024-06-26T00:26:00Z', 15.918249368667603],
      ['2024-06-26T00:27:00Z', 16.69492816925049],
      ['2024-06-26T00:28:00Z', 16.262516498565674],
      ['2024-06-26T00:29:00Z', 15.73572039604187],
      ['2024-06-26T00:30:00Z', 15.628776550292969],
      ['2024-06-26T00:31:00Z', 15.752628564834595],
      ['2024-06-26T00:32:00Z', 16.03513264656067],
      ['2024-06-26T00:33:00Z', 16.425793409347534],
      ['2024-06-26T00:34:00Z', 16.019538243611652],
      ['2024-06-26T00:35:00Z', 16.260529041290283],
      ['2024-06-26T00:36:00Z', 15.924251556396484],
      ['2024-06-26T00:37:00Z', 16.60065269470215],
      ['2024-06-26T00:38:00Z', 16.29461908340454],
      ['2024-06-26T00:39:00Z', 16.139455795288086],
      ['2024-06-26T00:40:00Z', 16.155229568481445],
      ['2024-06-26T00:41:00Z', 16.48023986816406],
      ['2024-06-26T00:42:00Z', 16.084901332855225],
      ['2024-06-26T00:43:00Z', 16.07903480529785],
      ['2024-06-26T00:44:00Z', 16.454304456710815],
      ['2024-06-26T00:45:00Z', 16.030957221984863],
      ['2024-06-26T00:46:00Z', 16.604240894317627],
      ['2024-06-26T00:47:00Z', 16.892590045928955],
      ['2024-06-26T00:48:00Z', 16.435633659362793],
      ['2024-06-26T00:49:00Z', 15.995516538619995],
      ['2024-06-26T00:50:00Z', 16.641935348510742],
      ['2024-06-26T00:51:00Z', 16.881965160369873],
      ['2024-06-26T00:52:00Z', 17.147180557250977],
      ['2024-06-26T00:53:00Z', 16.92635154724121],
      ['2024-06-26T00:54:00Z', 16.101451635360718],
      ['2024-06-26T00:55:00Z', 16.576676845550537],
      ['2024-06-26T00:56:00Z', 16.190160036087036],
      ['2024-06-26T00:57:00Z', 15.838969707489014],
      ['2024-06-26T00:58:00Z', 15.634106636047363],
      ['2024-06-26T00:59:00Z', 15.734626770019531],
      ['2024-06-26T01:00:00Z', 15.886577367782593],
      ['2024-06-26T01:01:00Z', 16.08158564567566],
      ['2024-06-26T01:02:00Z', 15.50546383857727],
      ['2024-06-26T01:03:00Z', 15.438913106918335],
      ['2024-06-26T01:04:00Z', 15.82291841506958],
      ['2024-06-26T01:05:00Z', 16.13657855987549],
      ['2024-06-26T01:06:00Z', 15.858192682266235],
      ['2024-06-26T01:07:00Z', 16.15358281135559],
      ['2024-06-26T01:08:00Z', 15.317189455032349],
      ['2024-06-26T01:09:00Z', 15.839359760284424],
      ['2024-06-26T01:10:00Z', 16.050596237182617],
      ['2024-06-26T01:11:00Z', 15.830379247665405],
      ['2024-06-26T01:12:00Z', 15.417191505432129],
      ['2024-06-26T01:13:00Z', 15.893425226211548],
      ['2024-06-26T01:14:00Z', 15.894088745117188],
      ['2024-06-26T01:15:00Z', 15.850573221842447],
      ['2024-06-26T01:16:00Z', 15.822417497634888],
      ['2024-06-26T01:17:00Z', 15.421577453613281],
      ['2024-06-26T01:18:00Z', 15.979941129684448],
      ['2024-06-26T01:19:00Z', 15.944130420684814],
      ['2024-06-26T01:20:00Z', 16.188395500183105],
      ['2024-06-26T01:21:00Z', 15.731521368026733],
      ['2024-06-26T01:22:00Z', 15.007112820943197],
      ['2024-06-26T01:23:00Z', 15.213916063308716],
      ['2024-06-26T01:24:00Z', 14.565622091293335],
      ['2024-06-26T01:25:00Z', 15.250186443328857],
      ['2024-06-26T01:26:00Z', 14.990876913070679],
      ['2024-06-26T01:27:00Z', 15.145044326782227],
      ['2024-06-26T01:28:00Z', 15.026461601257324],
      ['2024-06-26T01:29:00Z', 14.784922122955322],
      ['2024-06-26T01:30:00Z', 14.945460319519043],
      ['2024-06-26T01:31:00Z', 15.252496719360352],
      ['2024-06-26T01:32:00Z', 15.216075658798218],
      ['2024-06-26T01:33:00Z', 14.957655906677246],
      ['2024-06-26T01:34:00Z', 15.060508966445923],
      ['2024-06-26T01:35:00Z', 14.96802806854248],
      ['2024-06-26T01:36:00Z', 16.429819107055664],
      ['2024-06-26T01:37:00Z', 15.588751077651978],
      ['2024-06-26T01:38:00Z', 15.233967463175455],
      ['2024-06-26T01:39:00Z', 16.08708930015564],
      ['2024-06-26T01:40:00Z', 15.376309633255005],
      ['2024-06-26T01:41:00Z', 15.527931451797485],
      ['2024-06-26T01:42:00Z', 15.441745519638062],
      ['2024-06-26T01:43:00Z', 15.875611066818237],
      ['2024-06-26T01:44:00Z', 16.22300100326538],
      ['2024-06-26T01:45:00Z', 15.274304389953613],
      ['2024-06-26T01:46:00Z', 15.80484914779663],
      ['2024-06-26T01:47:00Z', 15.013956546783447],
      ['2024-06-26T01:48:00Z', 15.286214590072632],
      ['2024-06-26T01:49:00Z', 15.074403762817383],
      ['2024-06-26T01:50:00Z', 15.31377092997233],
      ['2024-06-26T01:51:00Z', 15.412827253341675],
      ['2024-06-26T01:52:00Z', 14.776073694229126],
      ['2024-06-26T01:53:00Z', 15.208134651184082],
      ['2024-06-26T01:54:00Z', 15.200304746627808],
      ['2024-06-26T01:55:00Z', 14.829187393188477],
      ['2024-06-26T01:56:00Z', 15.202261447906494],
      ['2024-06-26T01:57:00Z', 15.410046815872192],
      ['2024-06-26T01:58:00Z', 15.565107107162476],
      ['2024-06-26T01:59:00Z', 14.995995998382568],
      ['2024-06-26T02:00:00Z', 15.492664337158203],
      ['2024-06-26T02:01:00Z', 15.492664337158203],
      ['2024-06-26T02:02:00Z', 15.787395477294922],
      ['2024-06-26T02:03:00Z', 15.787395477294922],
      ['2024-06-26T02:04:00Z', 15.787395477294922],
      ['2024-06-26T02:05:00Z', 15.787395477294922],
      ['2024-06-26T02:06:00Z', 15.787395477294922],
      ['2024-06-26T02:07:00Z', 15.787395477294922],
      ['2024-06-26T02:08:00Z', 15.175194263458256],
      ['2024-06-26T02:09:00Z', 15.031350374221802],
      ['2024-06-26T02:10:00Z', 15.414080301920572],
      ['2024-06-26T02:11:00Z', 15.06525993347168],
      ['2024-06-26T02:12:00Z', 15.190446853637695],
      ['2024-06-26T02:13:00Z', 15.219552516937256],
      ['2024-06-26T02:14:00Z', 15.168389320373535],
      ['2024-06-26T02:15:00Z', 15.0929807027181],
      ['2024-06-26T02:16:00Z', 14.92756462097168],
      ['2024-06-26T02:17:00Z', 14.97990608215332],
      ['2024-06-26T02:18:00Z', 14.89552903175354],
      ['2024-06-26T02:19:00Z', 15.287800550460815],
      ['2024-06-26T02:20:00Z', 14.620160341262817],
      ['2024-06-26T02:21:00Z', 15.064246416091919],
      ['2024-06-26T02:22:00Z', 14.685467004776001],
      ['2024-06-26T02:23:00Z', 15.084036350250244],
      ['2024-06-26T02:24:00Z', 15.118588209152222],
      ['2024-06-26T02:25:00Z', 15.048148155212402],
      ['2024-06-26T02:26:00Z', 16.243005752563477],
      ['2024-06-26T02:27:00Z', 15.033878803253174],
      ['2024-06-26T02:28:00Z', 15.2024667263031],
      ['2024-06-26T02:29:00Z', 14.775322914123535],
      ['2024-06-26T02:30:00Z', 15.391182661056519],
      ['2024-06-26T02:31:00Z', 15.649447917938232],
      ['2024-06-26T02:32:00Z', 15.049725770950317],
      ['2024-06-26T02:33:00Z', 14.7926607131958],
      ['2024-06-26T02:34:00Z', 15.102924108505249],
      ['2024-06-26T02:35:00Z', 15.691702127456665],
      ['2024-06-26T02:36:00Z', 17.034738302230835],
      ['2024-06-26T02:37:00Z', 17.959605534871418],
      ['2024-06-26T02:38:00Z', 17.57084560394287],
      ['2024-06-26T02:39:00Z', 16.23178243637085],
      ['2024-06-26T02:40:00Z', 14.810328483581543],
      ['2024-06-26T02:41:00Z', 14.673613548278809],
      ['2024-06-26T02:42:00Z', 15.224211692810059],
      ['2024-06-26T02:43:00Z', 15.900647640228271],
      ['2024-06-26T02:44:00Z', 17.26024103164673],
      ['2024-06-26T02:45:00Z', 17.51768430074056],
      ['2024-06-26T02:46:00Z', 16.425097942352295],
      ['2024-06-26T02:47:00Z', 15.8582923412323],
      ['2024-06-26T02:48:00Z', 15.815535306930542],
      ['2024-06-26T02:49:00Z', 16.181020498275757],
      ['2024-06-26T02:50:00Z', 16.331926107406616],
      ['2024-06-26T02:51:00Z', 16.210129976272583],
      ['2024-06-26T02:52:00Z', 16.072295904159546],
      ['2024-06-26T02:53:00Z', 16.813636779785156],
      ['2024-06-26T02:54:00Z', 17.053282737731934],
      ['2024-06-26T02:55:00Z', 17.153844833374023],
      ['2024-06-26T02:56:00Z', 16.281566619873047],
      ['2024-06-26T02:57:00Z', 16.503317832946777],
      ['2024-06-26T02:58:00Z', 16.363184928894043],
      ['2024-06-26T02:59:00Z', 16.939391613006592],
      ['2024-06-26T03:00:00Z', 16.5406014919281],
      ['2024-06-26T03:01:00Z', 15.599514722824097],
      ['2024-06-26T03:02:00Z', 15.667684316635132],
      ['2024-06-26T03:03:00Z', 15.388380527496338],
      ['2024-06-26T03:04:00Z', 15.139963865280151],
      ['2024-06-26T03:05:00Z', 14.92980146408081],
      ['2024-06-26T03:06:00Z', 14.827101469039917],
      ['2024-06-26T03:07:00Z', 14.52149248123169],
      ['2024-06-26T03:08:00Z', 14.82569932937622],
      ['2024-06-26T03:09:00Z', 15.116772651672363],
      ['2024-06-26T03:10:00Z', 15.596147219340006],
      ['2024-06-26T03:11:00Z', 15.102014303207397],
      ['2024-06-26T03:12:00Z', 14.68996262550354],
      ['2024-06-26T03:13:00Z', 14.657413959503174],
      ['2024-06-26T03:14:00Z', 14.687601725260416],
      ['2024-06-26T03:15:00Z', 14.47027325630188],
      ['2024-06-26T03:16:00Z', 14.589392185211182],
      ['2024-06-26T03:17:00Z', 15.016835530598959],
      ['2024-06-26T03:18:00Z', 14.019261042277018],
      ['2024-06-26T03:19:00Z', 14.547701358795166],
      ['2024-06-26T03:20:00Z', 14.67101001739502],
      ['2024-06-26T03:21:00Z', 14.930434703826904],
      ['2024-06-26T03:22:00Z', 14.693229993184408],
      ['2024-06-26T03:23:00Z', 14.87370522816976],
      ['2024-06-26T03:24:00Z', 15.08158802986145],
      ['2024-06-26T03:25:00Z', 16.04269576072693],
      ['2024-06-26T03:26:00Z', 16.071399927139282],
      ['2024-06-26T03:27:00Z', 15.502509832382202],
      ['2024-06-26T03:28:00Z', 16.067321062088013],
      ['2024-06-26T03:29:00Z', 14.552981694539389],
      ['2024-06-26T03:30:00Z', 14.557784080505371],
      ['2024-06-26T03:31:00Z', 14.297137022018433],
      ['2024-06-26T03:32:00Z', 14.559247255325317],
      ['2024-06-26T03:33:00Z', 14.610668818155924],
      ['2024-06-26T03:34:00Z', 14.788498878479004],
      ['2024-06-26T03:35:00Z', 15.15461730957031],
      ['2024-06-26T03:36:00Z', 14.559388399124146],
      ['2024-06-26T03:37:00Z', 14.887977282206217],
      ['2024-06-26T03:38:00Z', 14.71377158164978],
      ['2024-06-26T03:39:00Z', 14.847843170166016],
      ['2024-06-26T03:40:00Z', 14.680472056070963],
      ['2024-06-26T03:41:00Z', 14.783395767211914],
      ['2024-06-26T03:42:00Z', 14.443526029586792],
      ['2024-06-26T03:43:00Z', 14.376008033752441],
      ['2024-06-26T03:44:00Z', 14.441481828689575],
      ['2024-06-26T03:45:00Z', 14.802908420562744],
      ['2024-06-26T03:46:00Z', 14.701031923294067],
      ['2024-06-26T03:47:00Z', 15.565443277359009],
      ['2024-06-26T03:48:00Z', 15.853492021560669],
      ['2024-06-26T03:49:00Z', 15.729000091552734],
      ['2024-06-26T03:50:00Z', 16.541279077529907],
      ['2024-06-26T03:51:00Z', 16.718623638153076],
      ['2024-06-26T03:52:00Z', 16.658441066741943],
      ['2024-06-26T03:53:00Z', 16.312486171722412],
      ['2024-06-26T03:54:00Z', 16.130447149276733],
      ['2024-06-26T03:55:00Z', 16.43517303466797],
      ['2024-06-26T03:56:00Z', 17.01456117630005],
      ['2024-06-26T03:57:00Z', 15.621916770935059],
      ['2024-06-26T03:58:00Z', 15.897214651107788],
      ['2024-06-26T03:59:00Z', 16.73136615753174],
      ['2024-06-26T04:00:00Z', 16.527567386627197],
      ['2024-06-26T04:01:00Z', 17.030183792114258],
      ['2024-06-26T04:02:00Z', 15.811879873275757],
      ['2024-06-26T04:03:00Z', 15.281407594680786],
      ['2024-06-26T04:04:00Z', 14.786227703094482],
      ['2024-06-26T04:05:00Z', 16.19775915145874],
      ['2024-06-26T04:06:00Z', 16.824132680892944],
      ['2024-06-26T04:07:00Z', 16.802019596099854],
      ['2024-06-26T04:08:00Z', 15.415116786956787],
      ['2024-06-26T04:09:00Z', 16.59234619140625],
      ['2024-06-26T04:10:00Z', 16.55624294281006],
      ['2024-06-26T04:11:00Z', 16.611828565597534],
      ['2024-06-26T04:12:00Z', 16.521371841430664],
      ['2024-06-26T04:13:00Z', 16.105324029922485],
      ['2024-06-26T04:14:00Z', 16.132518768310547],
      ['2024-06-26T04:15:00Z', 15.638763904571533],
      ['2024-06-26T04:16:00Z', 15.313560962677002],
      ['2024-06-26T04:17:00Z', 16.537940502166748],
      ['2024-06-26T04:18:00Z', 16.12280535697937],
      ['2024-06-26T04:19:00Z', 15.729302883148193],
      ['2024-06-26T04:20:00Z', 16.54874547322591],
      ['2024-06-26T04:21:00Z', 18.64543867111206],
      ['2024-06-26T04:22:00Z', 18.666258335113525],
      ['2024-06-26T04:23:00Z', 17.73829936981201],
      ['2024-06-26T04:24:00Z', 16.65807056427002],
      ['2024-06-26T04:25:00Z', 16.68376088142395],
      ['2024-06-26T04:26:00Z', 16.71631646156311],
      ['2024-06-26T04:27:00Z', 16.820974667867024],
      ['2024-06-26T04:28:00Z', 16.72398829460144],
      ['2024-06-26T04:29:00Z', 16.15575647354126],
      ['2024-06-26T04:30:00Z', 16.542986154556274],
      ['2024-06-26T04:31:00Z', 15.983386357625326],
      ['2024-06-26T04:32:00Z', 16.609357833862305],
      ['2024-06-26T04:33:00Z', 15.984503746032715],
      ['2024-06-26T04:34:00Z', 16.020556688308716],
      ['2024-06-26T04:35:00Z', 16.42763900756836],
      ['2024-06-26T04:36:00Z', 16.140830755233765],
      ['2024-06-26T04:37:00Z', 16.43516254425049],
      ['2024-06-26T04:38:00Z', 15.998951435089111],
      ['2024-06-26T04:39:00Z', 15.94938349723816],
      ['2024-06-26T04:40:00Z', 16.27760338783264],
      ['2024-06-26T04:41:00Z', 16.521082878112793],
      ['2024-06-26T04:42:00Z', 16.87182331085205],
      ['2024-06-26T04:43:00Z', 16.53973889350891],
      ['2024-06-26T04:44:00Z', 16.47531509399414],
      ['2024-06-26T04:45:00Z', 15.46669054031372],
      ['2024-06-26T04:46:00Z', 15.999448537826538],
      ['2024-06-26T04:47:00Z', 15.725109338760376],
      ['2024-06-26T04:48:00Z', 16.3469295501709],
      ['2024-06-26T04:49:00Z', 16.02044701576233],
      ['2024-06-26T04:50:00Z', 15.956596612930298],
      ['2024-06-26T04:51:00Z', 16.34779357910156],
      ['2024-06-26T04:52:00Z', 15.638752698898315],
      ['2024-06-26T04:53:00Z', 15.896819591522217],
      ['2024-06-26T04:54:00Z', 15.518951177597046],
      ['2024-06-26T04:55:00Z', 16.434457778930664],
      ['2024-06-26T04:56:00Z', 16.12264919281006],
      ['2024-06-26T04:57:00Z', 15.776784420013428],
      ['2024-06-26T04:58:00Z', 15.713388204574585],
      ['2024-06-26T04:59:00Z', 15.32902717590332],
      ['2024-06-26T05:00:00Z', 14.715891202290853],
      ['2024-06-26T05:01:00Z', 14.384861707687378],
      ['2024-06-26T05:02:00Z', 14.855151891708374],
      ['2024-06-26T05:03:00Z', 14.533514261245728],
      ['2024-06-26T05:04:00Z', 14.312366962432861],
      ['2024-06-26T05:05:00Z', 14.938605546951294],
      ['2024-06-26T05:06:00Z', 14.785584688186646],
      ['2024-06-26T05:07:00Z', 14.922829389572144],
      ['2024-06-26T05:08:00Z', 14.430567264556885],
      ['2024-06-26T05:09:00Z', 15.404557466506958],
      ['2024-06-26T05:10:00Z', 14.635260581970215],
      ['2024-06-26T05:11:00Z', 14.752357800801596],
      ['2024-06-26T05:12:00Z', 14.669480800628662],
      ['2024-06-26T05:13:00Z', 14.297533512115479],
      ['2024-06-26T05:14:00Z', 14.693934440612793],
      ['2024-06-26T05:15:00Z', 15.096193790435791],
      ['2024-06-26T05:16:00Z', 15.004379272460938],
      ['2024-06-26T05:17:00Z', 14.537010908126831],
      ['2024-06-26T05:18:00Z', 14.618170738220215],
      ['2024-06-26T05:19:00Z', 14.569857597351074],
      ['2024-06-26T05:20:00Z', 15.094079653422037],
      ['2024-06-26T05:21:00Z', 14.657094717025757],
      ['2024-06-26T05:22:00Z', 14.671040773391724],
      ['2024-06-26T05:23:00Z', 14.858198642730713],
      ['2024-06-26T05:24:00Z', 14.710583448410034],
      ['2024-06-26T05:25:00Z', 15.16742730140686],
      ['2024-06-26T05:26:00Z', 14.920764287312826],
      ['2024-06-26T05:27:00Z', 14.96095061302185],
      ['2024-06-26T05:28:00Z', 15.16587519645691],
      ['2024-06-26T05:29:00Z', 15.0604616800944],
      ['2024-06-26T05:30:00Z', 15.14347767829895],
      ['2024-06-26T05:31:00Z', 14.586015462875366],
      ['2024-06-26T05:32:00Z', 15.210256258646647],
      ['2024-06-26T05:33:00Z', 14.82870888710022],
      ['2024-06-26T05:34:00Z', 14.77748966217041],
      ['2024-06-26T05:35:00Z', 14.659751653671265],
      ['2024-06-26T05:36:00Z', 14.6410653591156],
      ['2024-06-26T05:37:00Z', 14.747821489969889],
      ['2024-06-26T05:38:00Z', 14.510397672653198],
      ['2024-06-26T05:39:00Z', 15.151484727859497],
      ['2024-06-26T05:40:00Z', 15.276744524637857],
      ['2024-06-26T05:41:00Z', 14.206451416015625],
      ['2024-06-26T05:42:00Z', 14.289681196212769],
      ['2024-06-26T05:43:00Z', 14.631747245788574],
      ['2024-06-26T05:44:00Z', 15.036044597625732],
      ['2024-06-26T05:45:00Z', 14.762502431869507],
      ['2024-06-26T05:46:00Z', 14.730848550796509],
      ['2024-06-26T05:47:00Z', 15.304187774658203],
      ['2024-06-26T05:48:00Z', 14.882208347320557],
      ['2024-06-26T05:49:00Z', 14.759294986724854],
      ['2024-06-26T05:50:00Z', 14.961363554000854],
      ['2024-06-26T05:51:00Z', 15.102197647094727],
      ['2024-06-26T05:52:00Z', 14.564104557037354],
      ['2024-06-26T05:53:00Z', 15.515235900878906],
      ['2024-06-26T05:54:00Z', 14.922168016433716],
      ['2024-06-26T05:55:00Z', 14.74284807840983],
      ['2024-06-26T05:56:00Z', 14.385865926742554],
      ['2024-06-26T05:57:00Z', 14.664236545562744],
      ['2024-06-26T05:58:00Z', 14.311880350112915],
      ['2024-06-26T05:59:00Z', 14.145366668701172],
      ['2024-06-26T06:00:00Z', 13.710739374160767],
      ['2024-06-26T06:01:00Z', 13.620458841323853],
      ['2024-06-26T06:02:00Z', 13.548054218292236],
      ['2024-06-26T06:03:00Z', 13.299758434295654],
      ['2024-06-26T06:04:00Z', 14.144233703613281],
      ['2024-06-26T06:05:00Z', 14.329817056655884],
      ['2024-06-26T06:06:00Z', 13.84620213508606],
      ['2024-06-26T06:07:00Z', 13.678928852081299],
      ['2024-06-26T06:08:00Z', 13.871919393539429],
      ['2024-06-26T06:09:00Z', 13.524339437484741],
      ['2024-06-26T06:10:00Z', 13.565088589986166],
      ['2024-06-26T06:11:00Z', 13.618246078491211],
      ['2024-06-26T06:12:00Z', 12.73764673868815],
      ['2024-06-26T06:13:00Z', 12.728911876678467],
      ['2024-06-26T06:14:00Z', 13.15427851676941],
      ['2024-06-26T06:15:00Z', 12.815424919128418],
      ['2024-06-26T06:16:00Z', 13.332899808883667],
      ['2024-06-26T06:17:00Z', 13.098363240559896],
      ['2024-06-26T06:18:00Z', 12.791396458943685],
      ['2024-06-26T06:19:00Z', 12.634569644927979],
      ['2024-06-26T06:20:00Z', 12.667022228240967],
      ['2024-06-26T06:21:00Z', 13.094569444656372],
      ['2024-06-26T06:22:00Z', 12.768236796061197],
      ['2024-06-26T06:23:00Z', 13.522011518478394],
      ['2024-06-26T06:24:00Z', 12.881824016571045],
      ['2024-06-26T06:25:00Z', 12.940734148025513],
      ['2024-06-26T06:26:00Z', 13.033329486846924],
      ['2024-06-26T06:27:00Z', 12.982109069824219],
      ['2024-06-26T06:28:00Z', 12.885340213775635],
      ['2024-06-26T06:29:00Z', 12.884523868560791],
      ['2024-06-26T06:30:00Z', 13.308712244033813],
      ['2024-06-26T06:31:00Z', 12.888518571853638],
      ['2024-06-26T06:32:00Z', 12.481983184814453],
      ['2024-06-26T06:33:00Z', 12.76720666885376],
      ['2024-06-26T06:34:00Z', 13.2010657787323],
      ['2024-06-26T06:35:00Z', 12.630706548690796],
      ['2024-06-26T06:36:00Z', 13.087228536605835],
      ['2024-06-26T06:37:00Z', 13.124613285064697],
      ['2024-06-26T06:38:00Z', 12.971480369567871],
      ['2024-06-26T06:39:00Z', 12.780725002288818],
      ['2024-06-26T06:40:00Z', 12.926353931427002],
      ['2024-06-26T06:41:00Z', 12.94292402267456],
      ['2024-06-26T06:42:00Z', 13.015217542648315],
      ['2024-06-26T06:43:00Z', 13.141030073165894],
      ['2024-06-26T06:44:00Z', 12.8326096534729],
      ['2024-06-26T06:45:00Z', 12.847752571105957],
      ['2024-06-26T06:46:00Z', 13.027697086334229],
      ['2024-06-26T06:47:00Z', 12.78387419382731],
      ['2024-06-26T06:48:00Z', 13.127868413925171],
      ['2024-06-26T06:49:00Z', 12.981786012649536],
      ['2024-06-26T06:50:00Z', 12.591796398162842],
      ['2024-06-26T06:51:00Z', 12.716805140177408],
      ['2024-06-26T06:52:00Z', 12.606908321380615],
      ['2024-06-26T06:53:00Z', 12.757678270339966],
      ['2024-06-26T06:54:00Z', 12.98457407951355],
      ['2024-06-26T06:55:00Z', 13.157103300094604],
      ['2024-06-26T06:56:00Z', 12.924275875091553],
      ['2024-06-26T06:57:00Z', 12.77657437324524],
      ['2024-06-26T06:58:00Z', 12.340995788574219],
      ['2024-06-26T06:59:00Z', 12.98735523223877],
      ['2024-06-26T07:00:00Z', 13.60846757888794],
      ['2024-06-26T07:01:00Z', 12.944885889689127],
      ['2024-06-26T07:02:00Z', 12.82515263557434],
      ['2024-06-26T07:03:00Z', 12.682552655537924],
      ['2024-06-26T07:04:00Z', 12.844710111618042],
      ['2024-06-26T07:05:00Z', 13.039419651031494],
      ['2024-06-26T07:06:00Z', 13.071812629699707],
      ['2024-06-26T07:07:00Z', 13.206678867340088],
      ['2024-06-26T07:08:00Z', 13.026664018630981],
      ['2024-06-26T07:09:00Z', 12.718146085739136],
      ['2024-06-26T07:10:00Z', 12.669922828674316],
      ['2024-06-26T07:11:00Z', 13.042398929595947],
      ['2024-06-26T07:12:00Z', 12.895675659179688],
      ['2024-06-26T07:13:00Z', 13.10259461402893],
      ['2024-06-26T07:14:00Z', 13.373223781585693],
      ['2024-06-26T07:15:00Z', 12.834685325622559],
      ['2024-06-26T07:16:00Z', 12.959549188613892],
      ['2024-06-26T07:17:00Z', 12.528888702392578],
      ['2024-06-26T07:18:00Z', 13.12686276435852],
      ['2024-06-26T07:19:00Z', 13.029728889465332],
      ['2024-06-26T07:20:00Z', 13.128657341003418],
      ['2024-06-26T07:21:00Z', 13.133153915405273],
      ['2024-06-26T07:22:00Z', 12.73835563659668],
      ['2024-06-26T07:23:00Z', 12.947983264923096],
      ['2024-06-26T07:24:00Z', 15.510010719299316],
      ['2024-06-26T07:25:00Z', 21.723110834757488],
      ['2024-06-26T07:26:00Z', 20.251912593841553],
      ['2024-06-26T07:27:00Z', 20.545087814331055],
      ['2024-06-26T07:28:00Z', 20.777812480926514],
      ['2024-06-26T07:29:00Z', 20.868267059326172],
      ['2024-06-26T07:30:00Z', 20.43465280532837],
      ['2024-06-26T07:31:00Z', 20.4406000773112],
      ['2024-06-26T07:32:00Z', 20.616034030914307],
      ['2024-06-26T07:33:00Z', 20.636088848114014],
      ['2024-06-26T07:34:00Z', 20.78604221343994],
      ['2024-06-26T07:35:00Z', 20.012012481689453],
      ['2024-06-26T07:36:00Z', 20.584815502166748],
      ['2024-06-26T07:37:00Z', 20.15006971359253],
      ['2024-06-26T07:38:00Z', 20.724799633026123],
      ['2024-06-26T07:39:00Z', 20.872354984283447],
      ['2024-06-26T07:40:00Z', 20.24156665802002],
      ['2024-06-26T07:41:00Z', 20.590388774871826],
      ['2024-06-26T07:42:00Z', 20.16232919692993],
      ['2024-06-26T07:43:00Z', 20.297495365142822],
      ['2024-06-26T07:44:00Z', 20.38613510131836],
      ['2024-06-26T07:45:00Z', 20.495442867279053],
      ['2024-06-26T07:46:00Z', 20.90240542093913],
      ['2024-06-26T07:47:00Z', 20.129932403564453],
      ['2024-06-26T07:48:00Z', 20.14122772216797],
      ['2024-06-26T07:49:00Z', 20.205204486846924],
      ['2024-06-26T07:50:00Z', 20.883179187774658],
      ['2024-06-26T07:51:00Z', 20.379119396209717],
      ['2024-06-26T07:52:00Z', 20.57527208328247],
      ['2024-06-26T07:53:00Z', 20.5603609085083],
      ['2024-06-26T07:54:00Z', 20.48304319381714],
      ['2024-06-26T07:55:00Z', 20.151302337646484],
      ['2024-06-26T07:56:00Z', 20.18745994567871],
      ['2024-06-26T07:57:00Z', 20.506866455078125],
      ['2024-06-26T07:58:00Z', 20.294368743896484],
      ['2024-06-26T07:59:00Z', 20.744595050811768],
      ['2024-06-26T08:00:00Z', 20.27509943644206],
      ['2024-06-26T08:01:00Z', 20.13230609893799],
      ['2024-06-26T08:02:00Z', 20.308032989501953],
      ['2024-06-26T08:03:00Z', 20.414724349975586],
      ['2024-06-26T08:04:00Z', 20.29979133605957],
      ['2024-06-26T08:05:00Z', 20.613201141357422],
      ['2024-06-26T08:06:00Z', 20.211609363555908],
      ['2024-06-26T08:07:00Z', 20.324307441711426],
      ['2024-06-26T08:08:00Z', 20.139469623565674],
      ['2024-06-26T08:09:00Z', 20.357887268066406],
      ['2024-06-26T08:10:00Z', 20.736473719278973],
      ['2024-06-26T08:11:00Z', 20.554361820220947],
      ['2024-06-26T08:12:00Z', 20.14577865600586],
      ['2024-06-26T08:13:00Z', 20.275874137878418],
      ['2024-06-26T08:14:00Z', 20.204388936360676],
      ['2024-06-26T08:15:00Z', 20.70060396194458],
      ['2024-06-26T08:16:00Z', 20.40859317779541],
      ['2024-06-26T08:17:00Z', 20.55567169189453],
      ['2024-06-26T08:18:00Z', 20.186185836791992],
      ['2024-06-26T08:19:00Z', 19.914043426513672],
      ['2024-06-26T08:20:00Z', 20.166158199310303],
      ['2024-06-26T08:21:00Z', 20.559253215789795],
      ['2024-06-26T08:22:00Z', 20.644174575805664],
      ['2024-06-26T08:23:00Z', 20.453954696655273],
      ['2024-06-26T08:24:00Z', 20.257762908935547],
      ['2024-06-26T08:25:00Z', 20.138590812683105],
      ['2024-06-26T08:26:00Z', 20.286890029907227],
      ['2024-06-26T08:27:00Z', 20.42766237258911],
      ['2024-06-26T08:28:00Z', 20.33321237564087],
      ['2024-06-26T08:29:00Z', 20.689553260803223],
      ['2024-06-26T08:30:00Z', 20.412617683410645],
      ['2024-06-26T08:31:00Z', 20.984913508097332],
      ['2024-06-26T08:32:00Z', 20.671298503875732],
      ['2024-06-26T08:33:00Z', 21.077003955841064],
      ['2024-06-26T08:34:00Z', 21.119086265563965],
      ['2024-06-26T08:35:00Z', 21.67477798461914],
      ['2024-06-26T08:36:00Z', 21.778465747833252],
      ['2024-06-26T08:37:00Z', 21.265384197235107],
      ['2024-06-26T08:38:00Z', 21.641915798187256],
      ['2024-06-26T08:39:00Z', 21.52686643600464],
      ['2024-06-26T08:40:00Z', 21.863679885864258],
      ['2024-06-26T08:41:00Z', 22.123658657073975],
      ['2024-06-26T08:42:00Z', 21.526290893554688],
      ['2024-06-26T08:43:00Z', 21.204457600911457],
      ['2024-06-26T08:44:00Z', 21.63598108291626],
      ['2024-06-26T08:45:00Z', 21.7744083404541],
      ['2024-06-26T08:46:00Z', 21.190990924835205],
      ['2024-06-26T08:47:00Z', 20.944264888763428],
      ['2024-06-26T08:48:00Z', 21.124468326568604],
      ['2024-06-26T08:49:00Z', 21.085198402404785],
      ['2024-06-26T08:50:00Z', 20.84827184677124],
      ['2024-06-26T08:51:00Z', 20.52932643890381],
      ['2024-06-26T08:52:00Z', 20.86352300643921],
      ['2024-06-26T08:53:00Z', 20.765286445617676],
      ['2024-06-26T08:54:00Z', 21.238367557525635],
      ['2024-06-26T08:55:00Z', 21.05422878265381],
      ['2024-06-26T08:56:00Z', 21.169025421142578],
      ['2024-06-26T08:57:00Z', 20.862369537353516],
      ['2024-06-26T08:58:00Z', 20.737454891204834],
      ['2024-06-26T08:59:00Z', 20.572421073913574],
      ['2024-06-26T09:00:00Z', 21.027108669281006],
      ['2024-06-26T09:01:00Z', 21.477135181427002],
      ['2024-06-26T09:02:00Z', 20.980294704437256],
      ['2024-06-26T09:03:00Z', 20.973610401153564],
      ['2024-06-26T09:04:00Z', 20.633920669555664],
      ['2024-06-26T09:05:00Z', 21.288817405700684],
      ['2024-06-26T09:06:00Z', 20.818132400512695],
      ['2024-06-26T09:07:00Z', 21.590028127034504],
      ['2024-06-26T09:08:00Z', 21.4495423634847],
      ['2024-06-26T09:09:00Z', 21.064401149749756],
      ['2024-06-26T09:10:00Z', 21.20701026916504],
      ['2024-06-26T09:11:00Z', 21.243408203125],
      ['2024-06-26T09:12:00Z', 21.20681619644165],
      ['2024-06-26T09:13:00Z', 21.099502086639404],
      ['2024-06-26T09:14:00Z', 21.512503623962402],
      ['2024-06-26T09:15:00Z', 21.440430164337158],
      ['2024-06-26T09:16:00Z', 21.49885368347168],
      ['2024-06-26T09:17:00Z', 21.03156805038452],
      ['2024-06-26T09:18:00Z', 21.518205642700195],
      ['2024-06-26T09:19:00Z', 21.535045623779297],
      ['2024-06-26T09:20:00Z', 21.050074100494385],
      ['2024-06-26T09:21:00Z', 21.258886337280273],
      ['2024-06-26T09:22:00Z', 21.532010078430176],
      ['2024-06-26T09:23:00Z', 20.847815831502277],
      ['2024-06-26T09:24:00Z', 21.146049976348877],
      ['2024-06-26T09:25:00Z', 21.59720516204834],
      ['2024-06-26T09:26:00Z', 21.089695930480957],
      ['2024-06-26T09:27:00Z', 21.48634624481201],
      ['2024-06-26T09:28:00Z', 21.142508029937744],
      ['2024-06-26T09:29:00Z', 21.160993099212646],
      ['2024-06-26T09:30:00Z', 21.126545588175457],
      ['2024-06-26T09:31:00Z', 21.232462882995605],
      ['2024-06-26T09:32:00Z', 21.60594940185547],
      ['2024-06-26T09:33:00Z', 22.3755145072937],
      ['2024-06-26T09:34:00Z', 22.825169563293457],
      ['2024-06-26T09:35:00Z', 22.802776336669922],
      ['2024-06-26T09:36:00Z', 22.527655124664307],
      ['2024-06-26T09:37:00Z', 22.359420776367188],
      ['2024-06-26T09:38:00Z', 22.570838451385498],
      ['2024-06-26T09:39:00Z', 23.722150325775146],
      ['2024-06-26T09:40:00Z', 24.484375476837158],
      ['2024-06-26T09:41:00Z', 24.361632347106934],
      ['2024-06-26T09:42:00Z', 24.352726459503174],
      ['2024-06-26T09:43:00Z', 24.341493129730225],
      ['2024-06-26T09:44:00Z', 24.576361656188965],
      ['2024-06-26T09:45:00Z', 24.262946128845215],
      ['2024-06-26T09:46:00Z', 24.096542358398438],
      ['2024-06-26T09:47:00Z', 24.167362213134766],
      ['2024-06-26T09:48:00Z', 23.800847053527832],
      ['2024-06-26T09:49:00Z', 23.34171962738037],
      ['2024-06-26T09:50:00Z', 23.764009952545166],
      ['2024-06-26T09:51:00Z', 23.518516540527344],
      ['2024-06-26T09:52:00Z', 23.626283645629883],
      ['2024-06-26T09:53:00Z', 23.274757862091064],
      ['2024-06-26T09:54:00Z', 21.11305332183838],
      ['2024-06-26T09:55:00Z', 20.853007316589355],
      ['2024-06-26T09:56:00Z', 21.10129451751709],
      ['2024-06-26T09:57:00Z', 21.8353009223938],
      ['2024-06-26T09:58:00Z', 22.27750062942505],
      ['2024-06-26T09:59:00Z', 21.35687017440796],
      ['2024-06-26T10:00:00Z', 21.932490348815918],
      ['2024-06-26T10:01:00Z', 21.056631088256836],
      ['2024-06-26T10:02:00Z', 20.641480445861816],
      ['2024-06-26T10:03:00Z', 21.0928692817688],
      ['2024-06-26T10:04:00Z', 21.057612419128418],
      ['2024-06-26T10:05:00Z', 21.693943977355957],
      ['2024-06-26T10:06:00Z', 21.393829822540283],
      ['2024-06-26T10:07:00Z', 21.252501964569092],
      ['2024-06-26T10:08:00Z', 21.438801447550457],
      ['2024-06-26T10:09:00Z', 21.600961685180664],
      ['2024-06-26T10:10:00Z', 22.958373546600342],
      ['2024-06-26T10:11:00Z', 24.505131244659424],
      ['2024-06-26T10:12:00Z', 24.290820121765137],
      ['2024-06-26T10:13:00Z', 23.041231632232666],
      ['2024-06-26T10:14:00Z', 23.902729511260986],
      ['2024-06-26T10:15:00Z', 23.28052282333374],
      ['2024-06-26T10:16:00Z', 23.80472993850708],
      ['2024-06-26T10:17:00Z', 23.89222717285156],
      ['2024-06-26T10:18:00Z', 24.346388339996338],
      ['2024-06-26T10:19:00Z', 25.46025848388672],
      ['2024-06-26T10:20:00Z', 25.060304641723633],
      ['2024-06-26T10:21:00Z', 25.13668394088745],
      ['2024-06-26T10:22:00Z', 25.734187126159668],
      ['2024-06-26T10:23:00Z', 38.878217697143555],
      ['2024-06-26T10:24:00Z', 31.117212295532227],
      ['2024-06-26T10:25:00Z', 31.16236639022827],
      ['2024-06-26T10:26:00Z', 30.94439172744751],
      ['2024-06-26T10:27:00Z', 19.642643213272095],
      ['2024-06-26T10:28:00Z', 23.645713488260906],
      ['2024-06-26T10:29:00Z', 31.518199920654297],
      ['2024-06-26T10:30:00Z', 30.933495044708252],
      ['2024-06-26T10:31:00Z', 31.413331031799316],
      ['2024-06-26T10:32:00Z', 27.743135929107666],
      ['2024-06-26T10:33:00Z', 16.335667610168457],
      ['2024-06-26T10:34:00Z', 28.2781081199646],
      ['2024-06-26T10:35:00Z', 31.81644058227539],
      ['2024-06-26T10:36:00Z', 31.649536609649658],
      ['2024-06-26T10:37:00Z', 31.63310670852661],
      ['2024-06-26T10:38:00Z', 27.174205780029297],
      ['2024-06-26T10:39:00Z', 17.28403615951538],
      ['2024-06-26T10:40:00Z', 31.82399559020996],
      ['2024-06-26T10:41:00Z', 32.53380632400513],
      ['2024-06-26T10:42:00Z', 32.770503997802734],
      ['2024-06-26T10:43:00Z', 32.403820514678955],
      ['2024-06-26T10:44:00Z', 32.164339542388916],
      ['2024-06-26T10:45:00Z', 31.91615629196167],
      ['2024-06-26T10:46:00Z', 18.88080859184265],
      ['2024-06-26T10:47:00Z', 31.291065216064453],
      ['2024-06-26T10:48:00Z', 31.652785778045654],
      ['2024-06-26T10:49:00Z', 32.18484544754028],
      ['2024-06-26T10:50:00Z', 32.52620458602905],
      ['2024-06-26T10:51:00Z', 31.606067657470703],
      ['2024-06-26T10:52:00Z', 24.21773386001587],
      ['2024-06-26T10:53:00Z', 27.40407395362854],
      ['2024-06-26T10:54:00Z', 31.59570598602295],
      ['2024-06-26T10:55:00Z', 32.63472652435303],
      ['2024-06-26T10:56:00Z', 32.41480875015259],
      ['2024-06-26T10:57:00Z', 32.031163692474365],
      ['2024-06-26T10:58:00Z', 32.325758934020996],
      ['2024-06-26T10:59:00Z', 27.733830213546753],
      ['2024-06-26T11:00:00Z', 19.028066873550415],
      ['2024-06-26T11:01:00Z', 31.944300174713135],
      ['2024-06-26T11:02:00Z', 32.276848793029785],
      ['2024-06-26T11:03:00Z', 31.84488344192505],
      ['2024-06-26T11:04:00Z', 31.860243797302246],
      ['2024-06-26T11:05:00Z', 31.891342639923096],
      ['2024-06-26T11:06:00Z', 31.678983688354492],
      ['2024-06-26T11:07:00Z', 20.625488758087158],
      ['2024-06-26T11:08:00Z', 28.378432750701904],
      ['2024-06-26T11:09:00Z', 32.050586223602295],
      ['2024-06-26T11:10:00Z', 31.428388595581055],
      ['2024-06-26T11:11:00Z', 31.581385294596355],
      ['2024-06-26T11:12:00Z', 31.625514030456543],
      ['2024-06-26T11:13:00Z', 33.15236155192057],
      ['2024-06-26T11:14:00Z', 28.568926334381104],
      ['2024-06-26T11:15:00Z', 17.086082220077515],
      ['2024-06-26T11:16:00Z', 29.138330459594727],
      ['2024-06-26T11:17:00Z', 32.629926681518555],
      ['2024-06-26T11:18:00Z', 32.51628398895264],
      ['2024-06-26T11:19:00Z', 31.978858311971027],
      ['2024-06-26T11:20:00Z', 31.933910846710205],
      ['2024-06-26T11:21:00Z', 32.265597661336265],
      ['2024-06-26T11:22:00Z', 32.35225486755371],
      ['2024-06-26T11:23:00Z', 22.714558362960815],
      ['2024-06-26T11:24:00Z', 29.357396602630615],
      ['2024-06-26T11:25:00Z', 32.75024890899658],
      ['2024-06-26T11:26:00Z', 33.4627628326416],
      ['2024-06-26T11:27:00Z', 33.06277656555176],
      ['2024-06-26T11:28:00Z', 33.221564292907715],
      ['2024-06-26T11:29:00Z', 32.26116895675659],
      ['2024-06-26T11:30:00Z', 33.29790687561035],
      ['2024-06-26T11:31:00Z', 33.8345365524292],
      ['2024-06-26T11:32:00Z', 33.320817947387695],
      ['2024-06-26T11:33:00Z', 33.346561431884766],
      ['2024-06-26T11:34:00Z', 33.55591011047363],
      ['2024-06-26T11:35:00Z', 32.82606601715088],
      ['2024-06-26T11:36:00Z', 32.497904459635414],
      ['2024-06-26T11:37:00Z', 32.523681004842125],
      ['2024-06-26T11:38:00Z', 32.939619064331055],
      ['2024-06-26T11:39:00Z', 32.907124042510986],
      ['2024-06-26T11:40:00Z', 33.0332727432251],
      ['2024-06-26T11:41:00Z', 32.8711051940918],
      ['2024-06-26T11:42:00Z', 33.6956901550293],
      ['2024-06-26T11:43:00Z', 33.106438636779785],
      ['2024-06-26T11:44:00Z', 33.454715728759766],
      ['2024-06-26T11:45:00Z', 33.41889667510986],
      ['2024-06-26T11:46:00Z', 34.39434814453125],
      ['2024-06-26T11:47:00Z', 34.12652778625488],
      ['2024-06-26T11:48:00Z', 32.86145782470703],
      ['2024-06-26T11:49:00Z', 33.095306396484375],
      ['2024-06-26T11:50:00Z', 33.1165771484375],
      ['2024-06-26T11:51:00Z', 34.60378170013428],
      ['2024-06-26T11:52:00Z', 33.520013173421226],
      ['2024-06-26T11:53:00Z', 33.54838180541992],
      ['2024-06-26T11:54:00Z', 33.54746627807617],
      ['2024-06-26T11:55:00Z', 33.54669380187988],
      ['2024-06-26T11:56:00Z', 32.680970191955566],
      ['2024-06-26T11:57:00Z', 32.17410230636597],
      ['2024-06-26T11:58:00Z', 32.45097780227661],
      ['2024-06-26T11:59:00Z', 32.3866933186849],
      ['2024-06-26T12:00:00Z', 33.79227352142334],
      ['2024-06-26T12:01:00Z', 33.03287887573242],
      ['2024-06-26T12:02:00Z', 33.222601890563965],
      ['2024-06-26T12:03:00Z', 32.278613567352295],
      ['2024-06-26T12:04:00Z', 32.53524208068848],
      ['2024-06-26T12:05:00Z', 32.83110523223877],
      ['2024-06-26T12:06:00Z', 33.04622745513916],
      ['2024-06-26T12:07:00Z', 32.42284059524536],
      ['2024-06-26T12:08:00Z', 24.94385004043579],
      ['2024-06-26T12:09:00Z', 23.793464422225952],
      ['2024-06-26T12:10:00Z', 31.704562187194824],
      ['2024-06-26T12:11:00Z', 32.6698203086853],
      ['2024-06-26T12:12:00Z', 33.64620780944824],
      ['2024-06-26T12:13:00Z', 33.78452682495117],
      ['2024-06-26T12:14:00Z', 33.462066650390625],
      ['2024-06-26T12:15:00Z', 34.03330898284912],
      ['2024-06-26T12:16:00Z', 33.30395317077637],
      ['2024-06-26T12:17:00Z', 32.709442138671875],
      ['2024-06-26T12:18:00Z', 32.30189514160156],
      ['2024-06-26T12:19:00Z', 31.574764251708984],
      ['2024-06-26T12:20:00Z', 31.869263648986816],
      ['2024-06-26T12:21:00Z', 31.068628311157227],
      ['2024-06-26T12:22:00Z', 14.313266515731812],
      ['2024-06-26T12:23:00Z', 24.060585498809814],
      ['2024-06-26T12:24:00Z', 31.388163566589355],
      ['2024-06-26T12:25:00Z', 30.801788330078125],
      ['2024-06-26T12:26:00Z', 30.147812366485596],
      ['2024-06-26T12:27:00Z', 17.535627365112305],
      ['2024-06-26T12:28:00Z', 24.468363285064697],
      ['2024-06-26T12:29:00Z', 29.93453025817871],
      ['2024-06-26T12:30:00Z', 29.347811698913574],
      ['2024-06-26T12:31:00Z', 25.184049606323242],
      ['2024-06-26T12:32:00Z', 21.378313302993774],
      ['2024-06-26T12:33:00Z', 11.943052291870117],
      ['2024-06-26T12:34:00Z', 25.70900297164917],
      ['2024-06-26T12:35:00Z', 26.10572052001953],
      ['2024-06-26T12:36:00Z', 26.909977912902832],
      ['2024-06-26T12:37:00Z', 26.22652769088745],
      ['2024-06-26T12:38:00Z', 28.64088185628255],
      ['2024-06-26T12:39:00Z', 32.38782596588135],
      ['2024-06-26T12:40:00Z', 30.89863681793213],
      ['2024-06-26T12:41:00Z', 30.9647274017334],
      ['2024-06-26T12:42:00Z', 31.119107723236084],
      ['2024-06-26T12:43:00Z', 19.613837480545044],
      ['2024-06-26T12:44:00Z', 25.934208869934082],
      ['2024-06-26T12:45:00Z', 32.09264087677002],
      ['2024-06-26T12:46:00Z', 31.77013349533081],
      ['2024-06-26T12:47:00Z', 32.599334716796875],
      ['2024-06-26T12:48:00Z', 31.360354900360107],
      ['2024-06-26T12:49:00Z', 31.806057453155518],
      ['2024-06-26T12:50:00Z', 29.274373531341553],
      ['2024-06-26T12:51:00Z', 23.640196800231934],
      ['2024-06-26T12:52:00Z', 35.179932594299316],
      ['2024-06-26T12:53:00Z', 32.65779495239258],
      ['2024-06-26T12:54:00Z', 33.76582908630371],
      ['2024-06-26T12:55:00Z', 33.09408092498779],
      ['2024-06-26T12:56:00Z', 32.74528932571411],
      ['2024-06-26T12:57:00Z', 32.551576137542725],
      ['2024-06-26T12:58:00Z', 32.52179209391276],
      ['2024-06-26T12:59:00Z', 31.90548801422119],
      ['2024-06-26T13:00:00Z', 32.17558288574219],
      ['2024-06-26T13:01:00Z', 32.67659854888916],
      ['2024-06-26T13:02:00Z', 32.10574150085449],
      ['2024-06-26T13:03:00Z', 32.12590980529785],
      ['2024-06-26T13:04:00Z', 32.70022773742676],
      ['2024-06-26T13:05:00Z', 33.57999038696289],
      ['2024-06-26T13:06:00Z', 33.308353424072266],
      ['2024-06-26T13:07:00Z', 32.49900817871094],
      ['2024-06-26T13:08:00Z', 33.281575202941895],
      ['2024-06-26T13:09:00Z', 33.96043300628662],
      ['2024-06-26T13:10:00Z', 33.14605840047201],
      ['2024-06-26T13:11:00Z', 33.71792793273926],
      ['2024-06-26T13:12:00Z', 32.46708393096924],
      ['2024-06-26T13:13:00Z', 32.3499174118042],
      ['2024-06-26T13:14:00Z', 28.97684669494629],
      ['2024-06-26T13:15:00Z', 21.304670572280884],
      ['2024-06-26T13:16:00Z', 33.470879554748535],
      ['2024-06-26T13:17:00Z', 33.22727680206299],
      ['2024-06-26T13:18:00Z', 33.532917976379395],
      ['2024-06-26T13:19:00Z', 32.615442752838135],
      ['2024-06-26T13:20:00Z', 33.073004722595215],
      ['2024-06-26T13:21:00Z', 33.31601142883301],
      ['2024-06-26T13:22:00Z', 33.207210540771484],
      ['2024-06-26T13:23:00Z', 33.61263561248779],
      ['2024-06-26T13:24:00Z', 33.04457473754883],
      ['2024-06-26T13:25:00Z', 32.755818684895836],
      ['2024-06-26T13:26:00Z', 32.741122245788574],
      ['2024-06-26T13:27:00Z', 32.92650508880615],
      ['2024-06-26T13:28:00Z', 32.94998741149902],
      ['2024-06-26T13:29:00Z', 33.46591663360596],
      ['2024-06-26T13:30:00Z', 32.70079946517944],
      ['2024-06-26T13:31:00Z', 32.37302541732788],
      ['2024-06-26T13:32:00Z', 31.927247524261475],
      ['2024-06-26T13:33:00Z', 33.1742000579834],
      ['2024-06-26T13:34:00Z', 32.41507911682129],
      ['2024-06-26T13:35:00Z', 32.273305892944336],
      ['2024-06-26T13:36:00Z', 32.29375076293945],
      ['2024-06-26T13:37:00Z', 32.74000803629557],
      ['2024-06-26T13:38:00Z', 33.045647621154785],
      ['2024-06-26T13:39:00Z', 32.88205337524414],
      ['2024-06-26T13:40:00Z', 33.07149124145508],
      ['2024-06-26T13:41:00Z', 33.642478942871094],
      ['2024-06-26T13:42:00Z', 32.91004753112793],
      ['2024-06-26T13:43:00Z', 33.55781555175781],
      ['2024-06-26T13:44:00Z', 33.09334468841553],
      ['2024-06-26T13:45:00Z', 32.63187122344971],
      ['2024-06-26T13:46:00Z', 32.49501991271973],
      ['2024-06-26T13:47:00Z', 32.65148735046387],
      ['2024-06-26T13:48:00Z', 33.08364295959473],
      ['2024-06-26T13:49:00Z', 21.39968729019165],
      ['2024-06-26T13:50:00Z', 34.66821765899658],
      ['2024-06-26T13:51:00Z', 32.91078758239746],
      ['2024-06-26T13:52:00Z', 32.36945676803589],
      ['2024-06-26T13:53:00Z', 32.392231941223145],
      ['2024-06-26T13:54:00Z', 32.44212055206299],
      ['2024-06-26T13:55:00Z', 31.843623161315918],
      ['2024-06-26T13:56:00Z', 30.586376825968426],
      ['2024-06-26T13:57:00Z', 31.012892246246338],
      ['2024-06-26T13:58:00Z', 27.476958751678467],
      ['2024-06-26T13:59:00Z', 19.687642097473145],
      ['2024-06-26T14:00:00Z', 32.40614461898804],
      ['2024-06-26T14:01:00Z', 33.467050552368164],
      ['2024-06-26T14:02:00Z', 34.181334495544434],
      ['2024-06-26T14:03:00Z', 33.75938924153646],
      ['2024-06-26T14:04:00Z', 33.506123542785645],
      ['2024-06-26T14:05:00Z', 32.93593215942383],
      ['2024-06-26T14:06:00Z', 31.765631198883057],
      ['2024-06-26T14:07:00Z', 31.70745277404785],
      ['2024-06-26T14:08:00Z', 33.106637954711914],
      ['2024-06-26T14:09:00Z', 33.62760353088379],
      ['2024-06-26T14:10:00Z', 33.49420166015625],
      ['2024-06-26T14:11:00Z', 32.64528560638428],
      ['2024-06-26T14:12:00Z', 31.250420570373535],
      ['2024-06-26T14:13:00Z', 31.778217315673828],
      ['2024-06-26T14:14:00Z', 32.70751190185547],
      ['2024-06-26T14:15:00Z', 33.274696350097656],
      ['2024-06-26T14:16:00Z', 32.72614765167236],
      ['2024-06-26T14:17:00Z', 17.22570562362671],
      ['2024-06-26T14:18:00Z', 33.56825542449951],
      ['2024-06-26T14:19:00Z', 32.51406288146973],
      ['2024-06-26T14:20:00Z', 32.86560583114624],
      ['2024-06-26T14:21:00Z', 32.270991802215576],
      ['2024-06-26T14:22:00Z', 32.185025691986084],
      ['2024-06-26T14:23:00Z', 32.59220504760742],
      ['2024-06-26T14:24:00Z', 31.595953464508057],
      ['2024-06-26T14:25:00Z', 31.820963541666668],
      ['2024-06-26T14:26:00Z', 31.792768955230713],
      ['2024-06-26T14:27:00Z', 24.418792247772217],
      ['2024-06-26T14:28:00Z', 20.27017831802368],
      ['2024-06-26T14:29:00Z', 31.001351356506348],
      ['2024-06-26T14:30:00Z', 33.43797254562378],
      ['2024-06-26T14:31:00Z', 32.514405727386475],
      ['2024-06-26T14:32:00Z', 32.736534118652344],
      ['2024-06-26T14:33:00Z', 32.04730033874512],
      ['2024-06-26T14:34:00Z', 34.07834720611572],
      ['2024-06-26T14:35:00Z', 32.49612474441528],
      ['2024-06-26T14:36:00Z', 32.91447830200195],
      ['2024-06-26T14:37:00Z', 32.65485334396362],
      ['2024-06-26T14:38:00Z', 32.246413707733154],
      ['2024-06-26T14:39:00Z', 32.837698459625244],
      ['2024-06-26T14:40:00Z', 32.86558246612549],
      ['2024-06-26T14:41:00Z', 31.66573476791382],
      ['2024-06-26T14:42:00Z', 31.71321725845337],
      ['2024-06-26T14:43:00Z', 31.077505588531494],
      ['2024-06-26T14:44:00Z', 25.828035354614258],
      ['2024-06-26T14:45:00Z', 15.330291271209717],
      ['2024-06-26T14:46:00Z', 27.776390075683594],
      ['2024-06-26T14:47:00Z', 30.264554977416992],
      ['2024-06-26T14:48:00Z', 31.129252910614014],
      ['2024-06-26T14:49:00Z', 30.87059275309245],
      ['2024-06-26T14:50:00Z', 31.07295036315918],
      ['2024-06-26T14:51:00Z', 16.001209497451782],
      ['2024-06-26T14:52:00Z', 29.84407138824463],
      ['2024-06-26T14:53:00Z', 31.01501989364624],
      ['2024-06-26T14:54:00Z', 30.19879976908366],
      ['2024-06-26T14:55:00Z', 26.57788634300232],
      ['2024-06-26T14:56:00Z', 13.386753559112549],
      ['2024-06-26T14:57:00Z', 22.630926609039307],
      ['2024-06-26T14:58:00Z', 24.500491619110107],
      ['2024-06-26T14:59:00Z', 25.137208302815754],
      ['2024-06-26T15:00:00Z', 25.329986572265625],
      ['2024-06-26T15:01:00Z', 24.498934745788574],
      ['2024-06-26T15:02:00Z', 25.24919080734253],
      ['2024-06-26T15:03:00Z', 32.063220500946045],
      ['2024-06-26T15:04:00Z', 32.21679814656576],
      ['2024-06-26T15:05:00Z', 30.485461235046387],
      ['2024-06-26T15:06:00Z', 31.271263599395752],
      ['2024-06-26T15:07:00Z', 15.724454641342163],
      ['2024-06-26T15:08:00Z', 30.12067413330078],
      ['2024-06-26T15:09:00Z', 31.109824180603027],
      ['2024-06-26T15:10:00Z', 30.22445297241211],
      ['2024-06-26T15:11:00Z', 30.652284145355225],
      ['2024-06-26T15:12:00Z', 18.055145740509033],
      ['2024-06-26T15:13:00Z', 18.1752347946167],
      ['2024-06-26T15:14:00Z', 25.138296127319336],
      ['2024-06-26T15:15:00Z', 25.317452907562256],
      ['2024-06-26T15:16:00Z', 24.827391624450684],
      ['2024-06-26T15:17:00Z', 25.307172298431396],
      ['2024-06-26T15:18:00Z', 24.767796834309895],
      ['2024-06-26T15:19:00Z', 25.18046998977661],
      ['2024-06-26T15:20:00Z', 24.887402057647705],
      ['2024-06-26T15:21:00Z', 24.55576801300049],
      ['2024-06-26T15:22:00Z', 35.92536687850952],
      ['2024-06-26T15:23:00Z', 30.360764026641846],
      ['2024-06-26T15:24:00Z', 30.403509616851807],
      ['2024-06-26T15:25:00Z', 26.70002269744873],
      ['2024-06-26T15:26:00Z', 13.388454675674438],
      ['2024-06-26T15:27:00Z', 22.261115550994873],
      ['2024-06-26T15:28:00Z', 24.58533000946045],
      ['2024-06-26T15:29:00Z', 24.95475959777832],
      ['2024-06-26T15:30:00Z', 24.938467502593994],
      ['2024-06-26T15:31:00Z', 24.90579652786255],
      ['2024-06-26T15:32:00Z', 24.78800678253174],
      ['2024-06-26T15:33:00Z', 24.95026206970215],
      ['2024-06-26T15:34:00Z', 24.622870445251465],
      ['2024-06-26T15:35:00Z', 25.232990741729736],
      ['2024-06-26T15:36:00Z', 25.435863494873047],
      ['2024-06-26T15:37:00Z', 32.86089324951172],
      ['2024-06-26T15:38:00Z', 34.79192399978638],
      ['2024-06-26T15:39:00Z', 29.907888412475586],
      ['2024-06-26T15:40:00Z', 30.454853534698486],
      ['2024-06-26T15:41:00Z', 29.43661594390869],
      ['2024-06-26T15:42:00Z', 29.99776792526245],
      ['2024-06-26T15:43:00Z', 21.908066511154175],
      ['2024-06-26T15:44:00Z', 17.650006532669067],
      ['2024-06-26T15:45:00Z', 25.462042331695557],
      ['2024-06-26T15:46:00Z', 24.88993501663208],
      ['2024-06-26T15:47:00Z', 34.24956464767456],
      ['2024-06-26T15:48:00Z', 35.52572727203369],
      ['2024-06-26T15:49:00Z', 32.669477462768555],
      ['2024-06-26T15:50:00Z', 32.515236377716064],
    ],
    powerKw: [
      ['2024-06-25T15:52:00Z', 212.969503197054],
      ['2024-06-25T15:53:00Z', 216.92135031960316],
      ['2024-06-25T15:54:00Z', 214.9454267583286],
      ['2024-06-25T15:55:00Z', 215.20038463720275],
      ['2024-06-25T15:56:00Z', 216.0768023458326],
      ['2024-06-25T15:57:00Z', 214.03713931483946],
      ['2024-06-25T15:58:00Z', 216.50173214395613],
      ['2024-06-25T15:59:00Z', 216.90541545217351],
      ['2024-06-25T16:00:00Z', 213.32007028050597],
      ['2024-06-25T16:01:00Z', 207.0895371155192],
      ['2024-06-25T16:02:00Z', 204.60369779649636],
      ['2024-06-25T16:03:00Z', 207.61538774069712],
      ['2024-06-25T16:04:00Z', 204.8108510730816],
      ['2024-06-25T16:05:00Z', 204.7311767359334],
      ['2024-06-25T16:06:00Z', 205.9900312628745],
      ['2024-06-25T16:07:00Z', 205.4801155051262],
      ['2024-06-25T16:08:00Z', 205.94222666058556],
      ['2024-06-25T16:09:00Z', 205.26233898358788],
      ['2024-06-25T16:10:00Z', 205.26233898358782],
      ['2024-06-25T16:11:00Z', 209.55944156711243],
      ['2024-06-25T16:12:00Z', 218.37673487817636],
      ['2024-06-25T16:13:00Z', 217.9252469676701],
      ['2024-06-25T16:14:00Z', 218.00492130481825],
      ['2024-06-25T16:15:00Z', 210.18090139686814],
      ['2024-06-25T16:16:00Z', 203.21736433011822],
      ['2024-06-25T16:17:00Z', 206.0006545078276],
      ['2024-06-25T16:18:00Z', 204.65150239878523],
      ['2024-06-25T16:19:00Z', 204.3487399176222],
      ['2024-06-25T16:20:00Z', 206.82395599169195],
      ['2024-06-25T16:21:00Z', 206.43620755090416],
      ['2024-06-25T16:22:00Z', 211.32821185180174],
      ['2024-06-25T16:23:00Z', 221.39904806733023],
      ['2024-06-25T16:24:00Z', 217.27191740305508],
      ['2024-06-25T16:25:00Z', 217.2559825356255],
      ['2024-06-25T16:26:00Z', 215.08884056519528],
      ['2024-06-25T16:27:00Z', 216.77793651273646],
      ['2024-06-25T16:28:00Z', 217.09663386132917],
      ['2024-06-25T16:29:00Z', 214.44613424553341],
      ['2024-06-25T16:30:00Z', 207.3285601269637],
      ['2024-06-25T16:31:00Z', 209.19825123870737],
      ['2024-06-25T16:32:00Z', 210.68550553213987],
      ['2024-06-25T16:33:00Z', 211.76376489487842],
      ['2024-06-25T16:34:00Z', 213.60689789423935],
      ['2024-06-25T16:35:00Z', 215.6040679454201],
      ['2024-06-25T16:36:00Z', 216.36362995956597],
      ['2024-06-25T16:37:00Z', 214.09556716208147],
      ['2024-06-25T16:38:00Z', 217.7340285585145],
      ['2024-06-25T16:39:00Z', 222.2754657759601],
      ['2024-06-25T16:40:00Z', 226.31229885813394],
      ['2024-06-25T16:41:00Z', 220.83070446233995],
      ['2024-06-25T16:42:00Z', 223.73085033453327],
      ['2024-06-25T16:43:00Z', 217.24004766819584],
      ['2024-06-25T16:44:00Z', 217.16037333104768],
      ['2024-06-25T16:45:00Z', 213.36787488279484],
      ['2024-06-25T16:46:00Z', 217.76589829337377],
      ['2024-06-25T16:47:00Z', 218.54670679742577],
      ['2024-06-25T16:48:00Z', 219.32751530147783],
      ['2024-06-25T16:49:00Z', 219.73651023217178],
      ['2024-06-25T16:50:00Z', 207.75880154756385],
      ['2024-06-25T16:51:00Z', 205.79350123124232],
      ['2024-06-25T16:52:00Z', 203.10582025811078],
      ['2024-06-25T16:53:00Z', 206.94081168617595],
      ['2024-06-25T16:54:00Z', 203.58386628099979],
      ['2024-06-25T16:55:00Z', 205.77225474133616],
      ['2024-06-25T16:56:00Z', 206.19187291698321],
      ['2024-06-25T16:57:00Z', 206.68585380730184],
      ['2024-06-25T16:58:00Z', 207.31262525953406],
      ['2024-06-25T16:59:00Z', 208.06156402872685],
      ['2024-06-25T17:00:00Z', 208.94860498230977],
      ['2024-06-25T17:01:00Z', 207.89690373195393],
      ['2024-06-25T17:02:00Z', 130.0922576955293],
      ['2024-06-25T17:03:00Z', 188.64227225447996],
      ['2024-06-25T17:04:00Z', 219.8214961917965],
      ['2024-06-25T17:05:00Z', 206.28748212156094],
      ['2024-06-25T17:06:00Z', 207.6525690980329],
      ['2024-06-25T17:07:00Z', 208.94860498230977],
      ['2024-06-25T17:08:00Z', 173.38198087936743],
      ['2024-06-25T17:09:00Z', 180.54204797774952],
      ['2024-06-25T17:10:00Z', 206.02190099773372],
      ['2024-06-25T17:11:00Z', 206.72303516463762],
      ['2024-06-25T17:12:00Z', 208.10936863101577],
      ['2024-06-25T17:13:00Z', 177.94466458671923],
      ['2024-06-25T17:14:00Z', 143.60502527585862],
      ['2024-06-25T17:15:00Z', 231.94793030574772],
      ['2024-06-25T17:16:00Z', 393.8568066357789],
      ['2024-06-25T17:17:00Z', 343.65135098747976],
      ['2024-06-25T17:18:00Z', 275.3491975615933],
      ['2024-06-25T17:19:00Z', 270.303156208876],
      ['2024-06-25T17:20:00Z', 266.14415580974156],
      ['2024-06-25T17:21:00Z', 263.6105118884298],
      ['2024-06-25T17:22:00Z', 263.43522834670387],
      ['2024-06-25T17:23:00Z', 262.1763738197628],
      ['2024-06-25T17:24:00Z', 262.86157311923705],
      ['2024-06-25T17:25:00Z', 261.73550915420964],
      ['2024-06-25T17:26:00Z', 248.66360623943342],
      ['2024-06-25T17:27:00Z', 207.47728555630695],
      ['2024-06-25T17:28:00Z', 208.4599357144677],
      ['2024-06-25T17:29:00Z', 205.8625523234374],
      ['2024-06-25T17:30:00Z', 207.07360224808957],
      ['2024-06-25T17:31:00Z', 206.1600031821239],
      ['2024-06-25T17:32:00Z', 205.60759444456326],
      ['2024-06-25T17:33:00Z', 206.9939279109414],
      ['2024-06-25T17:34:00Z', 205.62352931199288],
      ['2024-06-25T17:35:00Z', 206.85051410407468],
      ['2024-06-25T17:36:00Z', 205.0498740845261],
      ['2024-06-25T17:37:00Z', 205.41637603540767],
      ['2024-06-25T17:38:00Z', 204.61432104144944],
      ['2024-06-25T17:39:00Z', 216.77793651273646],
      ['2024-06-25T17:40:00Z', 210.63770092985095],
      ['2024-06-25T17:41:00Z', 218.37142325569982],
      ['2024-06-25T17:42:00Z', 216.3264486022302],
      ['2024-06-25T17:43:00Z', 217.2347360457193],
      ['2024-06-25T17:44:00Z', 217.36221498515636],
      ['2024-06-25T17:45:00Z', 217.4631358122107],
      ['2024-06-25T17:46:00Z', 217.6277961089836],
      ['2024-06-25T17:47:00Z', 217.6490425988898],
      ['2024-06-25T17:48:00Z', 209.77721808865076],
      ['2024-06-25T17:49:00Z', 205.20922275882242],
      ['2024-06-25T17:50:00Z', 205.52792010741507],
      ['2024-06-25T17:51:00Z', 204.7630464707927],
      ['2024-06-25T17:52:00Z', 204.51871183687163],
      ['2024-06-25T17:53:00Z', 204.6674372662149],
      ['2024-06-25T17:54:00Z', 204.64619077630874],
      ['2024-06-25T17:55:00Z', 206.05908235506956],
      ['2024-06-25T17:56:00Z', 208.63521925619364],
      ['2024-06-25T17:57:00Z', 208.68302385848256],
      ['2024-06-25T17:58:00Z', 208.92735849240358],
      ['2024-06-25T17:59:00Z', 208.02969429386758],
      ['2024-06-25T18:00:00Z', 204.8108510730816],
      ['2024-06-25T18:01:00Z', 204.99675785976063],
      ['2024-06-25T18:02:00Z', 204.90114865518282],
      ['2024-06-25T18:03:00Z', 204.83209756298777],
      ['2024-06-25T18:04:00Z', 204.81616269555812],
      ['2024-06-25T18:05:00Z', 204.6461907763087],
      ['2024-06-25T18:06:00Z', 205.21984600377553],
      ['2024-06-25T18:07:00Z', 206.2184310293659],
      ['2024-06-25T18:08:00Z', 208.15717323330463],
      ['2024-06-25T18:09:00Z', 210.14903166200884],
      ['2024-06-25T18:10:00Z', 209.88345053818162],
      ['2024-06-25T18:11:00Z', 210.02155272257176],
      ['2024-06-25T18:12:00Z', 208.83174928782583],
      ['2024-06-25T18:13:00Z', 208.23684757045282],
      ['2024-06-25T18:14:00Z', 208.18373134568736],
      ['2024-06-25T18:15:00Z', 208.0456291612972],
      ['2024-06-25T18:16:00Z', 207.89690373195396],
      ['2024-06-25T18:17:00Z', 207.6472574755564],
      ['2024-06-25T18:18:00Z', 204.7524232258396],
      ['2024-06-25T18:19:00Z', 204.98613461480755],
      ['2024-06-25T18:20:00Z', 205.86255232343743],
      ['2024-06-25T18:21:00Z', 206.43620755090421],
      ['2024-06-25T18:22:00Z', 208.35901488741334],
      ['2024-06-25T18:23:00Z', 214.11681365198763],
      ['2024-06-25T18:24:00Z', 215.95463502887208],
      ['2024-06-25T18:25:00Z', 212.68267558332062],
      ['2024-06-25T18:26:00Z', 212.36928985720445],
      ['2024-06-25T18:27:00Z', 209.32041855566789],
      ['2024-06-25T18:28:00Z', 205.98471964039794],
      ['2024-06-25T18:29:00Z', 207.02579764580065],
      ['2024-06-25T18:30:00Z', 206.97268142103522],
      ['2024-06-25T18:31:00Z', 207.05766738065995],
      ['2024-06-25T18:32:00Z', 207.76942479251687],
      ['2024-06-25T18:33:00Z', 207.98188969157866],
      ['2024-06-25T18:34:00Z', 208.15717323330466],
      ['2024-06-25T18:35:00Z', 209.01765607450488],
      ['2024-06-25T18:36:00Z', 210.1649665294385],
      ['2024-06-25T18:37:00Z', 210.91390529863128],
      ['2024-06-25T18:38:00Z', 211.50349539352771],
      ['2024-06-25T18:39:00Z', 212.47552230673537],
      ['2024-06-25T18:40:00Z', 181.75840952487823],
      ['2024-06-25T18:41:00Z', 169.037073693554],
      ['2024-06-25T18:42:00Z', 208.1890429681639],
      ['2024-06-25T18:43:00Z', 209.62318103683094],
      ['2024-06-25T18:44:00Z', 210.8182960940535],
      ['2024-06-25T18:45:00Z', 211.94436005908094],
      ['2024-06-25T18:46:00Z', 193.55552304528365],
      ['2024-06-25T18:47:00Z', 140.11528930876887],
      ['2024-06-25T18:48:00Z', 197.6985885769884],
      ['2024-06-25T18:49:00Z', 222.36576335806134],
      ['2024-06-25T18:50:00Z', 209.214186106137],
      ['2024-06-25T18:51:00Z', 210.29244546887554],
      ['2024-06-25T18:52:00Z', 211.2644723820832],
      ['2024-06-25T18:53:00Z', 212.11433197833034],
      ['2024-06-25T18:54:00Z', 164.03352532064898],
      ['2024-06-25T18:55:00Z', 165.24457524530118],
      ['2024-06-25T18:56:00Z', 233.8282446624445],
      ['2024-06-25T18:57:00Z', 234.75246697336325],
      ['2024-06-25T18:58:00Z', 208.57147978647515],
      ['2024-06-25T18:59:00Z', 209.75065997626803],
      ['2024-06-25T19:00:00Z', 210.99889125825598],
      ['2024-06-25T19:01:00Z', 176.68581005977813],
      ['2024-06-25T19:02:00Z', 184.03178394483925],
      ['2024-06-25T19:03:00Z', 209.2248093510901],
      ['2024-06-25T19:04:00Z', 211.53536512838699],
      ['2024-06-25T19:05:00Z', 179.1238447765121],
      ['2024-06-25T19:06:00Z', 133.5979285300487],
      ['2024-06-25T19:07:00Z', 231.21492640398458],
      ['2024-06-25T19:08:00Z', 216.34769509213635],
      ['2024-06-25T19:09:00Z', 210.403989540883],
      ['2024-06-25T19:10:00Z', 202.57996963293283],
      ['2024-06-25T19:11:00Z', 134.58589031068598],
      ['2024-06-25T19:12:00Z', 185.2906384717803],
      ['2024-06-25T19:13:00Z', 235.74042875400053],
      ['2024-06-25T19:14:00Z', 210.61114281746828],
      ['2024-06-25T19:15:00Z', 164.52750621096766],
      ['2024-06-25T19:16:00Z', 147.25410991724476],
      ['2024-06-25T19:17:00Z', 195.48895362674588],
      ['2024-06-25T19:18:00Z', 198.08633701777615],
      ['2024-06-25T19:19:00Z', 126.6821960655877],
      ['2024-06-25T19:20:00Z', 177.47193018630674],
      ['2024-06-25T19:21:00Z', 213.18727971859235],
      ['2024-06-25T19:22:00Z', 195.00559598138034],
      ['2024-06-25T19:23:00Z', 199.55234482130246],
      ['2024-06-25T19:24:00Z', 200.3437765703076],
      ['2024-06-25T19:25:00Z', 196.5884594793906],
      ['2024-06-25T19:26:00Z', 196.46098053995354],
      ['2024-06-25T19:27:00Z', 196.68938030644495],
      ['2024-06-25T19:28:00Z', 171.53884788000647],
      ['2024-06-25T19:29:00Z', 94.90807041089815],
      ['2024-06-25T19:30:00Z', 94.80183796136726],
      ['2024-06-25T19:31:00Z', 94.71685200174254],
      ['2024-06-25T19:32:00Z', 94.75934498155489],
      ['2024-06-25T19:33:00Z', 94.65311253202401],
      ['2024-06-25T19:34:00Z', 94.71685200174255],
      ['2024-06-25T19:35:00Z', 94.74872173660182],
      ['2024-06-25T19:36:00Z', 94.71685200174255],
      ['2024-06-25T19:37:00Z', 94.41940114305605],
      ['2024-06-25T19:38:00Z', 93.95197836512014],
      ['2024-06-25T19:39:00Z', 93.15523499363844],
      ['2024-06-25T19:40:00Z', 92.91090035971739],
      ['2024-06-25T19:41:00Z', 92.96401658448283],
      ['2024-06-25T19:42:00Z', 92.97463982943593],
      ['2024-06-25T19:43:00Z', 92.78873304275687],
      ['2024-06-25T19:44:00Z', 92.14602672309498],
      ['2024-06-25T19:45:00Z', 87.00437616579984],
      ['2024-06-25T19:46:00Z', 71.42007581961812],
      ['2024-06-25T19:47:00Z', 78.82978917439776],
      ['2024-06-25T19:48:00Z', 78.49515695837547],
      ['2024-06-25T19:49:00Z', 77.95337146576792],
      ['2024-06-25T19:50:00Z', 77.06101888970844],
      ['2024-06-25T19:51:00Z', 76.47142879481197],
      ['2024-06-25T19:52:00Z', 76.50861015214781],
      ['2024-06-25T19:53:00Z', 75.97744790449335],
      ['2024-06-25T19:54:00Z', 75.46753214674506],
      ['2024-06-25T19:55:00Z', 75.54720648389323],
      ['2024-06-25T19:56:00Z', 75.73842489304884],
      ['2024-06-25T19:57:00Z', 75.5312716164636],
      ['2024-06-25T19:58:00Z', 75.62688082104141],
      ['2024-06-25T19:59:00Z', 75.63750406599449],
      ['2024-06-25T20:00:00Z', 75.74373651552538],
      ['2024-06-25T20:01:00Z', 75.4356624118858],
      ['2024-06-25T20:02:00Z', 75.5312716164636],
      ['2024-06-25T20:03:00Z', 75.54720648389323],
      ['2024-06-25T20:04:00Z', 75.3878578095969],
      ['2024-06-25T20:05:00Z', 74.94168152156715],
      ['2024-06-25T20:06:00Z', 75.08509532843385],
      ['2024-06-25T20:07:00Z', 75.04260234862149],
      ['2024-06-25T20:08:00Z', 75.03729072614496],
      ['2024-06-25T20:09:00Z', 75.06916046100423],
      ['2024-06-25T20:10:00Z', 74.86200718441899],
      ['2024-06-25T20:11:00Z', 75.24444400273019],
      ['2024-06-25T20:12:00Z', 75.02135585871532],
      ['2024-06-25T20:13:00Z', 75.13289993072276],
      ['2024-06-25T20:14:00Z', 75.00542099128569],
      ['2024-06-25T20:15:00Z', 76.39175445766381],
      ['2024-06-25T20:16:00Z', 76.37581959023419],
      ['2024-06-25T20:17:00Z', 76.31208012051566],
      ['2024-06-25T20:18:00Z', 76.21647091593786],
      ['2024-06-25T20:19:00Z', 75.72249002561921],
      ['2024-06-25T20:20:00Z', 75.10103019586349],
      ['2024-06-25T20:21:00Z', 75.19132777796473],
      ['2024-06-25T20:22:00Z', 75.05322559357458],
      ['2024-06-25T20:23:00Z', 74.94168152156715],
      ['2024-06-25T20:24:00Z', 74.91512340918443],
      ['2024-06-25T20:25:00Z', 74.8142025821301],
      ['2024-06-25T20:26:00Z', 74.76639797984117],
      ['2024-06-25T20:27:00Z', 74.80889095965354],
      ['2024-06-25T20:28:00Z', 74.73452824498192],
      ['2024-06-25T20:29:00Z', 74.79826771470044],
      ['2024-06-25T20:30:00Z', 74.79826771470046],
      ['2024-06-25T20:31:00Z', 74.57517957068558],
      ['2024-06-25T20:32:00Z', 74.38396116152998],
      ['2024-06-25T20:33:00Z', 74.36802629410033],
      ['2024-06-25T20:34:00Z', 73.85279891387552],
      ['2024-06-25T20:35:00Z', 73.53410156528285],
      ['2024-06-25T20:36:00Z', 73.33225991117415],
      ['2024-06-25T20:37:00Z', 73.39599938089268],
      ['2024-06-25T20:38:00Z', 73.33225991117415],
      ['2024-06-25T20:39:00Z', 73.33225991117416],
      ['2024-06-25T20:40:00Z', 73.36412964603342],
      ['2024-06-25T20:41:00Z', 73.57128292261866],
      ['2024-06-25T20:42:00Z', 73.47567371804085],
      ['2024-06-25T20:43:00Z', 73.53410156528284],
      ['2024-06-25T20:44:00Z', 73.49160858547049],
      ['2024-06-25T20:45:00Z', 73.47036209556431],
      ['2024-06-25T20:46:00Z', 73.04543229744074],
      ['2024-06-25T20:47:00Z', 70.3205699669734],
      ['2024-06-25T20:48:00Z', 70.3205699669734],
      ['2024-06-25T20:49:00Z', 70.43211403898084],
      ['2024-06-25T20:50:00Z', 70.5595929784179],
      ['2024-06-25T20:51:00Z', 72.53551653969247],
      ['2024-06-25T20:52:00Z', 72.6948652139888],
      ['2024-06-25T20:53:00Z', 72.6948652139888],
      ['2024-06-25T20:54:00Z', 73.02418580753458],
      ['2024-06-25T20:55:00Z', 73.12510663458893],
      ['2024-06-25T20:56:00Z', 73.25789719650254],
      ['2024-06-25T20:57:00Z', 73.55534805518901],
      ['2024-06-25T20:58:00Z', 75.30818347244873],
      ['2024-06-25T20:59:00Z', 76.10492684393041],
      ['2024-06-25T21:00:00Z', 75.97744790449335],
      ['2024-06-25T21:01:00Z', 75.9137084347748],
      ['2024-06-25T21:02:00Z', 75.2338207577771],
      ['2024-06-25T21:03:00Z', 74.87263042937208],
      ['2024-06-25T21:04:00Z', 74.66016553031028],
      ['2024-06-25T21:05:00Z', 74.67078877526338],
      ['2024-06-25T21:06:00Z', 74.66016553031028],
      ['2024-06-25T21:07:00Z', 74.57517957068558],
      ['2024-06-25T21:08:00Z', 74.5539330807794],
      ['2024-06-25T21:09:00Z', 74.60704930554483],
      ['2024-06-25T21:10:00Z', 74.61767255049791],
      ['2024-06-25T21:11:00Z', 74.7345282449819],
      ['2024-06-25T21:12:00Z', 74.61767255049791],
      ['2024-06-25T21:13:00Z', 74.60704930554483],
      ['2024-06-25T21:14:00Z', 74.75046311241155],
      ['2024-06-25T21:15:00Z', 74.72390500002882],
      ['2024-06-25T21:16:00Z', 74.67078877526339],
      ['2024-06-25T21:17:00Z', 74.57517957068558],
      ['2024-06-25T21:18:00Z', 74.5433098358263],
      ['2024-06-25T21:19:00Z', 74.49019361106086],
      ['2024-06-25T21:20:00Z', 74.51144010096704],
      ['2024-06-25T21:21:00Z', 74.78764446974736],
      ['2024-06-25T21:22:00Z', 74.81420258213008],
      ['2024-06-25T21:23:00Z', 75.12758830824622],
      ['2024-06-25T21:24:00Z', 75.340053207308],
      ['2024-06-25T21:25:00Z', 75.51533674903396],
      ['2024-06-25T21:26:00Z', 75.65875055590067],
      ['2024-06-25T21:27:00Z', 75.75435976047848],
      ['2024-06-25T21:28:00Z', 75.70124353571303],
      ['2024-06-25T21:29:00Z', 75.57907621875249],
      ['2024-06-25T21:30:00Z', 75.27631373758946],
      ['2024-06-25T21:31:00Z', 75.18070453301166],
      ['2024-06-25T21:32:00Z', 75.36129969721418],
      ['2024-06-25T21:33:00Z', 75.17008128805857],
      ['2024-06-25T21:34:00Z', 75.38785780959688],
      ['2024-06-25T21:35:00Z', 75.46753214674506],
      ['2024-06-25T21:36:00Z', 76.34394985537492],
      ['2024-06-25T21:37:00Z', 78.28800368179024],
      ['2024-06-25T21:38:00Z', 77.69841358689378],
      ['2024-06-25T21:39:00Z', 77.37971623830111],
      ['2024-06-25T21:40:00Z', 77.44345570801964],
      ['2024-06-25T21:41:00Z', 77.23099080895786],
      ['2024-06-25T21:42:00Z', 76.98134455256027],
      ['2024-06-25T21:43:00Z', 76.80606101083428],
      ['2024-06-25T21:44:00Z', 76.74232154111576],
      ['2024-06-25T21:45:00Z', 76.55110313196015],
      ['2024-06-25T21:46:00Z', 76.59359611177251],
      ['2024-06-25T21:47:00Z', 76.46611717233544],
      ['2024-06-25T21:48:00Z', 76.43955905995273],
      ['2024-06-25T21:49:00Z', 76.29614525308601],
      ['2024-06-25T21:50:00Z', 76.26427551822675],
      ['2024-06-25T21:51:00Z', 76.13679657878967],
      ['2024-06-25T21:52:00Z', 76.16866631364894],
      ['2024-06-25T21:53:00Z', 76.16866631364894],
      ['2024-06-25T21:54:00Z', 76.16866631364894],
      ['2024-06-25T21:55:00Z', 76.26427551822675],
      ['2024-06-25T21:56:00Z', 76.23240578336748],
      ['2024-06-25T21:57:00Z', 76.23240578336748],
      ['2024-06-25T21:58:00Z', 76.23240578336747],
      ['2024-06-25T21:59:00Z', 76.10492684393041],
      ['2024-06-25T22:00:00Z', 76.08899197650078],
      ['2024-06-25T22:01:00Z', 76.07305710907116],
      ['2024-06-25T22:02:00Z', 75.97744790449333],
      ['2024-06-25T22:03:00Z', 75.96151303706371],
      ['2024-06-25T22:04:00Z', 76.13679657878967],
      ['2024-06-25T22:05:00Z', 76.69451693882687],
      ['2024-06-25T22:06:00Z', 77.92150173090866],
      ['2024-06-25T22:07:00Z', 85.90487031315513],
      ['2024-06-25T22:08:00Z', 88.02420768129639],
      ['2024-06-25T22:09:00Z', 85.53836836227356],
      ['2024-06-25T22:10:00Z', 85.41088942283648],
      ['2024-06-25T22:11:00Z', 85.07625720681418],
      ['2024-06-25T22:12:00Z', 82.57448302036167],
      ['2024-06-25T22:13:00Z', 82.03269752775414],
      ['2024-06-25T22:14:00Z', 81.92646507822325],
      ['2024-06-25T22:15:00Z', 82.11768348737884],
      ['2024-06-25T22:16:00Z', 82.11768348737884],
      ['2024-06-25T22:17:00Z', 82.13892997728503],
      ['2024-06-25T22:18:00Z', 82.24516242681592],
      ['2024-06-25T22:19:00Z', 82.70196195979875],
      ['2024-06-25T22:20:00Z', 83.21187771754704],
      ['2024-06-25T22:21:00Z', 83.08439877810997],
      ['2024-06-25T22:22:00Z', 83.2437474524063],
      ['2024-06-25T22:23:00Z', 86.54226501034047],
      ['2024-06-25T22:24:00Z', 90.04793584485988],
      ['2024-06-25T22:25:00Z', 87.99233794643712],
      ['2024-06-25T22:26:00Z', 81.12441008426502],
      ['2024-06-25T22:27:00Z', 78.3570547739853],
      ['2024-06-25T22:28:00Z', 80.5029502545093],
      ['2024-06-25T22:29:00Z', 81.65026070944293],
      ['2024-06-25T22:30:00Z', 82.04863239518377],
      ['2024-06-25T22:31:00Z', 86.98844129837022],
      ['2024-06-25T22:32:00Z', 95.94383679382433],
      ['2024-06-25T22:33:00Z', 91.08370222778608],
      ['2024-06-25T22:34:00Z', 88.7253418482003],
      ['2024-06-25T22:35:00Z', 88.98029972707441],
      ['2024-06-25T22:36:00Z', 89.42647601510417],
      ['2024-06-25T22:37:00Z', 89.18745300365964],
      ['2024-06-25T22:38:00Z', 84.85316906279931],
      ['2024-06-25T22:39:00Z', 80.85351733796125],
      ['2024-06-25T22:40:00Z', 80.8853870728205],
      ['2024-06-25T22:41:00Z', 81.58652123972439],
      ['2024-06-25T22:42:00Z', 83.57837966842861],
      ['2024-06-25T22:43:00Z', 87.7851846698519],
      ['2024-06-25T22:44:00Z', 94.10070379446336],
      ['2024-06-25T22:45:00Z', 90.55253998013161],
      ['2024-06-25T22:46:00Z', 89.02810432936332],
      ['2024-06-25T22:47:00Z', 83.0525290432507],
      ['2024-06-25T22:48:00Z', 83.06846391068032],
      ['2024-06-25T22:49:00Z', 85.01251773709564],
      ['2024-06-25T22:50:00Z', 86.52633014291084],
      ['2024-06-25T22:51:00Z', 94.78059147146107],
      ['2024-06-25T22:52:00Z', 98.49872720504226],
      ['2024-06-25T22:53:00Z', 94.76465660403144],
      ['2024-06-25T22:54:00Z', 87.54616165840739],
      ['2024-06-25T22:55:00Z', 82.22391593690975],
      ['2024-06-25T22:56:00Z', 85.7455216388588],
      ['2024-06-25T22:57:00Z', 85.85706571086622],
      ['2024-06-25T22:58:00Z', 85.90487031315513],
      ['2024-06-25T22:59:00Z', 86.45196742823923],
      ['2024-06-25T23:00:00Z', 86.22356766174781],
      ['2024-06-25T23:01:00Z', 86.23950252917744],
      ['2024-06-25T23:02:00Z', 86.09077709983417],
      ['2024-06-25T23:03:00Z', 86.02703763011566],
      ['2024-06-25T23:04:00Z', 85.5808613420859],
      ['2024-06-25T23:05:00Z', 84.83723419536966],
      ['2024-06-25T23:06:00Z', 84.66726227612024],
      ['2024-06-25T23:07:00Z', 84.91690853251782],
      ['2024-06-25T23:08:00Z', 84.81598770546348],
      ['2024-06-25T23:09:00Z', 84.86910393022893],
      ['2024-06-25T23:10:00Z', 84.88503879765857],
      ['2024-06-25T23:11:00Z', 84.88503879765858],
      ['2024-06-25T23:12:00Z', 84.30607194771521],
      ['2024-06-25T23:13:00Z', 80.12051343619811],
      ['2024-06-25T23:14:00Z', 79.96116476190176],
      ['2024-06-25T23:15:00Z', 79.96116476190176],
      ['2024-06-25T23:16:00Z', 82.19204620205048],
      ['2024-06-25T23:17:00Z', 82.12830673233194],
      ['2024-06-25T23:18:00Z', 82.22391593690975],
      ['2024-06-25T23:19:00Z', 82.38326461120609],
      ['2024-06-25T23:20:00Z', 82.22391593690975],
      ['2024-06-25T23:21:00Z', 82.63822249008021],
      ['2024-06-25T23:22:00Z', 87.6895754652741],
      ['2024-06-25T23:23:00Z', 94.39815465314987],
      ['2024-06-25T23:24:00Z', 90.04262422238332],
      ['2024-06-25T23:25:00Z', 80.40734104993152],
      ['2024-06-25T23:26:00Z', 77.5071951777382],
      ['2024-06-25T23:27:00Z', 77.63467411717525],
      ['2024-06-25T23:28:00Z', 77.60280438231598],
      ['2024-06-25T23:29:00Z', 79.71683012798071],
      ['2024-06-25T23:30:00Z', 81.58652123972439],
      ['2024-06-25T23:31:00Z', 81.58652123972439],
      ['2024-06-25T23:32:00Z', 80.78977786824271],
      ['2024-06-25T23:33:00Z', 79.65309065826217],
      ['2024-06-25T23:34:00Z', 79.81775095503505],
      ['2024-06-25T23:35:00Z', 80.39671780497841],
      ['2024-06-25T23:36:00Z', 80.71541515357107],
      ['2024-06-25T23:37:00Z', 81.05535899206994],
      ['2024-06-25T23:38:00Z', 81.07660548197612],
      ['2024-06-25T23:39:00Z', 81.04473574711685],
      ['2024-06-25T23:40:00Z', 81.26782389113173],
      ['2024-06-25T23:41:00Z', 81.31031687094408],
      ['2024-06-25T23:42:00Z', 81.63432584201328],
      ['2024-06-25T23:43:00Z', 82.92505010381365],
      ['2024-06-25T23:44:00Z', 85.51712187236738],
      ['2024-06-25T23:45:00Z', 84.82129932794004],
      ['2024-06-25T23:46:00Z', 83.7695980775842],
      ['2024-06-25T23:47:00Z', 83.5783796684286],
      ['2024-06-25T23:48:00Z', 83.32342178955446],
      ['2024-06-25T23:49:00Z', 83.68992374043604],
      ['2024-06-25T23:50:00Z', 84.29544870276213],
      ['2024-06-25T23:51:00Z', 86.62193934748862],
      ['2024-06-25T23:52:00Z', 89.55395495454123],
      ['2024-06-25T23:53:00Z', 87.46648732125922],
      ['2024-06-25T23:54:00Z', 88.06670066110875],
      ['2024-06-25T23:55:00Z', 91.94418506898629],
      ['2024-06-25T23:56:00Z', 97.47889568954572],
      ['2024-06-25T23:57:00Z', 94.19100137656463],
      ['2024-06-25T23:58:00Z', 89.85140581322771],
      ['2024-06-25T23:59:00Z', 89.9576382627586],
      ['2024-06-26T00:00:00Z', 91.73703179240104],
      ['2024-06-26T00:01:00Z', 91.65735745525289],
      ['2024-06-26T00:02:00Z', 91.13150683007495],
      ['2024-06-26T00:03:00Z', 87.54616165840739],
      ['2024-06-26T00:04:00Z', 82.8613106340951],
      ['2024-06-26T00:05:00Z', 82.89318036895438],
      ['2024-06-26T00:06:00Z', 82.95691983867289],
      ['2024-06-26T00:07:00Z', 85.3790196879772],
      ['2024-06-26T00:08:00Z', 86.606004480059],
      ['2024-06-26T00:09:00Z', 91.4820739135269],
      ['2024-06-26T00:10:00Z', 93.44206260737184],
      ['2024-06-26T00:11:00Z', 91.94418506898629],
      ['2024-06-26T00:12:00Z', 92.37973811206295],
      ['2024-06-26T00:13:00Z', 93.0914955239199],
      ['2024-06-26T00:14:00Z', 92.72499357303835],
      ['2024-06-26T00:15:00Z', 88.05607741615566],
      ['2024-06-26T00:16:00Z', 82.01145103784796],
      ['2024-06-26T00:17:00Z', 84.30607194771521],
      ['2024-06-26T00:18:00Z', 85.47462889255502],
      ['2024-06-26T00:19:00Z', 84.60352280640171],
      ['2024-06-26T00:20:00Z', 83.21187771754703],
      ['2024-06-26T00:21:00Z', 84.7097552559326],
      ['2024-06-26T00:22:00Z', 93.10743039134955],
      ['2024-06-26T00:23:00Z', 91.83264099697885],
      ['2024-06-26T00:24:00Z', 88.4066444996076],
      ['2024-06-26T00:25:00Z', 83.07377553315688],
      ['2024-06-26T00:26:00Z', 85.29934535082904],
      ['2024-06-26T00:27:00Z', 86.03234925259218],
      ['2024-06-26T00:28:00Z', 85.95267491544402],
      ['2024-06-26T00:29:00Z', 85.98454465030329],
      ['2024-06-26T00:30:00Z', 85.96329816039712],
      ['2024-06-26T00:31:00Z', 85.88893544572548],
      ['2024-06-26T00:32:00Z', 85.88893544572548],
      ['2024-06-26T00:33:00Z', 85.87831220077241],
      ['2024-06-26T00:34:00Z', 85.9367400480144],
      ['2024-06-26T00:35:00Z', 86.01641438516256],
      ['2024-06-26T00:36:00Z', 86.00047951773293],
      ['2024-06-26T00:37:00Z', 86.09077709983417],
      ['2024-06-26T00:38:00Z', 86.19700954936508],
      ['2024-06-26T00:39:00Z', 86.23950252917744],
      ['2024-06-26T00:40:00Z', 86.43072093833302],
      ['2024-06-26T00:41:00Z', 86.32448848880215],
      ['2024-06-26T00:42:00Z', 86.36698146861451],
      ['2024-06-26T00:43:00Z', 86.47852554062194],
      ['2024-06-26T00:44:00Z', 86.47852554062194],
      ['2024-06-26T00:45:00Z', 86.49446040805158],
      ['2024-06-26T00:46:00Z', 87.00437616579985],
      ['2024-06-26T00:47:00Z', 87.1637248400962],
      ['2024-06-26T00:48:00Z', 87.13185510523692],
      ['2024-06-26T00:49:00Z', 87.24339917724436],
      ['2024-06-26T00:50:00Z', 88.75721158305954],
      ['2024-06-26T00:51:00Z', 89.85671743570427],
      ['2024-06-26T00:52:00Z', 89.824847700845],
      ['2024-06-26T00:53:00Z', 88.38539800970142],
      ['2024-06-26T00:54:00Z', 88.17293311063965],
      ['2024-06-26T00:55:00Z', 88.08794715101493],
      ['2024-06-26T00:56:00Z', 87.6417708629852],
      ['2024-06-26T00:57:00Z', 85.85706571086622],
      ['2024-06-26T00:58:00Z', 84.23170923304357],
      ['2024-06-26T00:59:00Z', 84.45479737705845],
      ['2024-06-26T01:00:00Z', 84.39105790733993],
      ['2024-06-26T01:01:00Z', 84.78942959308075],
      ['2024-06-26T01:02:00Z', 84.94346664490057],
      ['2024-06-26T01:03:00Z', 84.78942959308075],
      ['2024-06-26T01:04:00Z', 85.66584730171063],
      ['2024-06-26T01:05:00Z', 85.98454465030329],
      ['2024-06-26T01:06:00Z', 85.96860978287364],
      ['2024-06-26T01:07:00Z', 85.87831220077241],
      ['2024-06-26T01:08:00Z', 85.7933262411477],
      ['2024-06-26T01:09:00Z', 85.72958677142915],
      ['2024-06-26T01:10:00Z', 85.28341048339942],
      ['2024-06-26T01:11:00Z', 84.39105790733991],
      ['2024-06-26T01:12:00Z', 84.50260197934736],
      ['2024-06-26T01:13:00Z', 84.58227631649552],
      ['2024-06-26T01:14:00Z', 84.26357896790284],
      ['2024-06-26T01:15:00Z', 84.12016516103614],
      ['2024-06-26T01:16:00Z', 83.78553294501384],
      ['2024-06-26T01:17:00Z', 84.94877826737711],
      ['2024-06-26T01:18:00Z', 84.82129932794003],
      ['2024-06-26T01:19:00Z', 84.90097366508819],
      ['2024-06-26T01:20:00Z', 84.96471313480673],
      ['2024-06-26T01:21:00Z', 84.56102982658933],
      ['2024-06-26T01:22:00Z', 84.37512303991029],
      ['2024-06-26T01:23:00Z', 81.02880087968721],
      ['2024-06-26T01:24:00Z', 79.35563979957567],
      ['2024-06-26T01:25:00Z', 80.29579697792407],
      ['2024-06-26T01:26:00Z', 81.23595415627244],
      ['2024-06-26T01:27:00Z', 81.20408442141319],
      ['2024-06-26T01:28:00Z', 81.20408442141319],
      ['2024-06-26T01:29:00Z', 81.17221468655393],
      ['2024-06-26T01:30:00Z', 81.20408442141319],
      ['2024-06-26T01:31:00Z', 81.26782389113173],
      ['2024-06-26T01:32:00Z', 81.16159144160083],
      ['2024-06-26T01:33:00Z', 81.10847521683539],
      ['2024-06-26T01:34:00Z', 81.16159144160083],
      ['2024-06-26T01:35:00Z', 81.17221468655393],
      ['2024-06-26T01:36:00Z', 82.11237186490231],
      ['2024-06-26T01:37:00Z', 83.94488161931017],
      ['2024-06-26T01:38:00Z', 84.07236055874725],
      ['2024-06-26T01:39:00Z', 83.67398887300641],
      ['2024-06-26T01:40:00Z', 83.80146781244348],
      ['2024-06-26T01:41:00Z', 83.83864916977929],
      ['2024-06-26T01:42:00Z', 83.64211913814714],
      ['2024-06-26T01:43:00Z', 84.07236055874725],
      ['2024-06-26T01:44:00Z', 83.97675135416945],
      ['2024-06-26T01:45:00Z', 83.7324167202484],
      ['2024-06-26T01:46:00Z', 83.7324167202484],
      ['2024-06-26T01:47:00Z', 83.66867725052987],
      ['2024-06-26T01:48:00Z', 83.33935665698411],
      ['2024-06-26T01:49:00Z', 82.20798106948011],
      ['2024-06-26T01:50:00Z', 81.28375875856136],
      ['2024-06-26T01:51:00Z', 81.39530283056878],
      ['2024-06-26T01:52:00Z', 81.42717256542807],
      ['2024-06-26T01:53:00Z', 81.90521858831706],
      ['2024-06-26T01:54:00Z', 82.19204620205048],
      ['2024-06-26T01:55:00Z', 82.19204620205048],
      ['2024-06-26T01:56:00Z', 82.25578567176902],
      ['2024-06-26T01:57:00Z', 82.41513434606534],
      ['2024-06-26T01:58:00Z', 82.22391593690975],
      ['2024-06-26T01:59:00Z', 82.09643699747267],
      ['2024-06-26T02:00:00Z', 82.09643699747267],
      ['2024-06-26T02:01:00Z', 81.94771156812942],
      ['2024-06-26T02:02:00Z', 82.01145103784796],
      ['2024-06-26T02:03:00Z', 82.00082779289487],
      ['2024-06-26T02:04:00Z', 82.03269752775414],
      ['2024-06-26T02:05:00Z', 81.90521858831707],
      ['2024-06-26T02:06:00Z', 82.03269752775414],
      ['2024-06-26T02:07:00Z', 81.82023262869235],
      ['2024-06-26T02:08:00Z', 81.90521858831706],
      ['2024-06-26T02:09:00Z', 82.03269752775414],
      ['2024-06-26T02:10:00Z', 82.00082779289487],
      ['2024-06-26T02:11:00Z', 82.08050213004304],
      ['2024-06-26T02:12:00Z', 82.12830673233194],
      ['2024-06-26T02:13:00Z', 82.03269752775414],
      ['2024-06-26T02:14:00Z', 81.80960938373927],
      ['2024-06-26T02:15:00Z', 81.79367451630964],
      ['2024-06-26T02:16:00Z', 81.71400017916146],
      ['2024-06-26T02:17:00Z', 81.7299350465911],
      ['2024-06-26T02:18:00Z', 81.6821304443022],
      ['2024-06-26T02:19:00Z', 81.52278177000585],
      ['2024-06-26T02:20:00Z', 80.71010353109455],
      ['2024-06-26T02:21:00Z', 80.71541515357107],
      ['2024-06-26T02:22:00Z', 80.53481998936857],
      ['2024-06-26T02:23:00Z', 80.66229892880563],
      ['2024-06-26T02:24:00Z', 80.8004011131958],
      ['2024-06-26T02:25:00Z', 81.42717256542805],
      ['2024-06-26T02:26:00Z', 81.41654932047497],
      ['2024-06-26T02:27:00Z', 81.76180478145037],
      ['2024-06-26T02:28:00Z', 81.71400017916146],
      ['2024-06-26T02:29:00Z', 81.58652123972439],
      ['2024-06-26T02:30:00Z', 81.45904230028732],
      ['2024-06-26T02:31:00Z', 81.22001928884282],
      ['2024-06-26T02:32:00Z', 81.52278177000585],
      ['2024-06-26T02:33:00Z', 81.35280985075643],
      ['2024-06-26T02:34:00Z', 81.35280985075643],
      ['2024-06-26T02:35:00Z', 81.92115345574669],
      ['2024-06-26T02:36:00Z', 89.824847700845],
      ['2024-06-26T02:37:00Z', 94.54688008249313],
      ['2024-06-26T02:38:00Z', 92.1832080804308],
      ['2024-06-26T02:39:00Z', 89.346801677956],
      ['2024-06-26T02:40:00Z', 79.62653254587946],
      ['2024-06-26T02:41:00Z', 78.09678527263463],
      ['2024-06-26T02:42:00Z', 81.31031687094406],
      ['2024-06-26T02:43:00Z', 82.1601764671912],
      ['2024-06-26T02:44:00Z', 91.03589762549716],
      ['2024-06-26T02:45:00Z', 93.25084419821624],
      ['2024-06-26T02:46:00Z', 88.85282078763734],
      ['2024-06-26T02:47:00Z', 86.32448848880215],
      ['2024-06-26T02:48:00Z', 82.79757116437655],
      ['2024-06-26T02:49:00Z', 83.83333754730273],
      ['2024-06-26T02:50:00Z', 88.40664449960761],
      ['2024-06-26T02:51:00Z', 89.79297796598573],
      ['2024-06-26T02:52:00Z', 88.44913747941996],
      ['2024-06-26T02:53:00Z', 88.44913747941995],
      ['2024-06-26T02:54:00Z', 88.72534184820029],
      ['2024-06-26T02:55:00Z', 89.10777866651148],
      ['2024-06-26T02:56:00Z', 88.66160237848173],
      ['2024-06-26T02:57:00Z', 88.34290502988905],
      ['2024-06-26T02:58:00Z', 84.24764410047322],
      ['2024-06-26T02:59:00Z', 86.04828412002183],
      ['2024-06-26T03:00:00Z', 86.52633014291084],
      ['2024-06-26T03:01:00Z', 87.0468691456122],
      ['2024-06-26T03:02:00Z', 86.34573497870834],
      ['2024-06-26T03:03:00Z', 85.90487031315513],
      ['2024-06-26T03:04:00Z', 80.66229892880564],
      ['2024-06-26T03:05:00Z', 79.41937926929421],
      ['2024-06-26T03:06:00Z', 79.53092334130166],
      ['2024-06-26T03:07:00Z', 79.63184416835601],
      ['2024-06-26T03:08:00Z', 79.61059767844984],
      ['2024-06-26T03:09:00Z', 80.78977786824271],
      ['2024-06-26T03:10:00Z', 81.79898613878618],
      ['2024-06-26T03:11:00Z', 81.54402825991203],
      ['2024-06-26T03:12:00Z', 80.32766671278333],
      ['2024-06-26T03:13:00Z', 79.07943543079536],
      ['2024-06-26T03:14:00Z', 78.90946351154594],
      ['2024-06-26T03:15:00Z', 79.03694245098302],
      ['2024-06-26T03:16:00Z', 79.03694245098302],
      ['2024-06-26T03:17:00Z', 79.0581889408892],
      ['2024-06-26T03:18:00Z', 79.10068192070155],
      ['2024-06-26T03:19:00Z', 79.08474705327191],
      ['2024-06-26T03:20:00Z', 79.1644213904201],
      ['2024-06-26T03:21:00Z', 79.16442139042009],
      ['2024-06-26T03:22:00Z', 79.1644213904201],
      ['2024-06-26T03:23:00Z', 79.24409572756825],
      ['2024-06-26T03:24:00Z', 80.1205134361981],
      ['2024-06-26T03:25:00Z', 81.07660548197612],
      ['2024-06-26T03:26:00Z', 87.62052437307902],
      ['2024-06-26T03:27:00Z', 86.78128802178497],
      ['2024-06-26T03:28:00Z', 85.69771703656988],
      ['2024-06-26T03:29:00Z', 80.03552747657339],
      ['2024-06-26T03:30:00Z', 78.01711093548646],
      ['2024-06-26T03:31:00Z', 78.10209689511117],
      ['2024-06-26T03:32:00Z', 78.24019907950132],
      ['2024-06-26T03:33:00Z', 79.07943543079536],
      ['2024-06-26T03:34:00Z', 80.78977786824271],
      ['2024-06-26T03:35:00Z', 80.77384300081307],
      ['2024-06-26T03:36:00Z', 80.6941686636649],
      ['2024-06-26T03:37:00Z', 80.5029502545093],
      ['2024-06-26T03:38:00Z', 79.80181608760543],
      ['2024-06-26T03:39:00Z', 79.14848652299044],
      ['2024-06-26T03:40:00Z', 79.14848652299045],
      ['2024-06-26T03:41:00Z', 79.12192841060772],
      ['2024-06-26T03:42:00Z', 79.212225992709],
      ['2024-06-26T03:43:00Z', 79.22816086013862],
      ['2024-06-26T03:44:00Z', 79.29190032985714],
      ['2024-06-26T03:45:00Z', 79.18566788032625],
      ['2024-06-26T03:46:00Z', 79.2494073500448],
      ['2024-06-26T03:47:00Z', 80.08864370133882],
      ['2024-06-26T03:48:00Z', 83.02065930839143],
      ['2024-06-26T03:49:00Z', 88.17293311063963],
      ['2024-06-26T03:50:00Z', 86.38822795852069],
      ['2024-06-26T03:51:00Z', 87.19559457495545],
      ['2024-06-26T03:52:00Z', 88.99623459450405],
      ['2024-06-26T03:53:00Z', 88.82095105277807],
      ['2024-06-26T03:54:00Z', 87.91797523176551],
      ['2024-06-26T03:55:00Z', 88.1091936409211],
      ['2024-06-26T03:56:00Z', 88.31103529502981],
      ['2024-06-26T03:57:00Z', 88.55536992895084],
      ['2024-06-26T03:58:00Z', 88.15168662073347],
      ['2024-06-26T03:59:00Z', 87.66301735289136],
      ['2024-06-26T04:00:00Z', 87.78518466985189],
      ['2024-06-26T04:01:00Z', 87.91266360928896],
      ['2024-06-26T04:02:00Z', 88.05607741615566],
      ['2024-06-26T04:03:00Z', 86.30324199889596],
      ['2024-06-26T04:04:00Z', 76.8060610108343],
      ['2024-06-26T04:05:00Z', 80.91725680767978],
      ['2024-06-26T04:06:00Z', 85.93674004801439],
      ['2024-06-26T04:07:00Z', 92.45410082673457],
      ['2024-06-26T04:08:00Z', 88.5978629087632],
      ['2024-06-26T04:09:00Z', 88.00296119139023],
      ['2024-06-26T04:10:00Z', 88.18355635559273],
      ['2024-06-26T04:11:00Z', 88.5978629087632],
      ['2024-06-26T04:12:00Z', 88.74658833810645],
      ['2024-06-26T04:13:00Z', 88.40664449960761],
      ['2024-06-26T04:14:00Z', 88.0720122835853],
      ['2024-06-26T04:15:00Z', 87.06811563551838],
      ['2024-06-26T04:16:00Z', 82.19204620205048],
      ['2024-06-26T04:17:00Z', 84.15734651837197],
      ['2024-06-26T04:18:00Z', 84.51853684677698],
      ['2024-06-26T04:19:00Z', 85.29934535082904],
      ['2024-06-26T04:20:00Z', 86.35104660118486],
      ['2024-06-26T04:21:00Z', 99.40170302605483],
      ['2024-06-26T04:22:00Z', 99.7522701095068],
      ['2024-06-26T04:23:00Z', 96.03413437592559],
      ['2024-06-26T04:24:00Z', 93.47393234223112],
      ['2024-06-26T04:25:00Z', 85.63397756685136],
      ['2024-06-26T04:26:00Z', 88.23136095788163],
      ['2024-06-26T04:27:00Z', 90.78093974662302],
      ['2024-06-26T04:28:00Z', 90.4303726631711],
      ['2024-06-26T04:29:00Z', 89.76110823112647],
      ['2024-06-26T04:30:00Z', 89.55395495454124],
      ['2024-06-26T04:31:00Z', 89.18745300365967],
      ['2024-06-26T04:32:00Z', 85.80926110857733],
      ['2024-06-26T04:33:00Z', 85.8889354457255],
      ['2024-06-26T04:34:00Z', 85.98454465030328],
      ['2024-06-26T04:35:00Z', 87.29120377953325],
      ['2024-06-26T04:36:00Z', 87.09998537037765],
      ['2024-06-26T04:37:00Z', 87.08936212542456],
      ['2024-06-26T04:38:00Z', 87.27526891210361],
      ['2024-06-26T04:39:00Z', 87.48242218868886],
      ['2024-06-26T04:40:00Z', 87.51429192354813],
      ['2024-06-26T04:41:00Z', 87.29120377953326],
      ['2024-06-26T04:42:00Z', 87.35494324925179],
      ['2024-06-26T04:43:00Z', 87.4505524538296],
      ['2024-06-26T04:44:00Z', 87.22746430981474],
      ['2024-06-26T04:45:00Z', 87.13185510523692],
      ['2024-06-26T04:46:00Z', 87.22746430981474],
      ['2024-06-26T04:47:00Z', 87.02031103322949],
      ['2024-06-26T04:48:00Z', 86.63787421491827],
      ['2024-06-26T04:49:00Z', 86.28730713146635],
      ['2024-06-26T04:50:00Z', 85.53836836227356],
      ['2024-06-26T04:51:00Z', 85.52243349484392],
      ['2024-06-26T04:52:00Z', 85.72958677142914],
      ['2024-06-26T04:53:00Z', 85.53836836227356],
      ['2024-06-26T04:54:00Z', 85.66584730171061],
      ['2024-06-26T04:55:00Z', 85.66584730171063],
      ['2024-06-26T04:56:00Z', 85.76145650628843],
      ['2024-06-26T04:57:00Z', 85.96329816039712],
      ['2024-06-26T04:58:00Z', 85.63397756685136],
      ['2024-06-26T04:59:00Z', 85.17717803386851],
      ['2024-06-26T05:00:00Z', 79.70620688302762],
      ['2024-06-26T05:01:00Z', 76.9972794199899],
      ['2024-06-26T05:02:00Z', 80.32766671278333],
      ['2024-06-26T05:03:00Z', 80.66229892880563],
      ['2024-06-26T05:04:00Z', 80.54544323432167],
      ['2024-06-26T05:05:00Z', 80.5507548567982],
      ['2024-06-26T05:06:00Z', 80.52419674441548],
      ['2024-06-26T05:07:00Z', 80.72603839852417],
      ['2024-06-26T05:08:00Z', 80.53481998936857],
      ['2024-06-26T05:09:00Z', 80.42327591736114],
      ['2024-06-26T05:10:00Z', 80.56668972422784],
      ['2024-06-26T05:11:00Z', 80.66229892880563],
      ['2024-06-26T05:12:00Z', 80.66229892880563],
      ['2024-06-26T05:13:00Z', 80.51888512193894],
      ['2024-06-26T05:14:00Z', 80.48701538707968],
      ['2024-06-26T05:15:00Z', 80.51888512193894],
      ['2024-06-26T05:16:00Z', 80.39671780497841],
      ['2024-06-26T05:17:00Z', 80.39140618250187],
      ['2024-06-26T05:18:00Z', 80.3117318453537],
      ['2024-06-26T05:19:00Z', 80.26923886554134],
      ['2024-06-26T05:20:00Z', 80.27986211049443],
      ['2024-06-26T05:21:00Z', 80.4179642948846],
      ['2024-06-26T05:22:00Z', 80.39671780497842],
      ['2024-06-26T05:23:00Z', 80.31173184535369],
      ['2024-06-26T05:24:00Z', 80.3117318453537],
      ['2024-06-26T05:25:00Z', 80.3117318453537],
      ['2024-06-26T05:26:00Z', 80.37547131507223],
      ['2024-06-26T05:27:00Z', 80.39140618250187],
      ['2024-06-26T05:28:00Z', 80.26392724306481],
      ['2024-06-26T05:29:00Z', 80.20549939582281],
      ['2024-06-26T05:30:00Z', 80.27986211049443],
      ['2024-06-26T05:31:00Z', 80.43921078479077],
      ['2024-06-26T05:32:00Z', 80.5029502545093],
      ['2024-06-26T05:33:00Z', 80.47108051965004],
      ['2024-06-26T05:34:00Z', 80.42327591736114],
      ['2024-06-26T05:35:00Z', 80.3595364476426],
      ['2024-06-26T05:36:00Z', 80.16300641601045],
      ['2024-06-26T05:37:00Z', 80.18425290591662],
      ['2024-06-26T05:38:00Z', 80.14175992610427],
      ['2024-06-26T05:39:00Z', 80.0992669462919],
      ['2024-06-26T05:40:00Z', 80.03552747657339],
      ['2024-06-26T05:41:00Z', 79.94522989447212],
      ['2024-06-26T05:42:00Z', 79.036942450983],
      ['2024-06-26T05:43:00Z', 78.39954775379766],
      ['2024-06-26T05:44:00Z', 78.59076616295327],
      ['2024-06-26T05:45:00Z', 79.11661678813118],
      ['2024-06-26T05:46:00Z', 79.10068192070155],
      ['2024-06-26T05:47:00Z', 79.73807661788689],
      ['2024-06-26T05:48:00Z', 79.73807661788689],
      ['2024-06-26T05:49:00Z', 79.70620688302762],
      ['2024-06-26T05:50:00Z', 79.78056959769924],
      ['2024-06-26T05:51:00Z', 79.78588122017578],
      ['2024-06-26T05:52:00Z', 79.88680204723013],
      ['2024-06-26T05:53:00Z', 79.99303449676103],
      ['2024-06-26T05:54:00Z', 80.00896936419066],
      ['2024-06-26T05:55:00Z', 80.1205134361981],
      ['2024-06-26T05:56:00Z', 80.39140618250187],
      ['2024-06-26T05:57:00Z', 79.84962068989432],
      ['2024-06-26T05:58:00Z', 79.46187224910658],
      ['2024-06-26T05:59:00Z', 77.65592060708143],
      ['2024-06-26T06:00:00Z', 74.41583089638925],
      ['2024-06-26T06:01:00Z', 74.19274275237437],
      ['2024-06-26T06:02:00Z', 74.27772871199909],
      ['2024-06-26T06:03:00Z', 74.87263042937208],
      ['2024-06-26T06:04:00Z', 76.08368035402424],
      ['2024-06-26T06:05:00Z', 76.0093176393526],
      ['2024-06-26T06:06:00Z', 75.94557816963408],
      ['2024-06-26T06:07:00Z', 76.04118737421189],
      ['2024-06-26T06:08:00Z', 76.10492684393041],
      ['2024-06-26T06:09:00Z', 76.0093176393526],
      ['2024-06-26T06:10:00Z', 76.10492684393041],
      ['2024-06-26T06:11:00Z', 74.0174592106484],
      ['2024-06-26T06:12:00Z', 69.5822544427337],
      ['2024-06-26T06:13:00Z', 69.81596583170165],
      ['2024-06-26T06:14:00Z', 71.96186131222565],
      ['2024-06-26T06:15:00Z', 71.96186131222564],
      ['2024-06-26T06:16:00Z', 72.07340538423308],
      ['2024-06-26T06:17:00Z', 72.12120998652199],
      ['2024-06-26T06:18:00Z', 72.13183323147507],
      ['2024-06-26T06:19:00Z', 72.18494945624053],
      ['2024-06-26T06:20:00Z', 72.02560078194419],
      ['2024-06-26T06:21:00Z', 72.02560078194419],
      ['2024-06-26T06:22:00Z', 72.004354292038],
      ['2024-06-26T06:23:00Z', 71.92999157736638],
      ['2024-06-26T06:24:00Z', 71.9937310470849],
      ['2024-06-26T06:25:00Z', 71.94592644479602],
      ['2024-06-26T06:26:00Z', 71.89812184250712],
      ['2024-06-26T06:27:00Z', 71.94061482231946],
      ['2024-06-26T06:28:00Z', 71.85562886269476],
      ['2024-06-26T06:29:00Z', 71.68565694344534],
      ['2024-06-26T06:30:00Z', 71.81844750535895],
      ['2024-06-26T06:31:00Z', 71.7281499232577],
      ['2024-06-26T06:32:00Z', 71.64316396363299],
      ['2024-06-26T06:33:00Z', 71.66441045353916],
      ['2024-06-26T06:34:00Z', 71.66441045353916],
      ['2024-06-26T06:35:00Z', 71.66441045353916],
      ['2024-06-26T06:36:00Z', 71.54755475905519],
      ['2024-06-26T06:37:00Z', 71.54755475905519],
      ['2024-06-26T06:38:00Z', 71.51568502419592],
      ['2024-06-26T06:39:00Z', 71.51568502419592],
      ['2024-06-26T06:40:00Z', 71.57942449391444],
      ['2024-06-26T06:41:00Z', 71.61129422877372],
      ['2024-06-26T06:42:00Z', 71.57942449391446],
      ['2024-06-26T06:43:00Z', 71.62722909620335],
      ['2024-06-26T06:44:00Z', 71.67503369849226],
      ['2024-06-26T06:45:00Z', 71.60067098382063],
      ['2024-06-26T06:46:00Z', 71.70690343335151],
      ['2024-06-26T06:47:00Z', 71.54755475905519],
      ['2024-06-26T06:48:00Z', 71.40414095218848],
      ['2024-06-26T06:49:00Z', 71.48381528933665],
      ['2024-06-26T06:50:00Z', 71.46788042190701],
      ['2024-06-26T06:51:00Z', 71.51568502419592],
      ['2024-06-26T06:52:00Z', 71.48381528933665],
      ['2024-06-26T06:53:00Z', 71.45194555447738],
      ['2024-06-26T06:54:00Z', 71.51568502419592],
      ['2024-06-26T06:55:00Z', 71.47319204438357],
      ['2024-06-26T06:56:00Z', 71.40414095218848],
      ['2024-06-26T06:57:00Z', 71.51568502419592],
      ['2024-06-26T06:58:00Z', 71.46788042190703],
      ['2024-06-26T06:59:00Z', 71.45194555447739],
      ['2024-06-26T07:00:00Z', 71.34571310494648],
      ['2024-06-26T07:01:00Z', 71.49975015676628],
      ['2024-06-26T07:02:00Z', 71.57942449391446],
      ['2024-06-26T07:03:00Z', 71.45194555447739],
      ['2024-06-26T07:04:00Z', 71.43601068704776],
      ['2024-06-26T07:05:00Z', 71.55817800400827],
      ['2024-06-26T07:06:00Z', 71.46788042190703],
      ['2024-06-26T07:07:00Z', 71.64316396363299],
      ['2024-06-26T07:08:00Z', 71.57942449391446],
      ['2024-06-26T07:09:00Z', 71.68565694344534],
      ['2024-06-26T07:10:00Z', 71.79188939297622],
      ['2024-06-26T07:11:00Z', 71.94592644479603],
      ['2024-06-26T07:12:00Z', 72.04684727185035],
      ['2024-06-26T07:13:00Z', 71.96186131222565],
      ['2024-06-26T07:14:00Z', 71.96186131222565],
      ['2024-06-26T07:15:00Z', 71.83438237278858],
      ['2024-06-26T07:16:00Z', 71.80251263792931],
      ['2024-06-26T07:17:00Z', 71.75470803564042],
      ['2024-06-26T07:18:00Z', 71.77064290307005],
      ['2024-06-26T07:19:00Z', 71.7281499232577],
      ['2024-06-26T07:20:00Z', 71.64316396363299],
      ['2024-06-26T07:21:00Z', 71.78657777049968],
      ['2024-06-26T07:22:00Z', 71.8131358828824],
      ['2024-06-26T07:23:00Z', 71.64316396363299],
      ['2024-06-26T07:24:00Z', 83.14813824782848],
      ['2024-06-26T07:25:00Z', 116.00583488773313],
      ['2024-06-26T07:26:00Z', 103.09859226972985],
      ['2024-06-26T07:27:00Z', 109.791236590176],
      ['2024-06-26T07:28:00Z', 111.96900180555927],
      ['2024-06-26T07:29:00Z', 109.99838986676123],
      ['2024-06-26T07:30:00Z', 108.4208379912275],
      ['2024-06-26T07:31:00Z', 108.29335905179043],
      ['2024-06-26T07:32:00Z', 108.26148931693116],
      ['2024-06-26T07:33:00Z', 108.19774984721263],
      ['2024-06-26T07:34:00Z', 108.26148931693118],
      ['2024-06-26T07:35:00Z', 108.2296195820719],
      ['2024-06-26T07:36:00Z', 108.16588011235336],
      ['2024-06-26T07:37:00Z', 108.10214064263482],
      ['2024-06-26T07:38:00Z', 108.2296195820719],
      ['2024-06-26T07:39:00Z', 108.25086607197808],
      ['2024-06-26T07:40:00Z', 108.19774984721263],
      ['2024-06-26T07:41:00Z', 108.18712660225953],
      ['2024-06-26T07:42:00Z', 108.2296195820719],
      ['2024-06-26T07:43:00Z', 108.18712660225954],
      ['2024-06-26T07:44:00Z', 108.14994524492373],
      ['2024-06-26T07:45:00Z', 108.123387132541],
      ['2024-06-26T07:46:00Z', 108.14463362244719],
      ['2024-06-26T07:47:00Z', 108.13401037749409],
      ['2024-06-26T07:48:00Z', 108.16588011235336],
      ['2024-06-26T07:49:00Z', 108.19774984721263],
      ['2024-06-26T07:50:00Z', 108.25086607197808],
      ['2024-06-26T07:51:00Z', 108.1340103774941],
      ['2024-06-26T07:52:00Z', 108.16588011235336],
      ['2024-06-26T07:53:00Z', 108.20837309216573],
      ['2024-06-26T07:54:00Z', 108.10214064263482],
      ['2024-06-26T07:55:00Z', 108.123387132541],
      ['2024-06-26T07:56:00Z', 108.18712660225954],
      ['2024-06-26T07:57:00Z', 108.21368471464227],
      ['2024-06-26T07:58:00Z', 108.10214064263482],
      ['2024-06-26T07:59:00Z', 108.18712660225954],
      ['2024-06-26T08:00:00Z', 108.0384011729163],
      ['2024-06-26T08:01:00Z', 108.02246630548666],
      ['2024-06-26T08:02:00Z', 108.181814979783],
      ['2024-06-26T08:03:00Z', 108.10214064263484],
      ['2024-06-26T08:04:00Z', 108.07027090777557],
      ['2024-06-26T08:05:00Z', 108.14463362244719],
      ['2024-06-26T08:06:00Z', 108.01715468301012],
      ['2024-06-26T08:07:00Z', 108.08620577520519],
      ['2024-06-26T08:08:00Z', 108.08620577520519],
      ['2024-06-26T08:09:00Z', 108.07027090777555],
      ['2024-06-26T08:10:00Z', 108.07027090777555],
      ['2024-06-26T08:11:00Z', 108.13401037749409],
      ['2024-06-26T08:12:00Z', 108.0384011729163],
      ['2024-06-26T08:13:00Z', 108.07027090777557],
      ['2024-06-26T08:14:00Z', 108.07027090777557],
      ['2024-06-26T08:15:00Z', 108.10214064263482],
      ['2024-06-26T08:16:00Z', 108.0862057752052],
      ['2024-06-26T08:17:00Z', 108.00653143805702],
      ['2024-06-26T08:18:00Z', 108.03840117291628],
      ['2024-06-26T08:19:00Z', 107.97466170319775],
      ['2024-06-26T08:20:00Z', 107.97466170319774],
      ['2024-06-26T08:21:00Z', 108.13401037749409],
      ['2024-06-26T08:22:00Z', 108.19774984721262],
      ['2024-06-26T08:23:00Z', 107.97466170319775],
      ['2024-06-26T08:24:00Z', 108.10214064263482],
      ['2024-06-26T08:25:00Z', 107.9427919683385],
      ['2024-06-26T08:26:00Z', 107.97466170319775],
      ['2024-06-26T08:27:00Z', 108.07027090777555],
      ['2024-06-26T08:28:00Z', 108.10214064263482],
      ['2024-06-26T08:29:00Z', 107.97466170319774],
      ['2024-06-26T08:30:00Z', 108.08620577520519],
      ['2024-06-26T08:31:00Z', 108.93075374897579],
      ['2024-06-26T08:32:00Z', 110.65171943137621],
      ['2024-06-26T08:33:00Z', 112.43642458349518],
      ['2024-06-26T08:34:00Z', 113.59966990585845],
      ['2024-06-26T08:35:00Z', 113.96617185674002],
      ['2024-06-26T08:36:00Z', 114.10958566360672],
      ['2024-06-26T08:37:00Z', 114.43359463467594],
      ['2024-06-26T08:38:00Z', 115.20909151625145],
      ['2024-06-26T08:39:00Z', 115.76681187628863],
      ['2024-06-26T08:40:00Z', 115.92084892810841],
      ['2024-06-26T08:41:00Z', 116.00583488773314],
      ['2024-06-26T08:42:00Z', 115.97396515287386],
      ['2024-06-26T08:43:00Z', 115.87835594829603],
      ['2024-06-26T08:44:00Z', 115.8942908157257],
      ['2024-06-26T08:45:00Z', 115.89960243820225],
      ['2024-06-26T08:46:00Z', 113.03132630086817],
      ['2024-06-26T08:47:00Z', 112.78699166694713],
      ['2024-06-26T08:48:00Z', 112.73387544218168],
      ['2024-06-26T08:49:00Z', 112.75512193208787],
      ['2024-06-26T08:50:00Z', 112.57983839036189],
      ['2024-06-26T08:51:00Z', 112.53203378807297],
      ['2024-06-26T08:52:00Z', 112.54265703302606],
      ['2024-06-26T08:53:00Z', 112.415178093589],
      ['2024-06-26T08:54:00Z', 112.28769915415194],
      ['2024-06-26T08:55:00Z', 112.03805289775435],
      ['2024-06-26T08:56:00Z', 111.68748581430239],
      ['2024-06-26T08:57:00Z', 111.3050489959912],
      ['2024-06-26T08:58:00Z', 110.94917029006272],
      ['2024-06-26T08:59:00Z', 111.1616351891245],
      ['2024-06-26T09:00:00Z', 111.14570032169486],
      ['2024-06-26T09:01:00Z', 111.1616351891245],
      ['2024-06-26T09:02:00Z', 111.20412816893685],
      ['2024-06-26T09:03:00Z', 111.20412816893685],
      ['2024-06-26T09:04:00Z', 111.820276376216],
      ['2024-06-26T09:05:00Z', 112.09648074499633],
      ['2024-06-26T09:06:00Z', 112.37268511377664],
      ['2024-06-26T09:07:00Z', 112.52141054311988],
      ['2024-06-26T09:08:00Z', 112.98883332105584],
      ['2024-06-26T09:09:00Z', 113.28628417974231],
      ['2024-06-26T09:10:00Z', 113.94492536683384],
      ['2024-06-26T09:11:00Z', 113.93430212188072],
      ['2024-06-26T09:12:00Z', 113.79619993749061],
      ['2024-06-26T09:13:00Z', 113.64747450814735],
      ['2024-06-26T09:14:00Z', 113.83869291730294],
      ['2024-06-26T09:15:00Z', 113.8811858971153],
      ['2024-06-26T09:16:00Z', 113.93430212188075],
      ['2024-06-26T09:17:00Z', 114.141455398466],
      ['2024-06-26T09:18:00Z', 114.06178106131782],
      ['2024-06-26T09:19:00Z', 114.01397645902891],
      ['2024-06-26T09:20:00Z', 113.80682318244367],
      ['2024-06-26T09:21:00Z', 113.94492536683383],
      ['2024-06-26T09:22:00Z', 113.98210672416965],
      ['2024-06-26T09:23:00Z', 113.79088831501403],
      ['2024-06-26T09:24:00Z', 113.82275804987331],
      ['2024-06-26T09:25:00Z', 113.68996748795972],
      ['2024-06-26T09:26:00Z', 113.80682318244368],
      ['2024-06-26T09:27:00Z', 113.90243238702148],
      ['2024-06-26T09:28:00Z', 113.74308371272514],
      ['2024-06-26T09:29:00Z', 113.95023698931038],
      ['2024-06-26T09:30:00Z', 113.96617185674002],
      ['2024-06-26T09:31:00Z', 113.79619993749058],
      ['2024-06-26T09:32:00Z', 114.49202248191793],
      ['2024-06-26T09:33:00Z', 118.09330252101513],
      ['2024-06-26T09:34:00Z', 121.26434113951224],
      ['2024-06-26T09:35:00Z', 122.50726079902368],
      ['2024-06-26T09:36:00Z', 122.3319772572977],
      ['2024-06-26T09:37:00Z', 121.59897335553455],
      ['2024-06-26T09:38:00Z', 119.49025923234633],
      ['2024-06-26T09:39:00Z', 127.97292032738801],
      ['2024-06-26T09:40:00Z', 133.32703578374492],
      ['2024-06-26T09:41:00Z', 133.38546363098692],
      ['2024-06-26T09:42:00Z', 133.3217241612684],
      ['2024-06-26T09:43:00Z', 133.5341890603302],
      ['2024-06-26T09:44:00Z', 133.35890551860422],
      ['2024-06-26T09:45:00Z', 133.44920310070543],
      ['2024-06-26T09:46:00Z', 130.01258335838114],
      ['2024-06-26T09:47:00Z', 129.0936726699389],
      ['2024-06-26T09:48:00Z', 129.24770972175867],
      ['2024-06-26T09:49:00Z', 130.41095504412195],
      ['2024-06-26T09:50:00Z', 130.5809269633714],
      ['2024-06-26T09:51:00Z', 129.4389281309143],
      ['2024-06-26T09:52:00Z', 129.60358842768716],
      ['2024-06-26T09:53:00Z', 127.92511572509912],
      ['2024-06-26T09:54:00Z', 112.26645266424576],
      ['2024-06-26T09:55:00Z', 112.09648074499633],
      ['2024-06-26T09:56:00Z', 116.83444799407408],
      ['2024-06-26T09:57:00Z', 118.90598075992645],
      ['2024-06-26T09:58:00Z', 119.06532943422278],
      ['2024-06-26T09:59:00Z', 119.06532943422279],
      ['2024-06-26T10:00:00Z', 119.03345969936352],
      ['2024-06-26T10:01:00Z', 115.49591912998486],
      ['2024-06-26T10:02:00Z', 113.0950657705867],
      ['2024-06-26T10:03:00Z', 113.2650376898361],
      ['2024-06-26T10:04:00Z', 113.45625609899173],
      ['2024-06-26T10:05:00Z', 114.84258956536986],
      ['2024-06-26T10:06:00Z', 115.73494214142934],
      ['2024-06-26T10:07:00Z', 116.11206733726401],
      ['2024-06-26T10:08:00Z', 117.0044199133235],
      ['2024-06-26T10:09:00Z', 116.64322958491847],
      ['2024-06-26T10:10:00Z', 118.61915314619304],
      ['2024-06-26T10:11:00Z', 132.94459896543373],
      ['2024-06-26T10:12:00Z', 134.41060676896],
      ['2024-06-26T10:13:00Z', 128.27568280855107],
      ['2024-06-26T10:14:00Z', 128.3553571456992],
      ['2024-06-26T10:15:00Z', 128.73248234153388],
      ['2024-06-26T10:16:00Z', 128.88120777087713],
      ['2024-06-26T10:17:00Z', 130.60217345327757],
      ['2024-06-26T10:18:00Z', 130.12412743038857],
      ['2024-06-26T10:19:00Z', 134.28312782952295],
      ['2024-06-26T10:20:00Z', 134.19283024742168],
      ['2024-06-26T10:21:00Z', 134.7452389849823],
      ['2024-06-26T10:22:00Z', 364.22326483913685],
      ['2024-06-26T10:23:00Z', 290.01458721933284],
      ['2024-06-26T10:24:00Z', 213.76624656853568],
      ['2024-06-26T10:25:00Z', 215.80590959952883],
      ['2024-06-26T10:26:00Z', 214.49925047029888],
      ['2024-06-26T10:27:00Z', 178.37490600731934],
      ['2024-06-26T10:28:00Z', 184.66917864202463],
      ['2024-06-26T10:29:00Z', 212.85264750257005],
      ['2024-06-26T10:30:00Z', 213.46348408737265],
      ['2024-06-26T10:31:00Z', 215.0410359629064],
      ['2024-06-26T10:32:00Z', 190.4057309166927],
      ['2024-06-26T10:33:00Z', 159.84265518665535],
      ['2024-06-26T10:34:00Z', 250.0658745732412],
      ['2024-06-26T10:35:00Z', 210.70675202204603],
      ['2024-06-26T10:36:00Z', 213.78218143596536],
      ['2024-06-26T10:37:00Z', 214.3717715308618],
      ['2024-06-26T10:38:00Z', 197.51268179030936],
      ['2024-06-26T10:39:00Z', 172.27185178176964],
      ['2024-06-26T10:40:00Z', 210.3083803363052],
      ['2024-06-26T10:41:00Z', 212.5551966438835],
      ['2024-06-26T10:42:00Z', 211.96029492651056],
      ['2024-06-26T10:43:00Z', 210.97764476834982],
      ['2024-06-26T10:44:00Z', 213.2882005456467],
      ['2024-06-26T10:45:00Z', 214.05838580474563],
      ['2024-06-26T10:46:00Z', 149.23003347851935],
      ['2024-06-26T10:47:00Z', 208.63521925619366],
      ['2024-06-26T10:48:00Z', 209.447897495105],
      ['2024-06-26T10:49:00Z', 211.24853751465358],
      ['2024-06-26T10:50:00Z', 213.49535382223192],
      ['2024-06-26T10:51:00Z', 210.63770092985095],
      ['2024-06-26T10:52:00Z', 172.79239078447097],
      ['2024-06-26T10:53:00Z', 211.99747628384634],
      ['2024-06-26T10:54:00Z', 209.40009289281605],
      ['2024-06-26T10:55:00Z', 210.42523603078914],
      ['2024-06-26T10:56:00Z', 212.52332690902426],
      ['2024-06-26T10:57:00Z', 211.2166677797943],
      ['2024-06-26T10:58:00Z', 214.41957613315068],
      ['2024-06-26T10:59:00Z', 183.2987800430761],
      ['2024-06-26T11:00:00Z', 179.60189079940108],
      ['2024-06-26T11:01:00Z', 210.75455662433495],
      ['2024-06-26T11:02:00Z', 210.07466894733724],
      ['2024-06-26T11:03:00Z', 212.76234992046875],
      ['2024-06-26T11:04:00Z', 211.2963421169425],
      ['2024-06-26T11:05:00Z', 214.3983296432445],
      ['2024-06-26T11:06:00Z', 213.12885187135035],
      ['2024-06-26T11:07:00Z', 157.23996017314852],
      ['2024-06-26T11:08:00Z', 201.59200785229552],
      ['2024-06-26T11:09:00Z', 209.8303343134162],
      ['2024-06-26T11:10:00Z', 210.85016582891274],
      ['2024-06-26T11:11:00Z', 210.89797043120163],
      ['2024-06-26T11:12:00Z', 212.82077776771078],
      ['2024-06-26T11:13:00Z', 212.23649929529086],
      ['2024-06-26T11:14:00Z', 199.8073027001766],
      ['2024-06-26T11:15:00Z', 175.90500155572607],
      ['2024-06-26T11:16:00Z', 232.7712317896121],
      ['2024-06-26T11:17:00Z', 208.9539166047863],
      ['2024-06-26T11:18:00Z', 210.228705999157],
      ['2024-06-26T11:19:00Z', 210.43585927574227],
      ['2024-06-26T11:20:00Z', 213.00137293191327],
      ['2024-06-26T11:21:00Z', 210.78642635919422],
      ['2024-06-26T11:22:00Z', 214.08494391712836],
      ['2024-06-26T11:23:00Z', 179.8887184131345],
      ['2024-06-26T11:24:00Z', 201.67168218944374],
      ['2024-06-26T11:25:00Z', 210.403989540883],
      ['2024-06-26T11:26:00Z', 207.90221535443052],
      ['2024-06-26T11:27:00Z', 210.72268688947568],
      ['2024-06-26T11:28:00Z', 208.31652190760101],
      ['2024-06-26T11:29:00Z', 210.88203556377204],
      ['2024-06-26T11:30:00Z', 209.36822315795678],
      ['2024-06-26T11:31:00Z', 209.97374812028286],
      ['2024-06-26T11:32:00Z', 209.01765607450488],
      ['2024-06-26T11:33:00Z', 208.90611200249742],
      ['2024-06-26T11:34:00Z', 211.1051237077869],
      ['2024-06-26T11:35:00Z', 209.41602776024573],
      ['2024-06-26T11:36:00Z', 211.3122769843721],
      ['2024-06-26T11:37:00Z', 211.23260264722393],
      ['2024-06-26T11:38:00Z', 209.60724616940132],
      ['2024-06-26T11:39:00Z', 212.8420242576169],
      ['2024-06-26T11:40:00Z', 210.77049149176457],
      ['2024-06-26T11:41:00Z', 211.954983304034],
      ['2024-06-26T11:42:00Z', 213.27226567821705],
      ['2024-06-26T11:43:00Z', 209.28323719833207],
      ['2024-06-26T11:44:00Z', 212.63487098103172],
      ['2024-06-26T11:45:00Z', 211.0732539729276],
      ['2024-06-26T11:46:00Z', 210.91390529863125],
      ['2024-06-26T11:47:00Z', 211.33883509675482],
      ['2024-06-26T11:48:00Z', 208.2209127030232],
      ['2024-06-26T11:49:00Z', 211.48756052609812],
      ['2024-06-26T11:50:00Z', 209.32573017814445],
      ['2024-06-26T11:51:00Z', 211.24853751465358],
      ['2024-06-26T11:52:00Z', 210.64832417480406],
      ['2024-06-26T11:53:00Z', 208.13061512092193],
      ['2024-06-26T11:54:00Z', 211.71064867011296],
      ['2024-06-26T11:55:00Z', 209.16106988137156],
      ['2024-06-26T11:56:00Z', 210.07998056981376],
      ['2024-06-26T11:57:00Z', 211.71064867011296],
      ['2024-06-26T11:58:00Z', 211.20073291236469],
      ['2024-06-26T11:59:00Z', 211.32821185180174],
      ['2024-06-26T12:00:00Z', 210.66957066471025],
      ['2024-06-26T12:01:00Z', 210.59520795003863],
      ['2024-06-26T12:02:00Z', 210.75455662433495],
      ['2024-06-26T12:03:00Z', 210.91390529863128],
      ['2024-06-26T12:04:00Z', 211.4875605260981],
      ['2024-06-26T12:05:00Z', 211.81156949716728],
      ['2024-06-26T12:06:00Z', 211.6575324453475],
      ['2024-06-26T12:07:00Z', 211.93373681412783],
      ['2024-06-26T12:08:00Z', 189.24248559432945],
      ['2024-06-26T12:09:00Z', 179.76123947369746],
      ['2024-06-26T12:10:00Z', 210.2605757340163],
      ['2024-06-26T12:11:00Z', 209.79846457855692],
      ['2024-06-26T12:12:00Z', 210.23401762163354],
      ['2024-06-26T12:13:00Z', 210.77049149176457],
      ['2024-06-26T12:14:00Z', 210.62707768489787],
      ['2024-06-26T12:15:00Z', 209.5435066996828],
      ['2024-06-26T12:16:00Z', 210.32431520373484],
      ['2024-06-26T12:17:00Z', 209.95781325285327],
      ['2024-06-26T12:18:00Z', 210.12778517210268],
      ['2024-06-26T12:19:00Z', 209.8940737831347],
      ['2024-06-26T12:20:00Z', 209.79315295608038],
      ['2024-06-26T12:21:00Z', 211.39195132152028],
      ['2024-06-26T12:22:00Z', 148.81572692534888],
      ['2024-06-26T12:23:00Z', 213.27226567821705],
      ['2024-06-26T12:24:00Z', 231.99573490803664],
      ['2024-06-26T12:25:00Z', 210.41992440831262],
      ['2024-06-26T12:26:00Z', 212.01341115127602],
      ['2024-06-26T12:27:00Z', 165.32424958244934],
      ['2024-06-26T12:28:00Z', 189.30622506404805],
      ['2024-06-26T12:29:00Z', 211.61503946553518],
      ['2024-06-26T12:30:00Z', 211.29634211694247],
      ['2024-06-26T12:31:00Z', 196.90715682798324],
      ['2024-06-26T12:32:00Z', 181.14757294007558],
      ['2024-06-26T12:33:00Z', 152.289528025009],
      ['2024-06-26T12:34:00Z', 193.831727414064],
      ['2024-06-26T12:35:00Z', 194.86749379699015],
      ['2024-06-26T12:36:00Z', 192.52506828483402],
      ['2024-06-26T12:37:00Z', 192.70566344903654],
      ['2024-06-26T12:38:00Z', 211.13699344264617],
      ['2024-06-26T12:39:00Z', 210.06935732486068],
      ['2024-06-26T12:40:00Z', 212.04528088613526],
      ['2024-06-26T12:41:00Z', 210.51553361289047],
      ['2024-06-26T12:42:00Z', 213.7343768336764],
      ['2024-06-26T12:43:00Z', 162.56751751712272],
      ['2024-06-26T12:44:00Z', 196.23789239593864],
      ['2024-06-26T12:45:00Z', 208.30058704017137],
      ['2024-06-26T12:46:00Z', 210.85016582891274],
      ['2024-06-26T12:47:00Z', 211.7956346297377],
      ['2024-06-26T12:48:00Z', 210.97764476834982],
      ['2024-06-26T12:49:00Z', 212.79421965532805],
      ['2024-06-26T12:50:00Z', 197.22585417657598],
      ['2024-06-26T12:51:00Z', 179.63376053426038],
      ['2024-06-26T12:52:00Z', 220.14019354038916],
      ['2024-06-26T12:53:00Z', 209.8462691808458],
      ['2024-06-26T12:54:00Z', 209.9737481202829],
      ['2024-06-26T12:55:00Z', 206.97799304351173],
      ['2024-06-26T12:56:00Z', 210.29244546887557],
      ['2024-06-26T12:57:00Z', 208.04562916129723],
      ['2024-06-26T12:58:00Z', 210.61114281746822],
      ['2024-06-26T12:59:00Z', 210.64301255232752],
      ['2024-06-26T13:00:00Z', 209.272613953379],
      ['2024-06-26T13:01:00Z', 212.25243416272048],
      ['2024-06-26T13:02:00Z', 209.38415802538643],
      ['2024-06-26T13:03:00Z', 212.48614555168842],
      ['2024-06-26T13:04:00Z', 211.3175886068487],
      ['2024-06-26T13:05:00Z', 212.05590413108834],
      ['2024-06-26T13:06:00Z', 211.53005350591044],
      ['2024-06-26T13:07:00Z', 211.26447238208317],
      ['2024-06-26T13:08:00Z', 213.33600514793554],
      ['2024-06-26T13:09:00Z', 209.61786941435443],
      ['2024-06-26T13:10:00Z', 213.16072160620962],
      ['2024-06-26T13:11:00Z', 210.5686498376559],
      ['2024-06-26T13:12:00Z', 211.32821185180174],
      ['2024-06-26T13:13:00Z', 212.7995312778046],
      ['2024-06-26T13:14:00Z', 181.92838144412764],
      ['2024-06-26T13:15:00Z', 194.91529839927907],
      ['2024-06-26T13:16:00Z', 209.5700648120655],
      ['2024-06-26T13:17:00Z', 209.47976722996427],
      ['2024-06-26T13:18:00Z', 206.97268142103525],
      ['2024-06-26T13:19:00Z', 210.6589474197571],
      ['2024-06-26T13:20:00Z', 207.32324850448714],
      ['2024-06-26T13:21:00Z', 209.51694858730005],
      ['2024-06-26T13:22:00Z', 207.92346184433669],
      ['2024-06-26T13:23:00Z', 208.63521925619366],
      ['2024-06-26T13:24:00Z', 209.06546067679375],
      ['2024-06-26T13:25:00Z', 207.0895371155192],
      ['2024-06-26T13:26:00Z', 210.0321759675249],
      ['2024-06-26T13:27:00Z', 208.81050279791964],
      ['2024-06-26T13:28:00Z', 208.8901771350678],
      ['2024-06-26T13:29:00Z', 208.8317492878258],
      ['2024-06-26T13:30:00Z', 208.79987955296656],
      ['2024-06-26T13:31:00Z', 209.20887448366048],
      ['2024-06-26T13:32:00Z', 209.62318103683097],
      ['2024-06-26T13:33:00Z', 209.4744556074877],
      ['2024-06-26T13:34:00Z', 209.59662292444827],
      ['2024-06-26T13:35:00Z', 209.81439944598657],
      ['2024-06-26T13:36:00Z', 210.4411708982188],
      ['2024-06-26T13:37:00Z', 208.87424226763815],
      ['2024-06-26T13:38:00Z', 212.20462956043156],
      ['2024-06-26T13:39:00Z', 210.14903166200887],
      ['2024-06-26T13:40:00Z', 211.0095145032091],
      ['2024-06-26T13:41:00Z', 211.4556907912388],
      ['2024-06-26T13:42:00Z', 210.19683626429776],
      ['2024-06-26T13:43:00Z', 212.41178283701683],
      ['2024-06-26T13:44:00Z', 211.54067675086353],
      ['2024-06-26T13:45:00Z', 210.05342245743108],
      ['2024-06-26T13:46:00Z', 212.4064712145403],
      ['2024-06-26T13:47:00Z', 212.20994118290815],
      ['2024-06-26T13:48:00Z', 211.37601645409063],
      ['2024-06-26T13:49:00Z', 158.24916844369199],
      ['2024-06-26T13:50:00Z', 229.30274231242856],
      ['2024-06-26T13:51:00Z', 207.88628048700087],
      ['2024-06-26T13:52:00Z', 210.27651060144592],
      ['2024-06-26T13:53:00Z', 206.3884029486153],
      ['2024-06-26T13:54:00Z', 211.59910459810553],
      ['2024-06-26T13:55:00Z', 208.95391660478634],
      ['2024-06-26T13:56:00Z', 212.50739204159464],
      ['2024-06-26T13:57:00Z', 210.29244546887554],
      ['2024-06-26T13:58:00Z', 197.08244036970925],
      ['2024-06-26T13:59:00Z', 165.38798905216788],
      ['2024-06-26T14:00:00Z', 209.65505077169018],
      ['2024-06-26T14:01:00Z', 207.99251293653174],
      ['2024-06-26T14:02:00Z', 207.50384366868968],
      ['2024-06-26T14:03:00Z', 208.3537032649368],
      ['2024-06-26T14:04:00Z', 206.06970560002264],
      ['2024-06-26T14:05:00Z', 209.09733041165302],
      ['2024-06-26T14:06:00Z', 207.80129452737617],
      ['2024-06-26T14:07:00Z', 208.25278243788244],
      ['2024-06-26T14:08:00Z', 210.7758031142411],
      ['2024-06-26T14:09:00Z', 207.6153877406971],
      ['2024-06-26T14:10:00Z', 210.5474033477497],
      ['2024-06-26T14:11:00Z', 208.66708899105294],
      ['2024-06-26T14:12:00Z', 208.70427034838875],
      ['2024-06-26T14:13:00Z', 212.1568249581427],
      ['2024-06-26T14:14:00Z', 209.89407378313473],
      ['2024-06-26T14:15:00Z', 211.46631403619187],
      ['2024-06-26T14:16:00Z', 211.23260264722396],
      ['2024-06-26T14:17:00Z', 150.18612552429735],
      ['2024-06-26T14:18:00Z', 220.26767247982622],
      ['2024-06-26T14:19:00Z', 207.40823446411184],
      ['2024-06-26T14:20:00Z', 210.10122705971997],
      ['2024-06-26T14:21:00Z', 207.61538774069712],
      ['2024-06-26T14:22:00Z', 210.55271497022625],
      ['2024-06-26T14:23:00Z', 209.40009289281608],
      ['2024-06-26T14:24:00Z', 210.73862175690533],
      ['2024-06-26T14:25:00Z', 210.43585927574225],
      ['2024-06-26T14:26:00Z', 212.1568249581427],
      ['2024-06-26T14:27:00Z', 179.7559278512209],
      ['2024-06-26T14:28:00Z', 177.8490553821414],
      ['2024-06-26T14:29:00Z', 250.79887847500436],
      ['2024-06-26T14:30:00Z', 212.50739204159464],
      ['2024-06-26T14:31:00Z', 209.06546067679378],
      ['2024-06-26T14:32:00Z', 206.6592956949191],
      ['2024-06-26T14:33:00Z', 208.36432650988985],
      ['2024-06-26T14:34:00Z', 209.20887448366045],
      ['2024-06-26T14:35:00Z', 208.10936863101574],
      ['2024-06-26T14:36:00Z', 209.54350669968278],
      ['2024-06-26T14:37:00Z', 208.5714797864751],
      ['2024-06-26T14:38:00Z', 211.49818377105117],
      ['2024-06-26T14:39:00Z', 208.09343376358612],
      ['2024-06-26T14:40:00Z', 211.92311356917475],
      ['2024-06-26T14:41:00Z', 208.17310810073428],
      ['2024-06-26T14:42:00Z', 212.06121575356488],
      ['2024-06-26T14:43:00Z', 209.75065997626803],
      ['2024-06-26T14:44:00Z', 195.5845628313237],
      ['2024-06-26T14:45:00Z', 153.1022062639203],
      ['2024-06-26T14:46:00Z', 232.23475791948113],
      ['2024-06-26T14:47:00Z', 210.45710576564846],
      ['2024-06-26T14:48:00Z', 208.52367518418623],
      ['2024-06-26T14:49:00Z', 211.08918884035722],
      ['2024-06-26T14:50:00Z', 211.29634211694247],
      ['2024-06-26T14:51:00Z', 157.21871368324236],
      ['2024-06-26T14:52:00Z', 203.4563873415627],
      ['2024-06-26T14:53:00Z', 208.0456291612972],
      ['2024-06-26T14:54:00Z', 212.23649929529083],
      ['2024-06-26T14:55:00Z', 193.81579254663433],
      ['2024-06-26T14:56:00Z', 143.07917465068073],
      ['2024-06-26T14:57:00Z', 213.46348408737265],
      ['2024-06-26T14:58:00Z', 234.16287687846682],
      ['2024-06-26T14:59:00Z', 233.76450519272598],
      ['2024-06-26T15:00:00Z', 233.2439661900246],
      ['2024-06-26T15:01:00Z', 232.9996315561035],
      ['2024-06-26T15:02:00Z', 232.25600440938734],
      ['2024-06-26T15:03:00Z', 271.09989958035766],
      ['2024-06-26T15:04:00Z', 215.82184446695845],
      ['2024-06-26T15:05:00Z', 211.29634211694247],
      ['2024-06-26T15:06:00Z', 201.01835262482876],
      ['2024-06-26T15:07:00Z', 155.508371245795],
      ['2024-06-26T15:08:00Z', 215.35973331149904],
      ['2024-06-26T15:09:00Z', 210.7758031142411],
      ['2024-06-26T15:10:00Z', 214.81794781889153],
      ['2024-06-26T15:11:00Z', 213.68657223138754],
      ['2024-06-26T15:12:00Z', 156.6875514355879],
      ['2024-06-26T15:13:00Z', 186.3476513446127],
      ['2024-06-26T15:14:00Z', 236.4309396759513],
      ['2024-06-26T15:15:00Z', 236.32470722642043],
      ['2024-06-26T15:16:00Z', 235.0924108118621],
      ['2024-06-26T15:17:00Z', 235.17739677148683],
      ['2024-06-26T15:18:00Z', 234.94368538251888],
      ['2024-06-26T15:19:00Z', 234.78433670822255],
      ['2024-06-26T15:20:00Z', 234.53469045182493],
      ['2024-06-26T15:21:00Z', 234.32222555276314],
      ['2024-06-26T15:22:00Z', 251.292859365323],
      ['2024-06-26T15:23:00Z', 210.6430125523275],
      ['2024-06-26T15:24:00Z', 212.071838998518],
      ['2024-06-26T15:25:00Z', 183.64934712652806],
      ['2024-06-26T15:26:00Z', 150.0586465848603],
      ['2024-06-26T15:27:00Z', 224.9365886367089],
      ['2024-06-26T15:28:00Z', 235.97945176544505],
      ['2024-06-26T15:29:00Z', 235.81479146867213],
      ['2024-06-26T15:30:00Z', 236.37782345118586],
      ['2024-06-26T15:31:00Z', 236.33001884889697],
      ['2024-06-26T15:32:00Z', 237.3551619868701],
      ['2024-06-26T15:33:00Z', 235.9475820305858],
      ['2024-06-26T15:34:00Z', 236.5849767277711],
      ['2024-06-26T15:35:00Z', 200.61998093908792],
      ['2024-06-26T15:36:00Z', 131.9407023173668],
      ['2024-06-26T15:37:00Z', 276.565559108722],
      ['2024-06-26T15:38:00Z', 211.51943026095734],
      ['2024-06-26T15:39:00Z', 184.5735694374468],
      ['2024-06-26T15:40:00Z', 183.41032411508354],
      ['2024-06-26T15:41:00Z', 183.30409166555268],
      ['2024-06-26T15:42:00Z', 184.14332801684668],
      ['2024-06-26T15:43:00Z', 137.78348704156582],
      ['2024-06-26T15:44:00Z', 131.9407023173668],
      ['2024-06-26T15:45:00Z', 187.56401289174138],
      ['2024-06-26T15:46:00Z', 186.2307956501287],
      ['2024-06-26T15:47:00Z', 332.30041375510405],
      ['2024-06-26T15:48:00Z', 285.1385177858649],
      ['2024-06-26T15:49:00Z', 265.85732819600815],
      ['2024-06-26T15:50:00Z', 264.21603685075587],
    ],
    specificPower: [
      ['2024-06-25T15:52:00Z', 5.940552889500334],
      ['2024-06-25T15:53:00Z', 6.117434962503726],
      ['2024-06-25T15:54:00Z', 6.056570974558021],
      ['2024-06-25T15:55:00Z', 6.069935799273354],
      ['2024-06-25T15:56:00Z', 6.158045988227643],
      ['2024-06-25T15:57:00Z', 5.986943447351407],
      ['2024-06-25T15:58:00Z', 6.081269137279771],
      ['2024-06-25T15:59:00Z', 6.15765037460352],
      ['2024-06-25T16:00:00Z', 6.203875302350568],
      ['2024-06-25T16:01:00Z', 6.280452828139812],
      ['2024-06-25T16:02:00Z', 6.2895022870827875],
      ['2024-06-25T16:03:00Z', 6.3996286406132885],
      ['2024-06-25T16:04:00Z', 6.213668303619582],
      ['2024-06-25T16:05:00Z', 6.314589841318062],
      ['2024-06-25T16:06:00Z', 6.416096934121118],
      ['2024-06-25T16:07:00Z', 6.428505366050191],
      ['2024-06-25T16:08:00Z', 6.0514645360318555],
      ['2024-06-25T16:09:00Z', 5.910549173260375],
      ['2024-06-25T16:10:00Z', 5.9291616325561805],
      ['2024-06-25T16:11:00Z', 5.957042867553479],
      ['2024-06-25T16:12:00Z', 6.090967754978169],
      ['2024-06-25T16:13:00Z', 5.964293088097737],
      ['2024-06-25T16:14:00Z', 6.118164565100015],
      ['2024-06-25T16:15:00Z', 6.081961240398598],
      ['2024-06-25T16:16:00Z', 6.051197427928145],
      ['2024-06-25T16:17:00Z', 6.24186089154265],
      ['2024-06-25T16:18:00Z', 6.109602382499331],
      ['2024-06-25T16:19:00Z', 6.34366829495075],
      ['2024-06-25T16:20:00Z', 6.19605517201222],
      ['2024-06-25T16:21:00Z', 5.984263963105845],
      ['2024-06-25T16:22:00Z', 6.0472832712649955],
      ['2024-06-25T16:23:00Z', 5.962602873505903],
      ['2024-06-25T16:24:00Z', 6.00354600937041],
      ['2024-06-25T16:25:00Z', 6.011370973831589],
      ['2024-06-25T16:26:00Z', 6.150656160119094],
      ['2024-06-25T16:27:00Z', 6.106460554934411],
      ['2024-06-25T16:28:00Z', 6.046380341649335],
      ['2024-06-25T16:29:00Z', 6.172073548028799],
      ['2024-06-25T16:30:00Z', 6.125199509828269],
      ['2024-06-25T16:31:00Z', 6.110221552946995],
      ['2024-06-25T16:32:00Z', 6.128658484521655],
      ['2024-06-25T16:33:00Z', 6.174308420687948],
      ['2024-06-25T16:34:00Z', 6.021509073778874],
      ['2024-06-25T16:35:00Z', 6.1317851639680345],
      ['2024-06-25T16:36:00Z', 6.099946765101708],
      ['2024-06-25T16:37:00Z', 6.069916832420107],
      ['2024-06-25T16:38:00Z', 6.032886406134604],
      ['2024-06-25T16:39:00Z', 5.9621019383855565],
      ['2024-06-25T16:40:00Z', 6.0812852217000275],
      ['2024-06-25T16:41:00Z', 6.049234037051694],
      ['2024-06-25T16:42:00Z', 5.987835395461632],
      ['2024-06-25T16:43:00Z', 6.04825580087543],
      ['2024-06-25T16:44:00Z', 6.262297360149757],
      ['2024-06-25T16:45:00Z', 6.0018210156174],
      ['2024-06-25T16:46:00Z', 5.928577335166883],
      ['2024-06-25T16:47:00Z', 5.9820713310855504],
      ['2024-06-25T16:48:00Z', 5.99329100718167],
      ['2024-06-25T16:49:00Z', 6.316912296884337],
      ['2024-06-25T16:50:00Z', 6.4261362497697005],
      ['2024-06-25T16:51:00Z', 6.26433038681662],
      ['2024-06-25T16:52:00Z', 6.151677721351452],
      ['2024-06-25T16:53:00Z', 6.419395460718649],
      ['2024-06-25T16:54:00Z', 6.39712665976576],
      ['2024-06-25T16:55:00Z', 6.239416397150068],
      ['2024-06-25T16:56:00Z', 6.392325884429069],
      ['2024-06-25T16:57:00Z', 6.425081056342012],
      ['2024-06-25T16:58:00Z', 6.728327766149318],
      ['2024-06-25T16:59:00Z', 6.625879685002347],
      ['2024-06-25T17:00:00Z', 6.764835857752599],
      ['2024-06-25T17:01:00Z', 6.898197643511439],
      ['2024-06-25T17:02:00Z', 12.789597580416812],
      ['2024-06-25T17:03:00Z', 7.405143196587578],
      ['2024-06-25T17:04:00Z', 6.897492177339967],
      ['2024-06-25T17:05:00Z', 6.704289541718627],
      ['2024-06-25T17:06:00Z', 6.671806946944963],
      ['2024-06-25T17:07:00Z', 6.712552196478167],
      ['2024-06-25T17:08:00Z', 7.507397935059409],
      ['2024-06-25T17:09:00Z', 7.433871487340441],
      ['2024-06-25T17:10:00Z', 6.733301760574634],
      ['2024-06-25T17:11:00Z', 6.685137356022277],
      ['2024-06-25T17:12:00Z', 6.882768273956259],
      ['2024-06-25T17:13:00Z', 6.94803016039297],
      ['2024-06-25T17:14:00Z', 9.614910899947196],
      ['2024-06-25T17:15:00Z', 8.862812487735528],
      ['2024-06-25T17:16:00Z', 14.884741575311105],
      ['2024-06-25T17:17:00Z', 8.216545931585399],
      ['2024-06-25T17:18:00Z', 8.072379182178052],
      ['2024-06-25T17:19:00Z', 8.438322915283308],
      ['2024-06-25T17:20:00Z', 8.251738915580333],
      ['2024-06-25T17:21:00Z', 7.98730010634939],
      ['2024-06-25T17:22:00Z', 8.083292142381314],
      ['2024-06-25T17:23:00Z', 8.191491634600423],
      ['2024-06-25T17:24:00Z', 8.122472327551145],
      ['2024-06-25T17:25:00Z', 7.91106631040105],
      ['2024-06-25T17:26:00Z', 7.75310054641797],
      ['2024-06-25T17:27:00Z', 6.2452729913531035],
      ['2024-06-25T17:28:00Z', 6.338108632404941],
      ['2024-06-25T17:29:00Z', 6.154597527232854],
      ['2024-06-25T17:30:00Z', 6.0988187991999965],
      ['2024-06-25T17:31:00Z', 6.297836780870617],
      ['2024-06-25T17:32:00Z', 6.2618467345208],
      ['2024-06-25T17:33:00Z', 6.309407244677572],
      ['2024-06-25T17:34:00Z', 6.111975527590213],
      ['2024-06-25T17:35:00Z', 6.1375408656453265],
      ['2024-06-25T17:36:00Z', 6.166525281319971],
      ['2024-06-25T17:37:00Z', 6.095689517124955],
      ['2024-06-25T17:38:00Z', 6.163586940622644],
      ['2024-06-25T17:39:00Z', 6.13165735909506],
      ['2024-06-25T17:40:00Z', 6.028877622979448],
      ['2024-06-25T17:41:00Z', 6.101242023175084],
      ['2024-06-25T17:42:00Z', 6.00588328053966],
      ['2024-06-25T17:43:00Z', 6.08912443879256],
      ['2024-06-25T17:44:00Z', 5.962961119371832],
      ['2024-06-25T17:45:00Z', 5.997330634115642],
      ['2024-06-25T17:46:00Z', 5.925915179133255],
      ['2024-06-25T17:47:00Z', 6.129808715452168],
      ['2024-06-25T17:48:00Z', 6.266820273115938],
      ['2024-06-25T17:49:00Z', 6.322163257246807],
      ['2024-06-25T17:50:00Z', 6.183084475608744],
      ['2024-06-25T17:51:00Z', 6.092393268821493],
      ['2024-06-25T17:52:00Z', 6.204469973412613],
      ['2024-06-25T17:53:00Z', 6.294972372667184],
      ['2024-06-25T17:54:00Z', 6.136056049624943],
      ['2024-06-25T17:55:00Z', 6.10703966247922],
      ['2024-06-25T17:56:00Z', 6.086033070147083],
      ['2024-06-25T17:57:00Z', 6.133318367775905],
      ['2024-06-25T17:58:00Z', 6.069704055213944],
      ['2024-06-25T17:59:00Z', 6.207065984566558],
      ['2024-06-25T18:00:00Z', 6.19371659086159],
      ['2024-06-25T18:01:00Z', 6.183823962679468],
      ['2024-06-25T18:02:00Z', 6.276139263105497],
      ['2024-06-25T18:03:00Z', 6.205100879297318],
      ['2024-06-25T18:04:00Z', 6.090577563233059],
      ['2024-06-25T18:05:00Z', 6.27887429391941],
      ['2024-06-25T18:06:00Z', 6.185231249593963],
      ['2024-06-25T18:07:00Z', 6.178462530412143],
      ['2024-06-25T18:08:00Z', 6.082322235162278],
      ['2024-06-25T18:09:00Z', 6.140977531393065],
      ['2024-06-25T18:10:00Z', 6.082544563059893],
      ['2024-06-25T18:11:00Z', 6.172303812789877],
      ['2024-06-25T18:12:00Z', 6.247374825702823],
      ['2024-06-25T18:13:00Z', 6.074684880489447],
      ['2024-06-25T18:14:00Z', 6.148739957703856],
      ['2024-06-25T18:15:00Z', 6.1687277661235544],
      ['2024-06-25T18:16:00Z', 6.015007179318467],
      ['2024-06-25T18:17:00Z', 6.239585279671038],
      ['2024-06-25T18:18:00Z', 6.1597290450658955],
      ['2024-06-25T18:19:00Z', 6.182244322212565],
      ['2024-06-25T18:20:00Z', 6.039001816270203],
      ['2024-06-25T18:21:00Z', 6.223829299354075],
      ['2024-06-25T18:22:00Z', 6.210187958997355],
      ['2024-06-25T18:23:00Z', 6.070150357459335],
      ['2024-06-25T18:24:00Z', 6.125981653884808],
      ['2024-06-25T18:25:00Z', 6.0980949630686645],
      ['2024-06-25T18:26:00Z', 6.1895469231704086],
      ['2024-06-25T18:27:00Z', 6.182322993596858],
      ['2024-06-25T18:28:00Z', 6.212696557868713],
      ['2024-06-25T18:29:00Z', 6.207543044162282],
      ['2024-06-25T18:30:00Z', 6.269052157836419],
      ['2024-06-25T18:31:00Z', 6.390582670421156],
      ['2024-06-25T18:32:00Z', 6.392886150078636],
      ['2024-06-25T18:33:00Z', 6.163484393449769],
      ['2024-06-25T18:34:00Z', 6.589093644461931],
      ['2024-06-25T18:35:00Z', 6.687750047303502],
      ['2024-06-25T18:36:00Z', 6.500336114892942],
      ['2024-06-25T18:37:00Z', 6.557600554249496],
      ['2024-06-25T18:38:00Z', 6.667588614558093],
      ['2024-06-25T18:39:00Z', 6.839517434833526],
      ['2024-06-25T18:40:00Z', 6.49383935058708],
      ['2024-06-25T18:41:00Z', 8.717038941139961],
      ['2024-06-25T18:42:00Z', 6.745593513592436],
      ['2024-06-25T18:43:00Z', 6.633042640833132],
      ['2024-06-25T18:44:00Z', 6.8251622332588955],
      ['2024-06-25T18:45:00Z', 6.835739865952148],
      ['2024-06-25T18:46:00Z', 6.711555485202104],
      ['2024-06-25T18:47:00Z', 12.52675279264357],
      ['2024-06-25T18:48:00Z', 6.851652854969314],
      ['2024-06-25T18:49:00Z', 6.869565877871403],
      ['2024-06-25T18:50:00Z', 6.651807112896508],
      ['2024-06-25T18:51:00Z', 6.764689969773514],
      ['2024-06-25T18:52:00Z', 6.737103246942266],
      ['2024-06-25T18:53:00Z', 6.860467448690801],
      ['2024-06-25T18:54:00Z', 8.580387508685837],
      ['2024-06-25T18:55:00Z', 8.671410706906142],
      ['2024-06-25T18:56:00Z', 8.684892286793529],
      ['2024-06-25T18:57:00Z', 7.154694860520349],
      ['2024-06-25T18:58:00Z', 6.591844536771],
      ['2024-06-25T18:59:00Z', 6.829622644192577],
      ['2024-06-25T19:00:00Z', 6.807475248402635],
      ['2024-06-25T19:01:00Z', 7.844357572704934],
      ['2024-06-25T19:02:00Z', 7.698270149250609],
      ['2024-06-25T19:03:00Z', 7.063313957108894],
      ['2024-06-25T19:04:00Z', 7.162968493186997],
      ['2024-06-25T19:05:00Z', 8.385438877875721],
      ['2024-06-25T19:06:00Z', 15.58697589450747],
      ['2024-06-25T19:07:00Z', 9.719738078318674],
      ['2024-06-25T19:08:00Z', 7.109103007079144],
      ['2024-06-25T19:09:00Z', 7.069355234683692],
      ['2024-06-25T19:10:00Z', 7.591660970851007],
      ['2024-06-25T19:11:00Z', 11.09605814924932],
      ['2024-06-25T19:12:00Z', 13.91639372707067],
      ['2024-06-25T19:13:00Z', 7.804502186743367],
      ['2024-06-25T19:14:00Z', 7.325686737875131],
      ['2024-06-25T19:15:00Z', 10.391478073635868],
      ['2024-06-25T19:16:00Z', 13.442752248696925],
      ['2024-06-25T19:17:00Z', 9.650998974935769],
      ['2024-06-25T19:18:00Z', 7.077182721094063],
      ['2024-06-25T19:19:00Z', 20.56754052902696],
      ['2024-06-25T19:20:00Z', 15.046874760512617],
      ['2024-06-25T19:21:00Z', 10.99879297445877],
      ['2024-06-25T19:22:00Z', 11.416854521601158],
      ['2024-06-25T19:23:00Z', 10.874528395150723],
      ['2024-06-25T19:24:00Z', 10.950864613056847],
      ['2024-06-25T19:25:00Z', 10.808109313423724],
      ['2024-06-25T19:26:00Z', 10.822623381097799],
      ['2024-06-25T19:27:00Z', 10.894944605743788],
      ['2024-06-25T19:28:00Z', 9.763586042788846],
      ['2024-06-25T19:29:00Z', 5.39890741022703],
      ['2024-06-25T19:30:00Z', 5.338888758377544],
      ['2024-06-25T19:31:00Z', 5.46796007820143],
      ['2024-06-25T19:32:00Z', 5.127147214978574],
      ['2024-06-25T19:33:00Z', 5.393988782428434],
      ['2024-06-25T19:34:00Z', 5.343507048630679],
      ['2024-06-25T19:35:00Z', 5.2673942407435375],
      ['2024-06-25T19:36:00Z', 5.448290125551462],
      ['2024-06-25T19:37:00Z', 5.29380036997609],
      ['2024-06-25T19:38:00Z', 5.374094718113452],
      ['2024-06-25T19:39:00Z', 5.351786468234655],
      ['2024-06-25T19:40:00Z', 5.511467380947822],
      ['2024-06-25T19:41:00Z', 5.33666245644229],
      ['2024-06-25T19:42:00Z', 5.368012862570736],
      ['2024-06-25T19:43:00Z', 5.228305345842397],
      ['2024-06-25T19:44:00Z', 5.26918283191369],
      ['2024-06-25T19:45:00Z', 5.377503346136792],
      ['2024-06-25T19:46:00Z', 5.462075831632895],
      ['2024-06-25T19:47:00Z', 5.603192556826255],
      ['2024-06-25T19:48:00Z', 5.560583207161088],
      ['2024-06-25T19:49:00Z', 5.418772757412459],
      ['2024-06-25T19:50:00Z', 5.38887347314086],
      ['2024-06-25T19:51:00Z', 5.649870503063799],
      ['2024-06-25T19:52:00Z', 5.6109072273244145],
      ['2024-06-25T19:53:00Z', 5.436171557984518],
      ['2024-06-25T19:54:00Z', 5.556560832876666],
      ['2024-06-25T19:55:00Z', 5.475553154097985],
      ['2024-06-25T19:56:00Z', 5.39251983389901],
      ['2024-06-25T19:57:00Z', 5.289666047025762],
      ['2024-06-25T19:58:00Z', 5.489662184607089],
      ['2024-06-25T19:59:00Z', 5.513417989627383],
      ['2024-06-25T20:00:00Z', 5.489988623367513],
      ['2024-06-25T20:01:00Z', 5.455984926394877],
      ['2024-06-25T20:02:00Z', 5.410561263417965],
      ['2024-06-25T20:03:00Z', 5.499007012892707],
      ['2024-06-25T20:04:00Z', 5.439402229951756],
      ['2024-06-25T20:05:00Z', 5.661252170089522],
      ['2024-06-25T20:06:00Z', 5.569243904144326],
      ['2024-06-25T20:07:00Z', 5.511844388930092],
      ['2024-06-25T20:08:00Z', 5.450218264565525],
      ['2024-06-25T20:09:00Z', 5.323026891593099],
      ['2024-06-25T20:10:00Z', 5.432547618253716],
      ['2024-06-25T20:11:00Z', 5.478599514523459],
      ['2024-06-25T20:12:00Z', 5.375082710731395],
      ['2024-06-25T20:13:00Z', 5.4868260154004],
      ['2024-06-25T20:14:00Z', 5.2811920851272],
      ['2024-06-25T20:15:00Z', 5.325928710946156],
      ['2024-06-25T20:16:00Z', 5.554794357180294],
      ['2024-06-25T20:17:00Z', 5.57857811675426],
      ['2024-06-25T20:18:00Z', 5.538530822841503],
      ['2024-06-25T20:19:00Z', 5.5881218889004876],
      ['2024-06-25T20:20:00Z', 5.48781554596054],
      ['2024-06-25T20:21:00Z', 5.4459439054979155],
      ['2024-06-25T20:22:00Z', 5.59472544268612],
      ['2024-06-25T20:23:00Z', 5.378774187085412],
      ['2024-06-25T20:24:00Z', 5.473115364187453],
      ['2024-06-25T20:25:00Z', 5.4333525809882985],
      ['2024-06-25T20:26:00Z', 5.534544093271428],
      ['2024-06-25T20:27:00Z', 5.471174442921101],
      ['2024-06-25T20:28:00Z', 5.4624402685146265],
      ['2024-06-25T20:29:00Z', 5.437297432072688],
      ['2024-06-25T20:30:00Z', 5.418618185876153],
      ['2024-06-25T20:31:00Z', 5.772829680517529],
      ['2024-06-25T20:32:00Z', 5.497973041137606],
      ['2024-06-25T20:33:00Z', 5.627380690620462],
      ['2024-06-25T20:34:00Z', 5.441174479696789],
      ['2024-06-25T20:35:00Z', 5.462504971818024],
      ['2024-06-25T20:36:00Z', 5.570162632685111],
      ['2024-06-25T20:37:00Z', 5.480662574194865],
      ['2024-06-25T20:38:00Z', 5.726667661417668],
      ['2024-06-25T20:39:00Z', 5.504208994131017],
      ['2024-06-25T20:40:00Z', 5.482960875869687],
      ['2024-06-25T20:41:00Z', 5.447148422183374],
      ['2024-06-25T20:42:00Z', 5.389029259431812],
      ['2024-06-25T20:43:00Z', 5.525527693933418],
      ['2024-06-25T20:44:00Z', 5.7000898629513586],
      ['2024-06-25T20:45:00Z', 5.719601159753728],
      ['2024-06-25T20:46:00Z', 5.58223112594655],
      ['2024-06-25T20:47:00Z', 5.4739872056810075],
      ['2024-06-25T20:48:00Z', 5.466206984121634],
      ['2024-06-25T20:49:00Z', 5.518275772368743],
      ['2024-06-25T20:50:00Z', 5.442848301347561],
      ['2024-06-25T20:51:00Z', 5.719117547313391],
      ['2024-06-25T20:52:00Z', 5.3651411785548],
      ['2024-06-25T20:53:00Z', 5.5914873427060305],
      ['2024-06-25T20:54:00Z', 5.472968586068559],
      ['2024-06-25T20:55:00Z', 5.294787971715415],
      ['2024-06-25T20:56:00Z', 5.467036007032876],
      ['2024-06-25T20:57:00Z', 5.491409862711706],
      ['2024-06-25T20:58:00Z', 5.672973453544074],
      ['2024-06-25T20:59:00Z', 5.362434118156701],
      ['2024-06-25T21:00:00Z', 5.7012776231334055],
      ['2024-06-25T21:01:00Z', 5.460667496126011],
      ['2024-06-25T21:02:00Z', 5.444629531201728],
      ['2024-06-25T21:03:00Z', 5.603197821480868],
      ['2024-06-25T21:04:00Z', 5.427832324285726],
      ['2024-06-25T21:05:00Z', 5.685998874340264],
      ['2024-06-25T21:06:00Z', 5.560454083464646],
      ['2024-06-25T21:07:00Z', 5.545602978933632],
      ['2024-06-25T21:08:00Z', 5.45396772635005],
      ['2024-06-25T21:09:00Z', 5.57661836491607],
      ['2024-06-25T21:10:00Z', 5.530592051224253],
      ['2024-06-25T21:11:00Z', 5.515109644330453],
      ['2024-06-25T21:12:00Z', 5.54197720566312],
      ['2024-06-25T21:13:00Z', 5.568653659876978],
      ['2024-06-25T21:14:00Z', 5.594237521140621],
      ['2024-06-25T21:15:00Z', 5.328855814389923],
      ['2024-06-25T21:16:00Z', 5.566206207894133],
      ['2024-06-25T21:17:00Z', 5.638234555343786],
      ['2024-06-25T21:18:00Z', 5.507276535916875],
      ['2024-06-25T21:19:00Z', 5.619522326889397],
      ['2024-06-25T21:20:00Z', 5.434780732852267],
      ['2024-06-25T21:21:00Z', 5.1975337191211155],
      ['2024-06-25T21:22:00Z', 5.634279253710065],
      ['2024-06-25T21:23:00Z', 5.263299729990517],
      ['2024-06-25T21:24:00Z', 5.629902109395457],
      ['2024-06-25T21:25:00Z', 5.603126977560979],
      ['2024-06-25T21:26:00Z', 5.482455092461486],
      ['2024-06-25T21:27:00Z', 5.495772916426917],
      ['2024-06-25T21:28:00Z', 5.434398743924017],
      ['2024-06-25T21:29:00Z', 5.569376626563585],
      ['2024-06-25T21:30:00Z', 5.378040759920072],
      ['2024-06-25T21:31:00Z', 5.471517742996761],
      ['2024-06-25T21:32:00Z', 5.298475218675015],
      ['2024-06-25T21:33:00Z', 5.560859550581872],
      ['2024-06-25T21:34:00Z', 5.4485377207424985],
      ['2024-06-25T21:35:00Z', 5.418129567380551],
      ['2024-06-25T21:36:00Z', 5.354889429062196],
      ['2024-06-25T21:37:00Z', 5.390030082799857],
      ['2024-06-25T21:38:00Z', 5.543857765741999],
      ['2024-06-25T21:39:00Z', 5.572378225563539],
      ['2024-06-25T21:40:00Z', 5.593480911428149],
      ['2024-06-25T21:41:00Z', 5.530493635292993],
      ['2024-06-25T21:42:00Z', 5.475641711726732],
      ['2024-06-25T21:43:00Z', 5.602343432895386],
      ['2024-06-25T21:44:00Z', 5.591849046518246],
      ['2024-06-25T21:45:00Z', 5.522434473233817],
      ['2024-06-25T21:46:00Z', 5.4184516164646235],
      ['2024-06-25T21:47:00Z', 5.449388397576432],
      ['2024-06-25T21:48:00Z', 5.487803941329776],
      ['2024-06-25T21:49:00Z', 5.532857747544496],
      ['2024-06-25T21:50:00Z', 5.508083430735776],
      ['2024-06-25T21:51:00Z', 5.71032471849143],
      ['2024-06-25T21:52:00Z', 5.420952001373943],
      ['2024-06-25T21:53:00Z', 5.556432280181206],
      ['2024-06-25T21:54:00Z', 5.3815018509883545],
      ['2024-06-25T21:55:00Z', 5.511725560624018],
      ['2024-06-25T21:56:00Z', 5.499266897845285],
      ['2024-06-25T21:57:00Z', 5.445166030549949],
      ['2024-06-25T21:58:00Z', 5.464960085495874],
      ['2024-06-25T21:59:00Z', 5.423112667368224],
      ['2024-06-25T22:00:00Z', 5.502512557806017],
      ['2024-06-25T22:01:00Z', 5.47886520634362],
      ['2024-06-25T22:02:00Z', 5.3738906967923254],
      ['2024-06-25T22:03:00Z', 5.4553310943829],
      ['2024-06-25T22:04:00Z', 5.340124670644919],
      ['2024-06-25T22:05:00Z', 5.274237153254002],
      ['2024-06-25T22:06:00Z', 5.240434722610433],
      ['2024-06-25T22:07:00Z', 5.210351738826257],
      ['2024-06-25T22:08:00Z', 5.498125238655117],
      ['2024-06-25T22:09:00Z', 5.5255439233104315],
      ['2024-06-25T22:10:00Z', 5.581634984875312],
      ['2024-06-25T22:11:00Z', 5.398538339232092],
      ['2024-06-25T22:12:00Z', 5.456528069372859],
      ['2024-06-25T22:13:00Z', 5.398991058305581],
      ['2024-06-25T22:14:00Z', 5.29974098797421],
      ['2024-06-25T22:15:00Z', 5.511522696936982],
      ['2024-06-25T22:16:00Z', 5.34850220353038],
      ['2024-06-25T22:17:00Z', 5.468212968343223],
      ['2024-06-25T22:18:00Z', 5.278510189617964],
      ['2024-06-25T22:19:00Z', 5.286270459370589],
      ['2024-06-25T22:20:00Z', 5.360490061585666],
      ['2024-06-25T22:21:00Z', 5.372382614671849],
      ['2024-06-25T22:22:00Z', 5.267896871771052],
      ['2024-06-25T22:23:00Z', 5.157607581970388],
      ['2024-06-25T22:24:00Z', 5.6353693716061475],
      ['2024-06-25T22:25:00Z', 5.5305290343088505],
      ['2024-06-25T22:26:00Z', 5.252316439202518],
      ['2024-06-25T22:27:00Z', 5.302891844696644],
      ['2024-06-25T22:28:00Z', 5.303699693481997],
      ['2024-06-25T22:29:00Z', 5.529959667301718],
      ['2024-06-25T22:30:00Z', 5.141577479097327],
      ['2024-06-25T22:31:00Z', 5.454340595082213],
      ['2024-06-25T22:32:00Z', 5.250721798323811],
      ['2024-06-25T22:33:00Z', 5.570426216262306],
      ['2024-06-25T22:34:00Z', 5.539334675238693],
      ['2024-06-25T22:35:00Z', 5.472573298891697],
      ['2024-06-25T22:36:00Z', 5.38338504482289],
      ['2024-06-25T22:37:00Z', 5.568126945006882],
      ['2024-06-25T22:38:00Z', 5.409432768481154],
      ['2024-06-25T22:39:00Z', 5.260994276387442],
      ['2024-06-25T22:40:00Z', 5.379117516132487],
      ['2024-06-25T22:41:00Z', 5.278530849621106],
      ['2024-06-25T22:42:00Z', 5.23280193408098],
      ['2024-06-25T22:43:00Z', 5.219186937016794],
      ['2024-06-25T22:44:00Z', 5.461851070007867],
      ['2024-06-25T22:45:00Z', 5.567530798235071],
      ['2024-06-25T22:46:00Z', 5.3593348008888295],
      ['2024-06-25T22:47:00Z', 5.2778086908146085],
      ['2024-06-25T22:48:00Z', 5.329561327216779],
      ['2024-06-25T22:49:00Z', 5.39272470152031],
      ['2024-06-25T22:50:00Z', 5.132787487660931],
      ['2024-06-25T22:51:00Z', 5.128724862382456],
      ['2024-06-25T22:52:00Z', 5.38767170304987],
      ['2024-06-25T22:53:00Z', 5.488433127536982],
      ['2024-06-25T22:54:00Z', 5.5247217370918085],
      ['2024-06-25T22:55:00Z', 5.2928783036274725],
      ['2024-06-25T22:56:00Z', 5.355070313148163],
      ['2024-06-25T22:57:00Z', 5.340857587061848],
      ['2024-06-25T22:58:00Z', 5.415928023474185],
      ['2024-06-25T22:59:00Z', 5.4632076629782045],
      ['2024-06-25T23:00:00Z', 5.616383362143091],
      ['2024-06-25T23:01:00Z', 5.479428647354872],
      ['2024-06-25T23:02:00Z', 5.2839528914659555],
      ['2024-06-25T23:03:00Z', 5.405258386549153],
      ['2024-06-25T23:04:00Z', 5.511091091557771],
      ['2024-06-25T23:05:00Z', 5.20329027782054],
      ['2024-06-25T23:06:00Z', 5.4102359370413655],
      ['2024-06-25T23:07:00Z', 5.450046660558958],
      ['2024-06-25T23:08:00Z', 5.581823522124512],
      ['2024-06-25T23:09:00Z', 5.423298943584205],
      ['2024-06-25T23:10:00Z', 5.424256306026235],
      ['2024-06-25T23:11:00Z', 5.436390453531586],
      ['2024-06-25T23:12:00Z', 5.512091993524475],
      ['2024-06-25T23:13:00Z', 5.39413459667987],
      ['2024-06-25T23:14:00Z', 5.337132209109971],
      ['2024-06-25T23:15:00Z', 5.398413863442018],
      ['2024-06-25T23:16:00Z', 5.417823046206586],
      ['2024-06-25T23:17:00Z', 5.33170204289659],
      ['2024-06-25T23:18:00Z', 5.464834785976323],
      ['2024-06-25T23:19:00Z', 5.24076861064699],
      ['2024-06-25T23:20:00Z', 5.380375161053308],
      ['2024-06-25T23:21:00Z', 5.25536900314213],
      ['2024-06-25T23:22:00Z', 5.260558836673032],
      ['2024-06-25T23:23:00Z', 5.578923773053536],
      ['2024-06-25T23:24:00Z', 5.420269724668082],
      ['2024-06-25T23:25:00Z', 5.434127681916341],
      ['2024-06-25T23:26:00Z', 5.474634383517772],
      ['2024-06-25T23:27:00Z', 5.503451860950902],
      ['2024-06-25T23:28:00Z', 5.515155511643198],
      ['2024-06-25T23:29:00Z', 5.47324985882307],
      ['2024-06-25T23:30:00Z', 5.296536579155908],
      ['2024-06-25T23:31:00Z', 5.394641337595331],
      ['2024-06-25T23:32:00Z', 5.467273775383109],
      ['2024-06-25T23:33:00Z', 5.377981219414553],
      ['2024-06-25T23:34:00Z', 5.478102012105979],
      ['2024-06-25T23:35:00Z', 5.3714159354258895],
      ['2024-06-25T23:36:00Z', 5.3428884516571475],
      ['2024-06-25T23:37:00Z', 5.3715928982563925],
      ['2024-06-25T23:38:00Z', 5.236845344410652],
      ['2024-06-25T23:39:00Z', 5.522934350967488],
      ['2024-06-25T23:40:00Z', 5.49294735489772],
      ['2024-06-25T23:41:00Z', 5.417991909286944],
      ['2024-06-25T23:42:00Z', 5.289482114841045],
      ['2024-06-25T23:43:00Z', 5.165575433696998],
      ['2024-06-25T23:44:00Z', 5.515598518140624],
      ['2024-06-25T23:45:00Z', 5.38236094522929],
      ['2024-06-25T23:46:00Z', 5.4758867727491545],
      ['2024-06-25T23:47:00Z', 5.487935442680482],
      ['2024-06-25T23:48:00Z', 5.528302948779031],
      ['2024-06-25T23:49:00Z', 5.1574600669572535],
      ['2024-06-25T23:50:00Z', 5.353276514674452],
      ['2024-06-25T23:51:00Z', 5.325673671649082],
      ['2024-06-25T23:52:00Z', 5.622196129378709],
      ['2024-06-25T23:53:00Z', 5.2983958935527005],
      ['2024-06-25T23:54:00Z', 5.142230262497462],
      ['2024-06-25T23:55:00Z', 5.261146119013381],
      ['2024-06-25T23:56:00Z', 5.317151912939744],
      ['2024-06-25T23:57:00Z', 5.424282507183103],
      ['2024-06-25T23:58:00Z', 5.157161302658574],
      ['2024-06-25T23:59:00Z', 5.338428918981049],
      ['2024-06-26T00:00:00Z', 5.3231586640866375],
      ['2024-06-26T00:01:00Z', 5.291186120974154],
      ['2024-06-26T00:02:00Z', 5.507913466005883],
      ['2024-06-26T00:03:00Z', 5.267453350634648],
      ['2024-06-26T00:04:00Z', 5.397992847094905],
      ['2024-06-26T00:05:00Z', 5.377749596248578],
      ['2024-06-26T00:06:00Z', 5.377751431613936],
      ['2024-06-26T00:07:00Z', 5.147180392134046],
      ['2024-06-26T00:08:00Z', 5.166618274680438],
      ['2024-06-26T00:09:00Z', 5.297430713019997],
      ['2024-06-26T00:10:00Z', 5.304129026307168],
      ['2024-06-26T00:11:00Z', 5.24380221866519],
      ['2024-06-26T00:12:00Z', 5.345789229181417],
      ['2024-06-26T00:13:00Z', 5.284796953307908],
      ['2024-06-26T00:14:00Z', 5.470462837461824],
      ['2024-06-26T00:15:00Z', 5.446081452678793],
      ['2024-06-26T00:16:00Z', 5.348634963425515],
      ['2024-06-26T00:17:00Z', 5.478512125234397],
      ['2024-06-26T00:18:00Z', 5.389682011627534],
      ['2024-06-26T00:19:00Z', 5.394431160938275],
      ['2024-06-26T00:20:00Z', 5.074217538743896],
      ['2024-06-26T00:21:00Z', 5.209149888708431],
      ['2024-06-26T00:22:00Z', 5.520351603719347],
      ['2024-06-26T00:23:00Z', 5.536968485267018],
      ['2024-06-26T00:24:00Z', 5.4315863768749395],
      ['2024-06-26T00:25:00Z', 5.34176040242927],
      ['2024-06-26T00:26:00Z', 5.358588333132063],
      ['2024-06-26T00:27:00Z', 5.153202720036295],
      ['2024-06-26T00:28:00Z', 5.2853243791036215],
      ['2024-06-26T00:29:00Z', 5.464290320761651],
      ['2024-06-26T00:30:00Z', 5.500321658817605],
      ['2024-06-26T00:31:00Z', 5.452355782542844],
      ['2024-06-26T00:32:00Z', 5.35629715942185],
      ['2024-06-26T00:33:00Z', 5.228259607350296],
      ['2024-06-26T00:34:00Z', 5.364495451813953],
      ['2024-06-26T00:35:00Z', 5.289890271512169],
      ['2024-06-26T00:36:00Z', 5.4005979002000934],
      ['2024-06-26T00:37:00Z', 5.18598748393241],
      ['2024-06-26T00:38:00Z', 5.289906386161153],
      ['2024-06-26T00:39:00Z', 5.343395937448837],
      ['2024-06-26T00:40:00Z', 5.350015025905776],
      ['2024-06-26T00:41:00Z', 5.238060196900453],
      ['2024-06-26T00:42:00Z', 5.369444280780275],
      ['2024-06-26T00:43:00Z', 5.378340589954336],
      ['2024-06-26T00:44:00Z', 5.255677975823041],
      ['2024-06-26T00:45:00Z', 5.395464488510582],
      ['2024-06-26T00:46:00Z', 5.239888816330945],
      ['2024-06-26T00:47:00Z', 5.15987924901441],
      ['2024-06-26T00:48:00Z', 5.301399198296259],
      ['2024-06-26T00:49:00Z', 5.454240815956246],
      ['2024-06-26T00:50:00Z', 5.333346736682418],
      ['2024-06-26T00:51:00Z', 5.32264559144106],
      ['2024-06-26T00:52:00Z', 5.238461646854301],
      ['2024-06-26T00:53:00Z', 5.221763104885244],
      ['2024-06-26T00:54:00Z', 5.476085952213235],
      ['2024-06-26T00:55:00Z', 5.313969016332682],
      ['2024-06-26T00:56:00Z', 5.413273906350288],
      ['2024-06-26T00:57:00Z', 5.420621877335312],
      ['2024-06-26T00:58:00Z', 5.387689312469673],
      ['2024-06-26T00:59:00Z', 5.367448406083395],
      ['2024-06-26T01:00:00Z', 5.312098128731111],
      ['2024-06-26T01:01:00Z', 5.27245456146177],
      ['2024-06-26T01:02:00Z', 5.478292525088027],
      ['2024-06-26T01:03:00Z', 5.491929969803752],
      ['2024-06-26T01:04:00Z', 5.414035834256933],
      ['2024-06-26T01:05:00Z', 5.328548696444778],
      ['2024-06-26T01:06:00Z', 5.4210849562327414],
      ['2024-06-26T01:07:00Z', 5.316363137743162],
      ['2024-06-26T01:08:00Z', 5.601114126910596],
      ['2024-06-26T01:09:00Z', 5.412440153445301],
      ['2024-06-26T01:10:00Z', 5.313410743323846],
      ['2024-06-26T01:11:00Z', 5.330956168961368],
      ['2024-06-26T01:12:00Z', 5.481063263018658],
      ['2024-06-26T01:13:00Z', 5.3218406424438855],
      ['2024-06-26T01:14:00Z', 5.301567162432599],
      ['2024-06-26T01:15:00Z', 5.307074008220514],
      ['2024-06-26T01:16:00Z', 5.295368609603304],
      ['2024-06-26T01:17:00Z', 5.508436379021238],
      ['2024-06-26T01:18:00Z', 5.307985720321297],
      ['2024-06-26T01:19:00Z', 5.324904615365133],
      ['2024-06-26T01:20:00Z', 5.248495018165679],
      ['2024-06-26T01:21:00Z', 5.375260780464245],
      ['2024-06-26T01:22:00Z', 5.6223421551253],
      ['2024-06-26T01:23:00Z', 5.325966078852225],
      ['2024-06-26T01:24:00Z', 5.448146279108179],
      ['2024-06-26T01:25:00Z', 5.26523379083337],
      ['2024-06-26T01:26:00Z', 5.419026160200281],
      ['2024-06-26T01:27:00Z', 5.361759442183562],
      ['2024-06-26T01:28:00Z', 5.4040722677265896],
      ['2024-06-26T01:29:00Z', 5.490202383989874],
      ['2024-06-26T01:30:00Z', 5.433361213729842],
      ['2024-06-26T01:31:00Z', 5.328165308698384],
      ['2024-06-26T01:32:00Z', 5.33393716366491],
      ['2024-06-26T01:33:00Z', 5.422539181465443],
      ['2024-06-26T01:34:00Z', 5.389033771861555],
      ['2024-06-26T01:35:00Z', 5.423039983279382],
      ['2024-06-26T01:36:00Z', 4.997764815903528],
      ['2024-06-26T01:37:00Z', 5.384965171434002],
      ['2024-06-26T01:38:00Z', 5.518743607794389],
      ['2024-06-26T01:39:00Z', 5.20131313451445],
      ['2024-06-26T01:40:00Z', 5.450037740603405],
      ['2024-06-26T01:41:00Z', 5.399215563903992],
      ['2024-06-26T01:42:00Z', 5.416623336511741],
      ['2024-06-26T01:43:00Z', 5.295692884191883],
      ['2024-06-26T01:44:00Z', 5.176400552355666],
      ['2024-06-26T01:45:00Z', 5.481913583922147],
      ['2024-06-26T01:46:00Z', 5.297894079041027],
      ['2024-06-26T01:47:00Z', 5.57272674859678],
      ['2024-06-26T01:48:00Z', 5.451929002168229],
      ['2024-06-26T01:49:00Z', 5.453481435349027],
      ['2024-06-26T01:50:00Z', 5.3078865506255966],
      ['2024-06-26T01:51:00Z', 5.281010517581799],
      ['2024-06-26T01:52:00Z', 5.510744887339719],
      ['2024-06-26T01:53:00Z', 5.385618977402994],
      ['2024-06-26T01:54:00Z', 5.407263049794104],
      ['2024-06-26T01:55:00Z', 5.5425859841655205],
      ['2024-06-26T01:56:00Z', 5.410759836859435],
      ['2024-06-26T01:57:00Z', 5.348143021939336],
      ['2024-06-26T01:58:00Z', 5.282579513961289],
      ['2024-06-26T01:59:00Z', 5.47455714220832],
      ['2024-06-26T02:00:00Z', 5.299052197275675],
      ['2024-06-26T02:01:00Z', 5.289452465034234],
      ['2024-06-26T02:02:00Z', 5.194742296523514],
      ['2024-06-26T02:03:00Z', 5.194069402443653],
      ['2024-06-26T02:04:00Z', 5.196088084683235],
      ['2024-06-26T02:05:00Z', 5.188013355724908],
      ['2024-06-26T02:06:00Z', 5.196088084683235],
      ['2024-06-26T02:07:00Z', 5.182630203086024],
      ['2024-06-26T02:08:00Z', 5.397309396265467],
      ['2024-06-26T02:09:00Z', 5.4574403154381335],
      ['2024-06-26T02:10:00Z', 5.319865096503856],
      ['2024-06-26T02:11:00Z', 5.448329633375811],
      ['2024-06-26T02:12:00Z', 5.406576088488435],
      ['2024-06-26T02:13:00Z', 5.389954628197057],
      ['2024-06-26T02:14:00Z', 5.393427585212102],
      ['2024-06-26T02:15:00Z', 5.419318829552296],
      ['2024-06-26T02:16:00Z', 5.474034261714852],
      ['2024-06-26T02:17:00Z', 5.455971125477353],
      ['2024-06-26T02:18:00Z', 5.483667634105264],
      ['2024-06-26T02:19:00Z', 5.332538287696887],
      ['2024-06-26T02:20:00Z', 5.520466372951092],
      ['2024-06-26T02:21:00Z', 5.358078520764856],
      ['2024-06-26T02:22:00Z', 5.48398086102247],
      ['2024-06-26T02:23:00Z', 5.347527482421337],
      ['2024-06-26T02:24:00Z', 5.344440895895445],
      ['2024-06-26T02:25:00Z', 5.411109176063181],
      ['2024-06-26T02:26:00Z', 5.01240660507836],
      ['2024-06-26T02:27:00Z', 5.438503652414569],
      ['2024-06-26T02:28:00Z', 5.3750487766423465],
      ['2024-06-26T02:29:00Z', 5.521809689975501],
      ['2024-06-26T02:30:00Z', 5.292578490826358],
      ['2024-06-26T02:31:00Z', 5.189960675593169],
      ['2024-06-26T02:32:00Z', 5.41689483321782],
      ['2024-06-26T02:33:00Z', 5.4995386853012596],
      ['2024-06-26T02:34:00Z', 5.3865601963094285],
      ['2024-06-26T02:35:00Z', 5.2206671265066005],
      ['2024-06-26T02:36:00Z', 5.273039485970954],
      ['2024-06-26T02:37:00Z', 5.264418525168351],
      ['2024-06-26T02:38:00Z', 5.246372892818831],
      ['2024-06-26T02:39:00Z', 5.504435635962874],
      ['2024-06-26T02:40:00Z', 5.376419073631753],
      ['2024-06-26T02:41:00Z', 5.322259920208629],
      ['2024-06-26T02:42:00Z', 5.34085563913595],
      ['2024-06-26T02:43:00Z', 5.167096229421992],
      ['2024-06-26T02:44:00Z', 5.274312071226725],
      ['2024-06-26T02:45:00Z', 5.323240366551992],
      ['2024-06-26T02:46:00Z', 5.4095763142166335],
      ['2024-06-26T02:47:00Z', 5.443492062783736],
      ['2024-06-26T02:48:00Z', 5.235205104192315],
      ['2024-06-26T02:49:00Z', 5.180967266943144],
      ['2024-06-26T02:50:00Z', 5.413118080390697],
      ['2024-06-26T02:51:00Z', 5.539312645698666],
      ['2024-06-26T02:52:00Z', 5.503204894114047],
      ['2024-06-26T02:53:00Z', 5.260559546865038],
      ['2024-06-26T02:54:00Z', 5.20283063459022],
      ['2024-06-26T02:55:00Z', 5.194624268324146],
      ['2024-06-26T02:56:00Z', 5.445520351233441],
      ['2024-06-26T02:57:00Z', 5.353039063061833],
      ['2024-06-26T02:58:00Z', 5.148609177649095],
      ['2024-06-26T02:59:00Z', 5.07977417878168],
      ['2024-06-26T03:00:00Z', 5.231147741824028],
      ['2024-06-26T03:01:00Z', 5.580101092391768],
      ['2024-06-26T03:02:00Z', 5.5110719129712695],
      ['2024-06-26T03:03:00Z', 5.582450353346681],
      ['2024-06-26T03:04:00Z', 5.327773543356014],
      ['2024-06-26T03:05:00Z', 5.319520119565358],
      ['2024-06-26T03:06:00Z', 5.363888788875432],
      ['2024-06-26T03:07:00Z', 5.4837231277209435],
      ['2024-06-26T03:08:00Z', 5.369770147753252],
      ['2024-06-26T03:09:00Z', 5.344380029377829],
      ['2024-06-26T03:10:00Z', 5.2448200820617625],
      ['2024-06-26T03:11:00Z', 5.399546485834908],
      ['2024-06-26T03:12:00Z', 5.468200890676525],
      ['2024-06-26T03:13:00Z', 5.395183328333577],
      ['2024-06-26T03:14:00Z', 5.372522007853317],
      ['2024-06-26T03:15:00Z', 5.462021418051799],
      ['2024-06-26T03:16:00Z', 5.417425307895989],
      ['2024-06-26T03:17:00Z', 5.264637065498706],
      ['2024-06-26T03:18:00Z', 5.642286114950176],
      ['2024-06-26T03:19:00Z', 5.4362366330443885],
      ['2024-06-26T03:20:00Z', 5.395976234530342],
      ['2024-06-26T03:21:00Z', 5.302218117609731],
      ['2024-06-26T03:22:00Z', 5.387816118521337],
      ['2024-06-26T03:23:00Z', 5.32779791665398],
      ['2024-06-26T03:24:00Z', 5.312471954383051],
      ['2024-06-26T03:25:00Z', 5.053801847969618],
      ['2024-06-26T03:26:00Z', 5.451953455847796],
      ['2024-06-26T03:27:00Z', 5.5978863397017875],
      ['2024-06-26T03:28:00Z', 5.333665562878416],
      ['2024-06-26T03:29:00Z', 5.49959651956441],
      ['2024-06-26T03:30:00Z', 5.359133677491534],
      ['2024-06-26T03:31:00Z', 5.462778790944603],
      ['2024-06-26T03:32:00Z', 5.373917875519526],
      ['2024-06-26T03:33:00Z', 5.412444592031778],
      ['2024-06-26T03:34:00Z', 5.463014098463517],
      ['2024-06-26T03:35:00Z', 5.329982364503753],
      ['2024-06-26T03:36:00Z', 5.542414725917968],
      ['2024-06-26T03:37:00Z', 5.407245640462164],
      ['2024-06-26T03:38:00Z', 5.423613901083658],
      ['2024-06-26T03:39:00Z', 5.330638639962512],
      ['2024-06-26T03:40:00Z', 5.391412906934378],
      ['2024-06-26T03:41:00Z', 5.352080784178978],
      ['2024-06-26T03:42:00Z', 5.48427204205171],
      ['2024-06-26T03:43:00Z', 5.511137770243607],
      ['2024-06-26T03:44:00Z', 5.490565391450007],
      ['2024-06-26T03:45:00Z', 5.349331741479216],
      ['2024-06-26T03:46:00Z', 5.390737722599772],
      ['2024-06-26T03:47:00Z', 5.145285121293859],
      ['2024-06-26T03:48:00Z', 5.236742743837367],
      ['2024-06-26T03:49:00Z', 5.605755775791046],
      ['2024-06-26T03:50:00Z', 5.222584514390586],
      ['2024-06-26T03:51:00Z', 5.215476851573413],
      ['2024-06-26T03:52:00Z', 5.342410747676879],
      ['2024-06-26T03:53:00Z', 5.444967132401228],
      ['2024-06-26T03:54:00Z', 5.450436334352184],
      ['2024-06-26T03:55:00Z', 5.361014055347372],
      ['2024-06-26T03:56:00Z', 5.190321065584705],
      ['2024-06-26T03:57:00Z', 5.6686622536429185],
      ['2024-06-26T03:58:00Z', 5.545102620514133],
      ['2024-06-26T03:59:00Z', 5.239441688593328],
      ['2024-06-26T04:00:00Z', 5.311440130075084],
      ['2024-06-26T04:01:00Z', 5.162167636147091],
      ['2024-06-26T04:02:00Z', 5.568982190724993],
      ['2024-06-26T04:03:00Z', 5.647597674767653],
      ['2024-06-26T04:04:00Z', 5.194432451135608],
      ['2024-06-26T04:05:00Z', 4.99558340453485],
      ['2024-06-26T04:06:00Z', 5.107944740926358],
      ['2024-06-26T04:07:00Z', 5.502558802407025],
      ['2024-06-26T04:08:00Z', 5.747466213407389],
      ['2024-06-26T04:09:00Z', 5.303828655465856],
      ['2024-06-26T04:10:00Z', 5.326302389992926],
      ['2024-06-26T04:11:00Z', 5.333420252858016],
      ['2024-06-26T04:12:00Z', 5.371623445672745],
      ['2024-06-26T04:13:00Z', 5.489280708376602],
      ['2024-06-26T04:14:00Z', 5.459284662763699],
      ['2024-06-26T04:15:00Z', 5.567455085760747],
      ['2024-06-26T04:16:00Z', 5.3672719495075745],
      ['2024-06-26T04:17:00Z', 5.08874406141115],
      ['2024-06-26T04:18:00Z', 5.24217311909617],
      ['2024-06-26T04:19:00Z', 5.4229577740673856],
      ['2024-06-26T04:20:00Z', 5.217981431939452],
      ['2024-06-26T04:21:00Z', 5.331153896639658],
      ['2024-06-26T04:22:00Z', 5.343988512248355],
      ['2024-06-26T04:23:00Z', 5.413942586816503],
      ['2024-06-26T04:24:00Z', 5.611330074608031],
      ['2024-06-26T04:25:00Z', 5.1327742093329825],
      ['2024-06-26T04:26:00Z', 5.278158089478481],
      ['2024-06-26T04:27:00Z', 5.396889391911465],
      ['2024-06-26T04:28:00Z', 5.407225302373736],
      ['2024-06-26T04:29:00Z', 5.555982994552486],
      ['2024-06-26T04:30:00Z', 5.413409291276972],
      ['2024-06-26T04:31:00Z', 5.580009830714645],
      ['2024-06-26T04:32:00Z', 5.166320213394031],
      ['2024-06-26T04:33:00Z', 5.373262555432336],
      ['2024-06-26T04:34:00Z', 5.367138378721385],
      ['2024-06-26T04:35:00Z', 5.313679204864279],
      ['2024-06-26T04:36:00Z', 5.396251698019629],
      ['2024-06-26T04:37:00Z', 5.298965671373358],
      ['2024-06-26T04:38:00Z', 5.455061806156268],
      ['2024-06-26T04:39:00Z', 5.485003367298653],
      ['2024-06-26T04:40:00Z', 5.376362222276791],
      ['2024-06-26T04:41:00Z', 5.283624834009946],
      ['2024-06-26T04:42:00Z', 5.177563896906424],
      ['2024-06-26T04:43:00Z', 5.287299455987781],
      ['2024-06-26T04:44:00Z', 5.294433752081158],
      ['2024-06-26T04:45:00Z', 5.633516418921612],
      ['2024-06-26T04:46:00Z', 5.4519044268049655],
      ['2024-06-26T04:47:00Z', 5.533844576758242],
      ['2024-06-26T04:48:00Z', 5.299947855590563],
      ['2024-06-26T04:49:00Z', 5.386073624947499],
      ['2024-06-26T04:50:00Z', 5.36069002916062],
      ['2024-06-26T04:51:00Z', 5.231435855917141],
      ['2024-06-26T04:52:00Z', 5.481868562156395],
      ['2024-06-26T04:53:00Z', 5.380847902928409],
      ['2024-06-26T04:54:00Z', 5.52007969619601],
      ['2024-06-26T04:55:00Z', 5.212575215687136],
      ['2024-06-26T04:56:00Z', 5.319315422711919],
      ['2024-06-26T04:57:00Z', 5.44872110005823],
      ['2024-06-26T04:58:00Z', 5.4497461942626115],
      ['2024-06-26T04:59:00Z', 5.556593843591326],
      ['2024-06-26T05:00:00Z', 5.416335700458263],
      ['2024-06-26T05:01:00Z', 5.352660385941839],
      ['2024-06-26T05:02:00Z', 5.40739450517631],
      ['2024-06-26T05:03:00Z', 5.550089089181637],
      ['2024-06-26T05:04:00Z', 5.62768153204411],
      ['2024-06-26T05:05:00Z', 5.3921200746369],
      ['2024-06-26T05:06:00Z', 5.4461286748269435],
      ['2024-06-26T05:07:00Z', 5.40956652998622],
      ['2024-06-26T05:08:00Z', 5.58084921492804],
      ['2024-06-26T05:09:00Z', 5.220745619744013],
      ['2024-06-26T05:10:00Z', 5.504971317250155],
      ['2024-06-26T05:11:00Z', 5.467756410058241],
      ['2024-06-26T05:12:00Z', 5.498647159028889],
      ['2024-06-26T05:13:00Z', 5.6316626258444265],
      ['2024-06-26T05:14:00Z', 5.477567339937244],
      ['2024-06-26T05:15:00Z', 5.333720952426549],
      ['2024-06-26T05:16:00Z', 5.358216847566542],
      ['2024-06-26T05:17:00Z', 5.53011940973089],
      ['2024-06-26T05:18:00Z', 5.493965919783188],
      ['2024-06-26T05:19:00Z', 5.509267220301108],
      ['2024-06-26T05:20:00Z', 5.318632467418699],
      ['2024-06-26T05:21:00Z', 5.48662377145388],
      ['2024-06-26T05:22:00Z', 5.479960082367893],
      ['2024-06-26T05:23:00Z', 5.405213227825954],
      ['2024-06-26T05:24:00Z', 5.459452517774476],
      ['2024-06-26T05:25:00Z', 5.295013468625912],
      ['2024-06-26T05:26:00Z', 5.386819989068238],
      ['2024-06-26T05:27:00Z', 5.373415651310957],
      ['2024-06-26T05:28:00Z', 5.292403254235949],
      ['2024-06-26T05:29:00Z', 5.325567110723532],
      ['2024-06-26T05:30:00Z', 5.301283088067534],
      ['2024-06-26T05:31:00Z', 5.51481732550787],
      ['2024-06-26T05:32:00Z', 5.292675474073318],
      ['2024-06-26T05:33:00Z', 5.426708497167504],
      ['2024-06-26T05:34:00Z', 5.442282671544712],
      ['2024-06-26T05:35:00Z', 5.48164377856415],
      ['2024-06-26T05:36:00Z', 5.475216758464954],
      ['2024-06-26T05:37:00Z', 5.437023560425557],
      ['2024-06-26T05:38:00Z', 5.523057447084461],
      ['2024-06-26T05:39:00Z', 5.2865622336674996],
      ['2024-06-26T05:40:00Z', 5.239043393538106],
      ['2024-06-26T05:41:00Z', 5.627389103259521],
      ['2024-06-26T05:42:00Z', 5.531050088922234],
      ['2024-06-26T05:43:00Z', 5.358180840388918],
      ['2024-06-26T05:44:00Z', 5.2268244918190225],
      ['2024-06-26T05:45:00Z', 5.359295766640016],
      ['2024-06-26T05:46:00Z', 5.369730171886433],
      ['2024-06-26T05:47:00Z', 5.210212903289324],
      ['2024-06-26T05:48:00Z', 5.357946532998458],
      ['2024-06-26T05:49:00Z', 5.400407468969136],
      ['2024-06-26T05:50:00Z', 5.332439741186887],
      ['2024-06-26T05:51:00Z', 5.283064298627063],
      ['2024-06-26T05:52:00Z', 5.485184601248207],
      ['2024-06-26T05:53:00Z', 5.155773009692337],
      ['2024-06-26T05:54:00Z', 5.3617523456428815],
      ['2024-06-26T05:55:00Z', 5.43453429147999],
      ['2024-06-26T05:56:00Z', 5.588221563573629],
      ['2024-06-26T05:57:00Z', 5.445194534457782],
      ['2024-06-26T05:58:00Z', 5.552161582211638],
      ['2024-06-26T05:59:00Z', 5.489848543757247],
      ['2024-06-26T06:00:00Z', 5.427557833725086],
      ['2024-06-26T06:01:00Z', 5.447154432659564],
      ['2024-06-26T06:02:00Z', 5.482538489675602],
      ['2024-06-26T06:03:00Z', 5.629623334834448],
      ['2024-06-26T06:04:00Z', 5.379130601793431],
      ['2024-06-26T06:05:00Z', 5.304276903105888],
      ['2024-06-26T06:06:00Z', 5.484939294450221],
      ['2024-06-26T06:07:00Z', 5.559001599941939],
      ['2024-06-26T06:08:00Z', 5.4862578627276894],
      ['2024-06-26T06:09:00Z', 5.620187070185575],
      ['2024-06-26T06:10:00Z', 5.610352364385704],
      ['2024-06-26T06:11:00Z', 5.435168287019889],
      ['2024-06-26T06:12:00Z', 5.462724463176624],
      ['2024-06-26T06:13:00Z', 5.484833779045668],
      ['2024-06-26T06:14:00Z', 5.470604961000851],
      ['2024-06-26T06:15:00Z', 5.615253631178059],
      ['2024-06-26T06:16:00Z', 5.405681165938922],
      ['2024-06-26T06:17:00Z', 5.506123831044338],
      ['2024-06-26T06:18:00Z', 5.639089794690933],
      ['2024-06-26T06:19:00Z', 5.7132891332961595],
      ['2024-06-26T06:20:00Z', 5.686072028938579],
      ['2024-06-26T06:21:00Z', 5.5004176415541775],
      ['2024-06-26T06:22:00Z', 5.6393341885897845],
      ['2024-06-26T06:23:00Z', 5.3194742127730805],
      ['2024-06-26T06:24:00Z', 5.5887839295485575],
      ['2024-06-26T06:25:00Z', 5.559647978377909],
      ['2024-06-26T06:26:00Z', 5.516481564826994],
      ['2024-06-26T06:27:00Z', 5.54151982820258],
      ['2024-06-26T06:28:00Z', 5.5765410668687165],
      ['2024-06-26T06:29:00Z', 5.563702444477886],
      ['2024-06-26T06:30:00Z', 5.396348361018518],
      ['2024-06-26T06:31:00Z', 5.565274978918054],
      ['2024-06-26T06:32:00Z', 5.739726043758324],
      ['2024-06-26T06:33:00Z', 5.613162872060972],
      ['2024-06-26T06:34:00Z', 5.428683687721243],
      ['2024-06-26T06:35:00Z', 5.673824356323705],
      ['2024-06-26T06:36:00Z', 5.466975269739654],
      ['2024-06-26T06:37:00Z', 5.451402887464391],
      ['2024-06-26T06:38:00Z', 5.513301719360993],
      ['2024-06-26T06:39:00Z', 5.5955890617620385],
      ['2024-06-26T06:40:00Z', 5.537479855002891],
      ['2024-06-26T06:41:00Z', 5.532852862561714],
      ['2024-06-26T06:42:00Z', 5.4996717695545785],
      ['2024-06-26T06:43:00Z', 5.450655595292094],
      ['2024-06-26T06:44:00Z', 5.585382524208144],
      ['2024-06-26T06:45:00Z', 5.5730113564645904],
      ['2024-06-26T06:46:00Z', 5.504188726384381],
      ['2024-06-26T06:47:00Z', 5.596703602856316],
      ['2024-06-26T06:48:00Z', 5.439126802676337],
      ['2024-06-26T06:49:00Z', 5.506470004950193],
      ['2024-06-26T06:50:00Z', 5.6757493658596845],
      ['2024-06-26T06:51:00Z', 5.623714780235928],
      ['2024-06-26T06:52:00Z', 5.670209814098836],
      ['2024-06-26T06:53:00Z', 5.600701322010477],
      ['2024-06-26T06:54:00Z', 5.507742078119451],
      ['2024-06-26T06:55:00Z', 5.432289343192255],
      ['2024-06-26T06:56:00Z', 5.524807860980658],
      ['2024-06-26T06:57:00Z', 5.597406858441899],
      ['2024-06-26T06:58:00Z', 5.7910951147130945],
      ['2024-06-26T06:59:00Z', 5.501654823232278],
      ['2024-06-26T07:00:00Z', 5.242744099683319],
      ['2024-06-26T07:01:00Z', 5.523397484230999],
      ['2024-06-26T07:02:00Z', 5.581175252087669],
      ['2024-06-26T07:03:00Z', 5.633877303342195],
      ['2024-06-26T07:04:00Z', 5.561512098465646],
      ['2024-06-26T07:05:00Z', 5.487834575394435],
      ['2024-06-26T07:06:00Z', 5.467327481387623],
      ['2024-06-26T07:07:00Z', 5.42476762578103],
      ['2024-06-26T07:08:00Z', 5.4948392306380365],
      ['2024-06-26T07:09:00Z', 5.636486360525966],
      ['2024-06-26T07:10:00Z', 5.666324125550177],
      ['2024-06-26T07:11:00Z', 5.51631082848843],
      ['2024-06-26T07:12:00Z', 5.586899762058172],
      ['2024-06-26T07:13:00Z', 5.492184062168586],
      ['2024-06-26T07:14:00Z', 5.381040689030702],
      ['2024-06-26T07:15:00Z', 5.596894707607815],
      ['2024-06-26T07:16:00Z', 5.540510058869498],
      ['2024-06-26T07:17:00Z', 5.727140669861469],
      ['2024-06-26T07:18:00Z', 5.4674634900532775],
      ['2024-06-26T07:19:00Z', 5.504961041917813],
      ['2024-06-26T07:20:00Z', 5.457006158571683],
      ['2024-06-26T07:21:00Z', 5.466057752227632],
      ['2024-06-26T07:22:00Z', 5.637551496565753],
      ['2024-06-26T07:23:00Z', 5.533152344868937],
      ['2024-06-26T07:24:00Z', 5.360933641674801],
      ['2024-06-26T07:25:00Z', 5.340203609426006],
      ['2024-06-26T07:26:00Z', 5.0908076850519945],
      ['2024-06-26T07:27:00Z', 5.343916637513325],
      ['2024-06-26T07:28:00Z', 5.388873439316284],
      ['2024-06-26T07:29:00Z', 5.271084060504305],
      ['2024-06-26T07:30:00Z', 5.305734284996347],
      ['2024-06-26T07:31:00Z', 5.297954005371626],
      ['2024-06-26T07:32:00Z', 5.251324728829517],
      ['2024-06-26T07:33:00Z', 5.243132584065275],
      ['2024-06-26T07:34:00Z', 5.208374360316219],
      ['2024-06-26T07:35:00Z', 5.408232664310979],
      ['2024-06-26T07:36:00Z', 5.25464413810111],
      ['2024-06-26T07:37:00Z', 5.364851942408563],
      ['2024-06-26T07:38:00Z', 5.222227548564666],
      ['2024-06-26T07:39:00Z', 5.18632737673776],
      ['2024-06-26T07:40:00Z', 5.345324879007971],
      ['2024-06-26T07:41:00Z', 5.254253709589463],
      ['2024-06-26T07:42:00Z', 5.367912532573457],
      ['2024-06-26T07:43:00Z', 5.3300727334098],
      ['2024-06-26T07:44:00Z', 5.305073507431516],
      ['2024-06-26T07:45:00Z', 5.275484303155012],
      ['2024-06-26T07:46:00Z', 5.173788922595127],
      ['2024-06-26T07:47:00Z', 5.371801961855896],
      ['2024-06-26T07:48:00Z', 5.370371737235418],
      ['2024-06-26T07:49:00Z', 5.354944559835889],
      ['2024-06-26T07:50:00Z', 5.183639191074405],
      ['2024-06-26T07:51:00Z', 5.306117907999783],
      ['2024-06-26T07:52:00Z', 5.257081397248631],
      ['2024-06-26T07:53:00Z', 5.2629607803911105],
      ['2024-06-26T07:54:00Z', 5.277640613249585],
      ['2024-06-26T07:55:00Z', 5.365578130925357],
      ['2024-06-26T07:56:00Z', 5.359125263573235],
      ['2024-06-26T07:57:00Z', 5.276948818664846],
      ['2024-06-26T07:58:00Z', 5.326706240870215],
      ['2024-06-26T07:59:00Z', 5.215195878119878],
      ['2024-06-26T08:00:00Z', 5.328624972301257],
      ['2024-06-26T08:01:00Z', 5.365628049495284],
      ['2024-06-26T08:02:00Z', 5.3270454620448255],
      ['2024-06-26T08:03:00Z', 5.295302488018366],
      ['2024-06-26T08:04:00Z', 5.323713387920631],
      ['2024-06-26T08:05:00Z', 5.246377449132369],
      ['2024-06-26T08:06:00Z', 5.34431240679818],
      ['2024-06-26T08:07:00Z', 5.318075712305978],
      ['2024-06-26T08:08:00Z', 5.366884421262561],
      ['2024-06-26T08:09:00Z', 5.308520942509379],
      ['2024-06-26T08:10:00Z', 5.211603109129456],
      ['2024-06-26T08:11:00Z', 5.2608789960637035],
      ['2024-06-26T08:12:00Z', 5.36283074572091],
      ['2024-06-26T08:13:00Z', 5.3299931816938955],
      ['2024-06-26T08:14:00Z', 5.34885124455745],
      ['2024-06-26T08:15:00Z', 5.222173268053764],
      ['2024-06-26T08:16:00Z', 5.296112516604192],
      ['2024-06-26T08:17:00Z', 5.2543421133081205],
      ['2024-06-26T08:18:00Z', 5.352095836549865],
      ['2024-06-26T08:19:00Z', 5.422036067242862],
      ['2024-06-26T08:20:00Z', 5.354250454451486],
      ['2024-06-26T08:21:00Z', 5.25962734358686],
      ['2024-06-26T08:22:00Z', 5.241079000272409],
      ['2024-06-26T08:23:00Z', 5.278913701752467],
      ['2024-06-26T08:24:00Z', 5.336331614136514],
      ['2024-06-26T08:25:00Z', 5.3599972794698765],
      ['2024-06-26T08:26:00Z', 5.322386109651107],
      ['2024-06-26T08:27:00Z', 5.290388539649539],
      ['2024-06-26T08:28:00Z', 5.31653034678086],
      ['2024-06-26T08:29:00Z', 5.218801022048066],
      ['2024-06-26T08:30:00Z', 5.295068347017882],
      ['2024-06-26T08:31:00Z', 5.1909079209186775],
      ['2024-06-26T08:32:00Z', 5.352915754693869],
      ['2024-06-26T08:33:00Z', 5.334554418600643],
      ['2024-06-26T08:34:00Z', 5.379004966284458],
      ['2024-06-26T08:35:00Z', 5.258008729667853],
      ['2024-06-26T08:36:00Z', 5.239560352177679],
      ['2024-06-26T08:37:00Z', 5.38121453970977],
      ['2024-06-26T08:38:00Z', 5.323423886803101],
      ['2024-06-26T08:39:00Z', 5.377782791584729],
      ['2024-06-26T08:40:00Z', 5.3019825360256885],
      ['2024-06-26T08:41:00Z', 5.243519468722259],
      ['2024-06-26T08:42:00Z', 5.387549844343983],
      ['2024-06-26T08:43:00Z', 5.464811132132665],
      ['2024-06-26T08:44:00Z', 5.356553528660443],
      ['2024-06-26T08:45:00Z', 5.322744050081739],
      ['2024-06-26T08:46:00Z', 5.333933023792618],
      ['2024-06-26T08:47:00Z', 5.385101471260383],
      ['2024-06-26T08:48:00Z', 5.3366491264726585],
      ['2024-06-26T08:49:00Z', 5.347595966620265],
      ['2024-06-26T08:50:00Z', 5.399960208586644],
      ['2024-06-26T08:51:00Z', 5.4815258612099775],
      ['2024-06-26T08:52:00Z', 5.394230734583583],
      ['2024-06-26T08:53:00Z', 5.413610757934582],
      ['2024-06-26T08:54:00Z', 5.28702118230192],
      ['2024-06-26T08:55:00Z', 5.321403792764921],
      ['2024-06-26T08:56:00Z', 5.275986191728715],
      ['2024-06-26T08:57:00Z', 5.335206472912987],
      ['2024-06-26T08:58:00Z', 5.350182598208735],
      ['2024-06-26T08:59:00Z', 5.403429902087736],
      ['2024-06-26T09:00:00Z', 5.2858289777172365],
      ['2024-06-26T09:01:00Z', 5.175812986699216],
      ['2024-06-26T09:02:00Z', 5.300408299098753],
      ['2024-06-26T09:03:00Z', 5.302097542672984],
      ['2024-06-26T09:04:00Z', 5.419245240251472],
      ['2024-06-26T09:05:00Z', 5.2655099909391545],
      ['2024-06-26T09:06:00Z', 5.397827382009022],
      ['2024-06-26T09:07:00Z', 5.211730613830157],
      ['2024-06-26T09:08:00Z', 5.267657062623672],
      ['2024-06-26T09:09:00Z', 5.378091851478443],
      ['2024-06-26T09:10:00Z', 5.3729839293994965],
      ['2024-06-26T09:11:00Z', 5.363277918141237],
      ['2024-06-26T09:12:00Z', 5.366020004293939],
      ['2024-06-26T09:13:00Z', 5.386263336522573],
      ['2024-06-26T09:14:00Z', 5.2917454382436455],
      ['2024-06-26T09:15:00Z', 5.311515908227395],
      ['2024-06-26T09:16:00Z', 5.299552422623977],
      ['2024-06-26T09:17:00Z', 5.427149089645702],
      ['2024-06-26T09:18:00Z', 5.3007106147817655],
      ['2024-06-26T09:19:00Z', 5.294345712141566],
      ['2024-06-26T09:20:00Z', 5.40648088168824],
      ['2024-06-26T09:21:00Z', 5.359872740229873],
      ['2024-06-26T09:22:00Z', 5.293611990194632],
      ['2024-06-26T09:23:00Z', 5.458168339297649],
      ['2024-06-26T09:24:00Z', 5.382695972873426],
      ['2024-06-26T09:25:00Z', 5.26410554675571],
      ['2024-06-26T09:26:00Z', 5.396323567565456],
      ['2024-06-26T09:27:00Z', 5.301154095220997],
      ['2024-06-26T09:28:00Z', 5.37982927813792],
      ['2024-06-26T09:29:00Z', 5.384919150772287],
      ['2024-06-26T09:30:00Z', 5.394453692444967],
      ['2024-06-26T09:31:00Z', 5.359538390085979],
      ['2024-06-26T09:32:00Z', 5.299097038155871],
      ['2024-06-26T09:33:00Z', 5.277791600390708],
      ['2024-06-26T09:34:00Z', 5.312746562659705],
      ['2024-06-26T09:35:00Z', 5.37247127236939],
      ['2024-06-26T09:36:00Z', 5.430302292019867],
      ['2024-06-26T09:37:00Z', 5.43837761146562],
      ['2024-06-26T09:38:00Z', 5.294010654044245],
      ['2024-06-26T09:39:00Z', 5.394659361396082],
      ['2024-06-26T09:40:00Z', 5.445392548806306],
      ['2024-06-26T09:41:00Z', 5.475226853869959],
      ['2024-06-26T09:42:00Z', 5.474611821512996],
      ['2024-06-26T09:43:00Z', 5.4858668015411975],
      ['2024-06-26T09:44:00Z', 5.426307904490858],
      ['2024-06-26T09:45:00Z', 5.500123620274341],
      ['2024-06-26T09:46:00Z', 5.395487096225135],
      ['2024-06-26T09:47:00Z', 5.341653405590849],
      ['2024-06-26T09:48:00Z', 5.43038276877634],
      ['2024-06-26T09:49:00Z', 5.587032880437262],
      ['2024-06-26T09:50:00Z', 5.494902889879743],
      ['2024-06-26T09:51:00Z', 5.503702918841154],
      ['2024-06-26T09:52:00Z', 5.485568122841856],
      ['2024-06-26T09:53:00Z', 5.496302753527593],
      ['2024-06-26T09:54:00Z', 5.317395402403615],
      ['2024-06-26T09:55:00Z', 5.375554664281892],
      ['2024-06-26T09:56:00Z', 5.53683793651071],
      ['2024-06-26T09:57:00Z', 5.445584706276208],
      ['2024-06-26T09:58:00Z', 5.344644869045872],
      ['2024-06-26T09:59:00Z', 5.575036438480548],
      ['2024-06-26T10:00:00Z', 5.427266024343188],
      ['2024-06-26T10:01:00Z', 5.4850141338324665],
      ['2024-06-26T10:02:00Z', 5.479019107530142],
      ['2024-06-26T10:03:00Z', 5.369825990802232],
      ['2024-06-26T10:04:00Z', 5.387897442538631],
      ['2024-06-26T10:05:00Z', 5.293762613439126],
      ['2024-06-26T10:06:00Z', 5.409734633837855],
      ['2024-06-26T10:07:00Z', 5.4634540220647505],
      ['2024-06-26T10:08:00Z', 5.45760079916651],
      ['2024-06-26T10:09:00Z', 5.3999091005721995],
      ['2024-06-26T10:10:00Z', 5.1667054247297965],
      ['2024-06-26T10:11:00Z', 5.425173921254035],
      ['2024-06-26T10:12:00Z', 5.533391054529484],
      ['2024-06-26T10:13:00Z', 5.5672233522927055],
      ['2024-06-26T10:14:00Z', 5.36990376288318],
      ['2024-06-26T10:15:00Z', 5.52962162054656],
      ['2024-06-26T10:16:00Z', 5.414100815418028],
      ['2024-06-26T10:17:00Z', 5.466303853065619],
      ['2024-06-26T10:18:00Z', 5.344699411395659],
      ['2024-06-26T10:19:00Z', 5.274224843966452],
      ['2024-06-26T10:20:00Z', 5.354796446648144],
      ['2024-06-26T10:21:00Z', 5.360501779067407],
      ['2024-06-26T10:22:00Z', 14.153284230567035],
      ['2024-06-26T10:23:00Z', 7.459564877137891],
      ['2024-06-26T10:24:00Z', 6.869710709889908],
      ['2024-06-26T10:25:00Z', 6.925209302050954],
      ['2024-06-26T10:26:00Z', 6.931764965993472],
      ['2024-06-26T10:27:00Z', 9.081003206676147],
      ['2024-06-26T10:28:00Z', 7.8098374461698965],
      ['2024-06-26T10:29:00Z', 6.753325000742979],
      ['2024-06-26T10:30:00Z', 6.900723108683755],
      ['2024-06-26T10:31:00Z', 6.845534328888047],
      ['2024-06-26T10:32:00Z', 6.8631654115539975],
      ['2024-06-26T10:33:00Z', 9.784886605256228],
      ['2024-06-26T10:34:00Z', 8.843090687410323],
      ['2024-06-26T10:35:00Z', 6.622574623870044],
      ['2024-06-26T10:36:00Z', 6.754670189097969],
      ['2024-06-26T10:37:00Z', 6.776816880685276],
      ['2024-06-26T10:38:00Z', 7.2683883896788695],
      ['2024-06-26T10:39:00Z', 9.967107809302332],
      ['2024-06-26T10:40:00Z', 6.608484460731968],
      ['2024-06-26T10:41:00Z', 6.533363926957704],
      ['2024-06-26T10:42:00Z', 6.468020599888318],
      ['2024-06-26T10:43:00Z', 6.510887957572065],
      ['2024-06-26T10:44:00Z', 6.631201000243057],
      ['2024-06-26T10:45:00Z', 6.706897404768565],
      ['2024-06-26T10:46:00Z', 7.9037946257764276],
      ['2024-06-26T10:47:00Z', 6.6675652559467],
      ['2024-06-26T10:48:00Z', 6.617044672269507],
      ['2024-06-26T10:49:00Z', 6.563602670050981],
      ['2024-06-26T10:50:00Z', 6.563795454755713],
      ['2024-06-26T10:51:00Z', 6.6644703546365625],
      ['2024-06-26T10:52:00Z', 7.134952914391212],
      ['2024-06-26T10:53:00Z', 7.735983950509519],
      ['2024-06-26T10:54:00Z', 6.627485804097834],
      ['2024-06-26T10:55:00Z', 6.447893346793129],
      ['2024-06-26T10:56:00Z', 6.556365288072966],
      ['2024-06-26T10:57:00Z', 6.594099103224872],
      ['2024-06-26T10:58:00Z', 6.633087147955139],
      ['2024-06-26T10:59:00Z', 6.609212598177035],
      ['2024-06-26T11:00:00Z', 9.43878808041468],
      ['2024-06-26T11:01:00Z', 6.597563742879133],
      ['2024-06-26T11:02:00Z', 6.508524741507698],
      ['2024-06-26T11:03:00Z', 6.681209881282175],
      ['2024-06-26T11:04:00Z', 6.631975055220197],
      ['2024-06-26T11:05:00Z', 6.722775270516535],
      ['2024-06-26T11:06:00Z', 6.727767972862672],
      ['2024-06-26T11:07:00Z', 7.623574986144048],
      ['2024-06-26T11:08:00Z', 7.10370476140228],
      ['2024-06-26T11:09:00Z', 6.546848561506046],
      ['2024-06-26T11:10:00Z', 6.70890794122862],
      ['2024-06-26T11:11:00Z', 6.6779201882346415],
      ['2024-06-26T11:12:00Z', 6.729401380251289],
      ['2024-06-26T11:13:00Z', 6.401851613584241],
      ['2024-06-26T11:14:00Z', 6.9938681055619405],
      ['2024-06-26T11:15:00Z', 10.29522153118423],
      ['2024-06-26T11:16:00Z', 7.988488980602001],
      ['2024-06-26T11:17:00Z', 6.403750723814432],
      ['2024-06-26T11:18:00Z', 6.465336139596453],
      ['2024-06-26T11:19:00Z', 6.580468171278251],
      ['2024-06-26T11:20:00Z', 6.670068503490434],
      ['2024-06-26T11:21:00Z', 6.53285361615287],
      ['2024-06-26T11:22:00Z', 6.61731136805044],
      ['2024-06-26T11:23:00Z', 7.919534051186643],
      ['2024-06-26T11:24:00Z', 6.869535637617561],
      ['2024-06-26T11:25:00Z', 6.424500470989839],
      ['2024-06-26T11:26:00Z', 6.212942320220796],
      ['2024-06-26T11:27:00Z', 6.37341169673658],
      ['2024-06-26T11:28:00Z', 6.270521161222782],
      ['2024-06-26T11:29:00Z', 6.536714024418701],
      ['2024-06-26T11:30:00Z', 6.28772925397639],
      ['2024-06-26T11:31:00Z', 6.205899932895859],
      ['2024-06-26T11:32:00Z', 6.272884909504197],
      ['2024-06-26T11:33:00Z', 6.264697259092777],
      ['2024-06-26T11:34:00Z', 6.2911458223836325],
      ['2024-06-26T11:35:00Z', 6.379565180025854],
      ['2024-06-26T11:36:00Z', 6.502335473563724],
      ['2024-06-26T11:37:00Z', 6.494732334134492],
      ['2024-06-26T11:38:00Z', 6.363377966212618],
      ['2024-06-26T11:39:00Z', 6.467961891250583],
      ['2024-06-26T11:40:00Z', 6.380551304441737],
      ['2024-06-26T11:41:00Z', 6.448063795011384],
      ['2024-06-26T11:42:00Z', 6.329363330947676],
      ['2024-06-26T11:43:00Z', 6.3215267427112405],
      ['2024-06-26T11:44:00Z', 6.355901293707228],
      ['2024-06-26T11:45:00Z', 6.315985115395307],
      ['2024-06-26T11:46:00Z', 6.132225690463241],
      ['2024-06-26T11:47:00Z', 6.192802163186247],
      ['2024-06-26T11:48:00Z', 6.336326094044172],
      ['2024-06-26T11:49:00Z', 6.390258424939794],
      ['2024-06-26T11:50:00Z', 6.320874565021912],
      ['2024-06-26T11:51:00Z', 6.104781822555361],
      ['2024-06-26T11:52:00Z', 6.284255411386051],
      ['2024-06-26T11:53:00Z', 6.203894313832368],
      ['2024-06-26T11:54:00Z', 6.310779088806161],
      ['2024-06-26T11:55:00Z', 6.234923510395252],
      ['2024-06-26T11:56:00Z', 6.428205140051963],
      ['2024-06-26T11:57:00Z', 6.580157129301597],
      ['2024-06-26T11:58:00Z', 6.508301050255189],
      ['2024-06-26T11:59:00Z', 6.5251555560900645],
      ['2024-06-26T12:00:00Z', 6.234252647462496],
      ['2024-06-26T12:01:00Z', 6.375321047320288],
      ['2024-06-26T12:02:00Z', 6.343710144032832],
      ['2024-06-26T12:03:00Z', 6.534168664293466],
      ['2024-06-26T12:04:00Z', 6.500260855646992],
      ['2024-06-26T12:05:00Z', 6.45155160019338],
      ['2024-06-26T12:06:00Z', 6.404892441434543],
      ['2024-06-26T12:07:00Z', 6.5365567273956495],
      ['2024-06-26T12:08:00Z', 7.5867392278078025],
      ['2024-06-26T12:09:00Z', 7.555067907882254],
      ['2024-06-26T12:10:00Z', 6.631871290086402],
      ['2024-06-26T12:11:00Z', 6.421782017661781],
      ['2024-06-26T12:12:00Z', 6.24837184660666],
      ['2024-06-26T12:13:00Z', 6.238669334747127],
      ['2024-06-26T12:14:00Z', 6.294502963176636],
      ['2024-06-26T12:15:00Z', 6.157012437588158],
      ['2024-06-26T12:16:00Z', 6.315295788617993],
      ['2024-06-26T12:17:00Z', 6.41887478125539],
      ['2024-06-26T12:18:00Z', 6.50512250909636],
      ['2024-06-26T12:19:00Z', 6.647526236772272],
      ['2024-06-26T12:20:00Z', 6.582930665319909],
      ['2024-06-26T12:21:00Z', 6.804032324967696],
      ['2024-06-26T12:22:00Z', 10.39704855364668],
      ['2024-06-26T12:23:00Z', 8.86396823920876],
      ['2024-06-26T12:24:00Z', 7.391185356093304],
      ['2024-06-26T12:25:00Z', 6.831419077146126],
      ['2024-06-26T12:26:00Z', 7.0324641991922725],
      ['2024-06-26T12:27:00Z', 9.427906178672982],
      ['2024-06-26T12:28:00Z', 7.736775151593369],
      ['2024-06-26T12:29:00Z', 7.069262074280178],
      ['2024-06-26T12:30:00Z', 7.199730742608126],
      ['2024-06-26T12:31:00Z', 7.818724943209434],
      ['2024-06-26T12:32:00Z', 8.473426802792156],
      ['2024-06-26T12:33:00Z', 12.751307145215769],
      ['2024-06-26T12:34:00Z', 7.539449414970066],
      ['2024-06-26T12:35:00Z', 7.464551443717224],
      ['2024-06-26T12:36:00Z', 7.154411977147029],
      ['2024-06-26T12:37:00Z', 7.347738355618962],
      ['2024-06-26T12:38:00Z', 7.371874738428558],
      ['2024-06-26T12:39:00Z', 6.486059223183312],
      ['2024-06-26T12:40:00Z', 6.862609575160095],
      ['2024-06-26T12:41:00Z', 6.798559240702563],
      ['2024-06-26T12:42:00Z', 6.868268162910235],
      ['2024-06-26T12:43:00Z', 8.288409531198235],
      ['2024-06-26T12:44:00Z', 7.566758383882694],
      ['2024-06-26T12:45:00Z', 6.490602871854898],
      ['2024-06-26T12:46:00Z', 6.636741575539837],
      ['2024-06-26T12:47:00Z', 6.49693119413905],
      ['2024-06-26T12:48:00Z', 6.72752733311469],
      ['2024-06-26T12:49:00Z', 6.690367706489082],
      ['2024-06-26T12:50:00Z', 6.7371502917192485],
      ['2024-06-26T12:51:00Z', 7.598657576848006],
      ['2024-06-26T12:52:00Z', 6.257550180072303],
      ['2024-06-26T12:53:00Z', 6.425610470233908],
      ['2024-06-26T12:54:00Z', 6.218527837228604],
      ['2024-06-26T12:55:00Z', 6.254229978848946],
      ['2024-06-26T12:56:00Z', 6.422067106420031],
      ['2024-06-26T12:57:00Z', 6.39126131042705],
      ['2024-06-26T12:58:00Z', 6.476000529407763],
      ['2024-06-26T12:59:00Z', 6.602093422248796],
      ['2024-06-26T13:00:00Z', 6.504081517233771],
      ['2024-06-26T13:01:00Z', 6.4955486062956815],
      ['2024-06-26T13:02:00Z', 6.521704475189077],
      ['2024-06-26T13:03:00Z', 6.614167406914887],
      ['2024-06-26T13:04:00Z', 6.4622665720761026],
      ['2024-06-26T13:05:00Z', 6.314948327484245],
      ['2024-06-26T13:06:00Z', 6.350660773073089],
      ['2024-06-26T13:07:00Z', 6.500643687965708],
      ['2024-06-26T13:08:00Z', 6.4100332946103435],
      ['2024-06-26T13:09:00Z', 6.172414508835939],
      ['2024-06-26T13:10:00Z', 6.430952333179205],
      ['2024-06-26T13:11:00Z', 6.245005631950445],
      ['2024-06-26T13:12:00Z', 6.50899884637385],
      ['2024-06-26T13:13:00Z', 6.57805485463638],
      ['2024-06-26T13:14:00Z', 6.278405078350257],
      ['2024-06-26T13:15:00Z', 9.148946834825965],
      ['2024-06-26T13:16:00Z', 6.261265541865143],
      ['2024-06-26T13:17:00Z', 6.304451865792331],
      ['2024-06-26T13:18:00Z', 6.1722240088627816],
      ['2024-06-26T13:19:00Z', 6.458871308789023],
      ['2024-06-26T13:20:00Z', 6.268654760686003],
      ['2024-06-26T13:21:00Z', 6.288776465179613],
      ['2024-06-26T13:22:00Z', 6.2613949939893425],
      ['2024-06-26T13:23:00Z', 6.207047303921664],
      ['2024-06-26T13:24:00Z', 6.326771106520881],
      ['2024-06-26T13:25:00Z', 6.322221377144546],
      ['2024-06-26T13:26:00Z', 6.4149351506893115],
      ['2024-06-26T13:27:00Z', 6.341714744238308],
      ['2024-06-26T13:28:00Z', 6.339613260737345],
      ['2024-06-26T13:29:00Z', 6.240132358368459],
      ['2024-06-26T13:30:00Z', 6.385161310056087],
      ['2024-06-26T13:31:00Z', 6.462444327853276],
      ['2024-06-26T13:32:00Z', 6.565651513727846],
      ['2024-06-26T13:33:00Z', 6.314378500200715],
      ['2024-06-26T13:34:00Z', 6.46602225368876],
      ['2024-06-26T13:35:00Z', 6.501174690376441],
      ['2024-06-26T13:36:00Z', 6.516467301770429],
      ['2024-06-26T13:37:00Z', 6.379785919297277],
      ['2024-06-26T13:38:00Z', 6.421560624055823],
      ['2024-06-26T13:39:00Z', 6.390994785630493],
      ['2024-06-26T13:40:00Z', 6.380405194390173],
      ['2024-06-26T13:41:00Z', 6.285377815062783],
      ['2024-06-26T13:42:00Z', 6.387011020433299],
      ['2024-06-26T13:43:00Z', 6.329726156024788],
      ['2024-06-26T13:44:00Z', 6.392242269332005],
      ['2024-06-26T13:45:00Z', 6.437063354996444],
      ['2024-06-26T13:46:00Z', 6.536585353234288],
      ['2024-06-26T13:47:00Z', 6.4992427115236255],
      ['2024-06-26T13:48:00Z', 6.389139693964343],
      ['2024-06-26T13:49:00Z', 7.394929014510602],
      ['2024-06-26T13:50:00Z', 6.614206261420633],
      ['2024-06-26T13:51:00Z', 6.3166607595313256],
      ['2024-06-26T13:52:00Z', 6.496139620393298],
      ['2024-06-26T13:53:00Z', 6.3715400446352195],
      ['2024-06-26T13:54:00Z', 6.522357385933885],
      ['2024-06-26T13:55:00Z', 6.561876314961123],
      ['2024-06-26T13:56:00Z', 6.947779177989194],
      ['2024-06-26T13:57:00Z', 6.780807278441706],
      ['2024-06-26T13:58:00Z', 7.17264389231833],
      ['2024-06-26T13:59:00Z', 8.400599128800446],
      ['2024-06-26T14:00:00Z', 6.469607947402822],
      ['2024-06-26T14:01:00Z', 6.214844436651857],
      ['2024-06-26T14:02:00Z', 6.070677073644916],
      ['2024-06-26T14:03:00Z', 6.1717260870521065],
      ['2024-06-26T14:04:00Z', 6.150210284304657],
      ['2024-06-26T14:05:00Z', 6.3486082434082505],
      ['2024-06-26T14:06:00Z', 6.541702043518118],
      ['2024-06-26T14:07:00Z', 6.567944259727312],
      ['2024-06-26T14:08:00Z', 6.366572268756827],
      ['2024-06-26T14:09:00Z', 6.1739572833378356],
      ['2024-06-26T14:10:00Z', 6.286085140468086],
      ['2024-06-26T14:11:00Z', 6.391951704972829],
      ['2024-06-26T14:12:00Z', 6.678446770929141],
      ['2024-06-26T14:13:00Z', 6.676171380246101],
      ['2024-06-26T14:14:00Z', 6.417304820157464],
      ['2024-06-26T14:15:00Z', 6.3551688589810755],
      ['2024-06-26T14:16:00Z', 6.454551415446835],
      ['2024-06-26T14:17:00Z', 8.718721241718114],
      ['2024-06-26T14:18:00Z', 6.561784927287752],
      ['2024-06-26T14:19:00Z', 6.379031596888405],
      ['2024-06-26T14:20:00Z', 6.3927386015385785],
      ['2024-06-26T14:21:00Z', 6.4334988218875635],
      ['2024-06-26T14:22:00Z', 6.541946462470989],
      ['2024-06-26T14:23:00Z', 6.42485197264025],
      ['2024-06-26T14:24:00Z', 6.669797826915698],
      ['2024-06-26T14:25:00Z', 6.61312027840375],
      ['2024-06-26T14:26:00Z', 6.673115677872957],
      ['2024-06-26T14:27:00Z', 7.361376681830791],
      ['2024-06-26T14:28:00Z', 8.773926533443612],
      ['2024-06-26T14:29:00Z', 8.089933744851688],
      ['2024-06-26T14:30:00Z', 6.355271443316222],
      ['2024-06-26T14:31:00Z', 6.429933317240382],
      ['2024-06-26T14:32:00Z', 6.312803149713107],
      ['2024-06-26T14:33:00Z', 6.501774698880886],
      ['2024-06-26T14:34:00Z', 6.139055782790889],
      ['2024-06-26T14:35:00Z', 6.4041288082136925],
      ['2024-06-26T14:36:00Z', 6.366301928806137],
      ['2024-06-26T14:37:00Z', 6.3871510182430615],
      ['2024-06-26T14:38:00Z', 6.558812576430193],
      ['2024-06-26T14:39:00Z', 6.337028583761499],
      ['2024-06-26T14:40:00Z', 6.448177627388883],
      ['2024-06-26T14:41:00Z', 6.574081088801118],
      ['2024-06-26T14:42:00Z', 6.686840191120583],
      ['2024-06-26T14:43:00Z', 6.749275915299719],
      ['2024-06-26T14:44:00Z', 7.5725683407964635],
      ['2024-06-26T14:45:00Z', 9.986907851610503],
      ['2024-06-26T14:46:00Z', 8.360868971335027],
      ['2024-06-26T14:47:00Z', 6.953913775460725],
      ['2024-06-26T14:48:00Z', 6.698640528988949],
      ['2024-06-26T14:49:00Z', 6.837872875609473],
      ['2024-06-26T14:50:00Z', 6.800008999707359],
      ['2024-06-26T14:51:00Z', 9.825426865905335],
      ['2024-06-26T14:52:00Z', 6.817313385120194],
      ['2024-06-26T14:53:00Z', 6.707899265411001],
      ['2024-06-26T14:54:00Z', 7.027977963302044],
      ['2024-06-26T14:55:00Z', 7.292370433274278],
      ['2024-06-26T14:56:00Z', 10.68811598113605],
      ['2024-06-26T14:57:00Z', 9.432379317694862],
      ['2024-06-26T14:58:00Z', 9.557476662869181],
      ['2024-06-26T14:59:00Z', 9.299541236905801],
      ['2024-06-26T15:00:00Z', 9.208215153394857],
      ['2024-06-26T15:01:00Z', 9.510602561858601],
      ['2024-06-26T15:02:00Z', 9.198552388532258],
      ['2024-06-26T15:03:00Z', 8.455167489253261],
      ['2024-06-26T15:04:00Z', 6.69904698428154],
      ['2024-06-26T15:05:00Z', 6.93105282179671],
      ['2024-06-26T15:06:00Z', 6.428213301515357],
      ['2024-06-26T15:07:00Z', 9.889587575071637],
      ['2024-06-26T15:08:00Z', 7.149897520832772],
      ['2024-06-26T15:09:00Z', 6.775216789738716],
      ['2024-06-26T15:10:00Z', 7.10742219271827],
      ['2024-06-26T15:11:00Z', 6.971309910154533],
      ['2024-06-26T15:12:00Z', 8.6782767465587],
      ['2024-06-26T15:13:00Z', 10.252833234363871],
      ['2024-06-26T15:14:00Z', 9.405209425431472],
      ['2024-06-26T15:15:00Z', 9.334458252545257],
      ['2024-06-26T15:16:00Z', 9.46907409235599],
      ['2024-06-26T15:17:00Z', 9.292914830554329],
      ['2024-06-26T15:18:00Z', 9.485853221190036],
      ['2024-06-26T15:19:00Z', 9.324064912352553],
      ['2024-06-26T15:20:00Z', 9.423831780776581],
      ['2024-06-26T15:21:00Z', 9.542451509914356],
      ['2024-06-26T15:22:00Z', 6.994858541462686],
      ['2024-06-26T15:23:00Z', 6.93800104527957],
      ['2024-06-26T15:24:00Z', 6.9752420582712125],
      ['2024-06-26T15:25:00Z', 6.878246854227443],
      ['2024-06-26T15:26:00Z', 11.208063232084784],
      ['2024-06-26T15:27:00Z', 10.104461661924946],
      ['2024-06-26T15:28:00Z', 9.598384551870568],
      ['2024-06-26T15:29:00Z', 9.449691973376746],
      ['2024-06-26T15:30:00Z', 9.478442226917064],
      ['2024-06-26T15:31:00Z', 9.488956459774753],
      ['2024-06-26T15:32:00Z', 9.575403301653756],
      ['2024-06-26T15:33:00Z', 9.456717583624263],
      ['2024-06-26T15:34:00Z', 9.60834266881328],
      ['2024-06-26T15:35:00Z', 7.9507016426438595],
      ['2024-06-26T15:36:00Z', 5.1871917909907514],
      ['2024-06-26T15:37:00Z', 8.416252017520295],
      ['2024-06-26T15:38:00Z', 6.079555423904009],
      ['2024-06-26T15:39:00Z', 6.171400899050264],
      ['2024-06-26T15:40:00Z', 6.022367630371838],
      ['2024-06-26T15:41:00Z', 6.227077596651654],
      ['2024-06-26T15:42:00Z', 6.138567658621407],
      ['2024-06-26T15:43:00Z', 6.2891669135391455],
      ['2024-06-26T15:44:00Z', 7.475391132187557],
      ['2024-06-26T15:45:00Z', 7.366416662431619],
      ['2024-06-26T15:46:00Z', 7.482172835151422],
      ['2024-06-26T15:47:00Z', 9.702325187881366],
      ['2024-06-26T15:48:00Z', 8.026254201707212],
      ['2024-06-26T15:49:00Z', 8.13778942436376],
      ['2024-06-26T15:50:00Z', 8.12591468754732],
    ],
  },
};
